import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const ShAcIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <path fill="#012169" d="M0 0h640v480H0Z" />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-h)"
      d="M395.4 250.5s-18.2-20.1-32-22.9c-14-2.7-22.7-.3-26.8 3-4.2 3.5-18 14.4-19.5 22.6l18.1.9s3.8-8 15.8-7.5 13.9 4.8 13.1 5.8c-.7 1-1.1 4.3 3.7 6.6 4.8 2.2 6.9 7.4 6.9 7.4l8.5-4.4s1.8-2.8 2.6-3.3c.9-.4 3.5-.8 4.2-1.5.7-.8 3.4-2.6 3.4-2.6z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#d5ccc0"
      d="M527.1 277.7s12.3 9.4 13.2 12.7c1 3.3-6.8 8.2-6.8 8.2l.9 1.6 4.2-2c.6 0 1-.8 1.1-1 .1-.3.8-1.1 1.9-1.4 1-.3 1.2-.2 1.5-.5.2-.4 1.2-1.3 1.9-1.7.7-.3.7-.6.7-.8l1-1.4-.3-.6s-7-8-15.6-12l-3.7-1z"
    />
    <path
      fill="#fdf2e8"
      d="M503 292.9s8.6-14.5 15.4-15.6c0 0-3 0-5.7 2-3 2.2-9 7.4-11.8 13.5"
    />
    <path
      fill="#494037"
      d="M546 292.5c.4-.7-.3-1.5-1-1.6-.8 0-2.3-.1-2.3.4 0 .6-.3 3 .4 3s2.5-1.2 2.9-1.8m-5 1.7c0 .6-.6 1.2-1.2 1.1-.6 0-.8.5-.9 1 0 .3-1.9-.1-2-1.2-.2-1.2-.3-3.2.6-3.3.9-.2 3.5 1.9 3.5 2.4m-2.2 4c0-.6-1.6-.5-1.7-1-.1-.6-1.4-2.5-1.9-1.8-.5.6-.3 1.4-1 1.6-.7.3-1.5.8-1.3 1.1l1.3 2zm-7.1-2.5c.4.4 1 1.2 2 .1.8-1 1-1.4-.3-1.5-1.2-.1-3.2-.4-3 0 0 .4.8 1 1.3 1.4m-3.7-2.1c-.1-.8 1.7-.2 1.5.4s1 1.9.3 1.6c-.6-.2-1.6-.5-1.8-2m2.3-2.2c.2-1.2 1.5-.3 1.8.2s2.6 2 1 1.8c-1.7-.2-3.2-.3-2.8-2m.1-3c0 1.2.6 2 2.2 2 1.6-.1 3.3-1 3.2-2 0-1.1-1.5-2.8-2.5-3.3-1-.6-3.2-1.7-3.2-.6 0 1 .4 2.7.3 4zm7 .8c.3-.8 1.4-2.7 2-2.7a8 8 0 0 1 3.4 1.7c.6.7.2 1.5-.5 2.1s-2 1-3.1.9c-1-.1-2-1-1.8-2m.1-6.3s-.1 4-1.5 2.7c-1.4-1.2-3.4-1.4-3.5-3s.6-2.1 1.4-2.1 3.6 2.4 3.6 2.4m-11 4.6c0 1-.3 1.3.6 1.3 1-.1 3 0 2.8-.7-.3-.8-1.2-1.7-2-1.7-1 0-1.3.2-1.3 1zm1.7-4.8c.6.1 3.4.8 3.3-.2 0-1 .4-1.3.6-2 .3-.9-.1-1.3-.9-1.7-.7-.5-2.9-.8-3.4-1-.6 0-1.1 1.3-.3 2 .8.5 0 2.7.7 2.9m-4-2.5c.8.4 2.6 1.1 2.5.6 0-.5.2-1.6-.4-1.6-.7 0-3.3.5-2.2 1zm-2 8c.7-.3 2.5-1.2 2.1-1.7-.3-.4-4.2 0-4.2.7s.4 2 2.1 1m1.7.4c.5-.1 1.8-.4 1.8 0 0 .5-.1 1-1 .9-.8-.2-1.7-.7-.8-.9m.2-4c1.3-.3 2.7-1 0-1.3-2.6-.3-5.9-.6-5.3.3.5.9 2.1 2.5 3.3 2 1.1-.3.9-.6 2-1m-3-3.2c.9.3 2.1-.4 1.5-1.5-.5-1-2.6 1.2-1.6 1.5zm-3.2-4c1.2.4 2.3 1.5 2.1 2.4-.1.8-.3 2.8-2 2.7-1.5-.1-3.2.4-4-.3-.7-.7-2.3-1.8-1-3.2 1.4-1.3 5-1.6 5-1.6zm-5 8.5c-1.1-.6 1.7-2.2 2.3-2.5s1.9.4 2 .8c.2.4 1.3 1.2 2 1.4.7.3 0 1.4-.7 1.5-.6.1-2.2 2-2.9 1.4s-2.2-2.4-2.7-2.6m-.6-2.3c-.1-.7 0-1.5-1.5-.9-1.5.7-3.3 1.7-3.5 2.4-.3.7-1 2.8-.2 2.7.8 0 2.1 1.7 2.7.4.6-1.2 2.3-1.2 2.4-2.9s.3-.6.1-1.7m2.1 5c-.6-1-2-1-2.9-.2-.8.8-2.2 2-1.5 2 .7.1 2.6 1 3.7.3s1-1.5.7-2.1m-10.5 4.2c-.4-1.2 1.4-2.7 1.4-3.7.1-1 .8-1.5 1.8-.4 1 1 2 2.8 2.1 3.6 0 .8-.1 0-1.4.4-1.4.3-3.9.1-3.9.1"
    />
    <path fill="#494037" d="M504.2 290.1s.4.7.2 1.2c-.1.6-1 1-1 1z" />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M546.4 291.2s-10.6-11.7-18.6-13.3c-8.1-1.6-13.2-.2-15.6 1.7-2.4 2-10.4 8.3-11.3 13.2l10.5.4s2.2-4.6 9.2-4.3 8 2.8 7.6 3.4-.6 2.5 2.2 3.8c2.7 1.3 4 4.3 4 4.3"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-d)"
      d="M122 250.5s18.2-20.1 32-22.9c14-2.7 22.7-.3 26.8 3 4.2 3.5 17.9 14.4 19.5 22.6l-18.2.9s-3.7-8-15.7-7.5-14 4.8-13.2 5.8 1.2 4.3-3.6 6.6c-4.8 2.2-7 7.4-7 7.4l-8.4-4.4s-1.8-2.8-2.7-3.3c-.8-.4-3.5-.8-4.2-1.5-.6-.8-3.4-2.6-3.4-2.6z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#d5ccc0"
      d="M406.7 277.7s-12.3 9.4-13.2 12.7c-1 3.3 6.9 8.2 6.9 8.2l-1 1.6-4.2-2c-.6 0-1-.8-1.1-1-.1-.3-.8-1.1-1.9-1.4-1-.3-1.2-.2-1.5-.5a7.5 7.5 0 0 0-1.9-1.7c-.6-.3-.7-.6-.7-.8l-1-1.4.4-.6s6.9-8 15.5-12l3.7-1z"
    />
    <path
      fill="#fdf2e8"
      d="M430.8 292.9s-8.6-14.5-15.4-15.6c0 0 3 0 5.7 2 3.1 2.2 9 7.4 11.8 13.5"
    />
    <path
      fill="#494037"
      d="M387.9 292.5c-.5-.7.2-1.5 1-1.6.7 0 2.2-.1 2.2.4 0 .6.3 3-.4 3s-2.4-1.2-2.8-1.8m5 1.7c0 .6.5 1.2 1 1.1.7 0 1 .5 1 1 0 .3 1.9-.1 2-1.2.3-1.2.4-3.2-.6-3.3-.9-.2-3.4 1.9-3.4 2.4m2.1 4c0-.6 1.6-.5 1.7-1 .1-.6 1.4-2.5 1.9-1.8.5.6.3 1.4 1 1.6.7.3 1.5.8 1.3 1.1l-1.3 2zm7.1-2.5c-.4.4-1 1.2-1.9.1-1-1-1-1.4.2-1.5s3.2-.4 3 0c0 .4-.8 1-1.3 1.4m3.7-2.1c.1-.8-1.7-.2-1.5.4s-1 1.9-.3 1.6c.6-.2 1.6-.5 1.8-2m-2.2-2.2c-.3-1.2-1.6-.3-1.9.2s-2.6 2-1 1.8c1.7-.2 3.2-.3 2.9-2m-.2-3c.1 1.2-.5 2-2.2 2-1.6-.1-3.3-1-3.2-2 0-1.1 1.5-2.8 2.5-3.3 1-.6 3.2-1.7 3.3-.6 0 1-.5 2.7-.4 4zm-7 .8c-.2-.8-1.4-2.7-2-2.7a8 8 0 0 0-3.4 1.7c-.6.7-.2 1.5.5 2.1s2 1 3.1.9c1-.1 2-1 1.8-2m-.1-6.3s.1 4 1.5 2.7c1.4-1.2 3.4-1.4 3.5-3s-.5-2.1-1.4-2.1c-.8 0-3.6 2.4-3.6 2.4m11 4.6c0 1 .3 1.3-.6 1.3-1-.1-3 0-2.7-.7.3-.8 1-1.7 2-1.7.8 0 1.2.2 1.3 1zm-1.7-4.8c-.6.1-3.4.8-3.3-.2 0-1-.3-1.3-.6-2-.3-.9.2-1.3.9-1.7.7-.5 2.9-.8 3.5-1 .5 0 1 1.3.2 2-.8.5 0 2.7-.7 2.9m4.1-2.5c-.8.4-2.7 1.1-2.6.6 0-.5-.2-1.6.5-1.6.6 0 3.2.5 2.1 1m1.9 8c-.7-.3-2.5-1.2-2.1-1.7.3-.4 4.2 0 4.2.7s-.4 2-2.1 1m-1.6.4c-.6-.1-1.9-.4-1.9 0 0 .5.1 1 1 .9.8-.2 1.7-.7.9-.9m-.3-4c-1.3-.3-2.6-1 0-1.3s5.9-.6 5.3.3c-.5.9-2.1 2.5-3.3 2-1-.3-.8-.6-2-1m3-3.2c-.9.3-2-.4-1.5-1.5.5-1 2.6 1.2 1.6 1.5zm3.2-4c-1.2.4-2.2 1.5-2 2.4 0 .8.3 2.8 1.9 2.7s3.2.4 4-.3c.7-.7 2.3-1.8 1-3.2-1.4-1.3-5-1.6-5-1.6zm5 8.5c1.1-.6-1.7-2.2-2.3-2.5s-1.9.4-2 .8c-.2.4-1.3 1.2-2 1.4-.6.3 0 1.4.7 1.5.6.1 2.2 2 3 1.4.6-.6 2-2.4 2.6-2.6m.6-2.3c.1-.7 0-1.5 1.5-.9 1.5.7 3.3 1.7 3.5 2.4.3.7 1 2.8.2 2.7-.8 0-2.1 1.7-2.7.4-.6-1.2-2.3-1.2-2.4-2.9s-.3-.6-.1-1.7m-2 5c.5-1 2-1 2.8-.2.9.8 2.2 2 1.5 2-.7.1-2.6 1-3.7.3-1-.7-1-1.5-.7-2.1zm10.4 4.2c.4-1.2-1.4-2.7-1.4-3.7s-.8-1.5-1.8-.4c-.9 1-2 2.8-2 3.6-.1.8 0 0 1.4.4 1.3.3 3.8.1 3.8.1"
    />
    <path fill="#494037" d="M429.6 290.1s-.3.7-.2 1.2c.1.6 1.1 1 1.1 1z" />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M387.4 291.2s10.6-11.7 18.7-13.3c8-1.6 13.1-.2 15.5 1.7 2.4 2 10.4 8.3 11.3 13.2l-10.5.4s-2.2-4.6-9.2-4.3-8 2.8-7.6 3.4.6 2.5-2.1 3.8a8.8 8.8 0 0 0-4 4.3"
    />
    <path
      fill="#fff"
      d="M410.2 291.7s.7 60.8 1.6 66.4c1 5.6 4.4 40.5 54.6 61.5 0 0 38.8-16.5 48.7-39.4 10-22.9 8-66 8-66v-23.4z"
    />
    <path
      fill="#1b81b6"
      d="M522.8 311.5s-8.2-5.2-16.2-5.2-13.4 9.3-20 9.3-10-7.2-20.2-7.2c-10 0-11.4 7.2-18 7.2-6.5 0-14-9.3-20.9-9.3-7 0-15.9 6-15.9 6l.1 21s9-6 15.9-6c7 0 14.3 9.3 21 9.3 6.5 0 7.8-7.2 18-7.2 10 0 13.5 7.2 20.1 7.2s12-9.3 20-9.3 16.3 5.1 16.3 5.1l-.1-21m-100.7 74a19 19 0 0 1 5.7-1c7 0 14.3 9.3 21 9.3 6.5 0 7.8-7.2 18-7.2 10 0 13.5 7.2 20.1 7.2s12-9.3 20-9.3c1.7 0 3.5.3 5.2.7 6 1.3-34.9 34.5-45.3 34.5-10.3 0-50-32.4-44.7-34.2m97.6-18a32.3 32.3 0 0 0-13-3.4c-7.9 0-13.3 9.3-19.9 9.3s-10-7.2-20.2-7.2c-10.1 0-11.4 7.2-18 7.2s-13.9-9.2-20.9-9.2a31 31 0 0 0-13.4 4.6c-1.5.9-2.5-16-2.5-16s9-6 15.9-6c7 0 14.3 9.3 21 9.3 6.5 0 7.8-7.3 18-7.3 10 0 13.5 7.3 20.1 7.3s12-9.4 20-9.4 16.3 5.2 16.3 5.2-1.2 16.6-3.3 15.7"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-i)"
      d="m643.2-61.7-1.3 1.6c.4-.5.9-1 1.2-1.6m-88.7-17.2 1 3zm50.2-50.6-49.2 53.7a55 55 0 0 0 8.6 15.4l39-42 .5.5 1.4-1.2 38.3 41.4c4-5.4 6.7-11 8.6-17z"
      transform="translate(-136.2 449.1)"
    />
    <path d="m415.5 372.3.4.4 51-54.8 50.7 54.8.4-.4-.5-.3v.2c-.3.6-1.6 3.8-3.6 7.5-1.9 3.7-4.5 8-7.3 11.2l.4.4.4-.4-40.5-44.1-41.2 44 .4.5.5-.4v-.1a94 94 0 0 1-4.9-7 49 49 0 0 1-5.7-11.7zl.4.4zl-.6.1a52 52 0 0 0 6.3 12.8c2.4 3.7 4.5 6.4 4.5 6.4l.4.5 40.8-43.6 39.9 43.6.5-.5c3.2-3.4 6-8.2 8-12.1 2-4 3.2-7 3.2-7l.1-.4-51.8-55.9-52 55.9v.3zm51 45.8h.9l-.5-.2zM411 290.8l-.9.9h1z" />
    <path d="m470.3 289.9-.8 1.8h53a5396 5396 0 0 1-1 37.5l-.6 19.2-.1 2.4v2.4a63 63 0 0 1-.4 4.7 61 61 0 0 1-1.9 9.2c-1.6 6-4.3 11.8-7.7 17a73.3 73.3 0 0 1-12.2 14.4c-4.7 4.3-9.8 8-15.2 11.3a108 108 0 0 1-8.3 4.5 87 87 0 0 1-8.2 3.6l.5.2h-1l.5-.2a87 87 0 0 1-8.2-3.6 108 108 0 0 1-8.3-4.5c-5.4-3.3-10.5-7-15.2-11.3-4.6-4.2-8.8-9-12.2-14.3s-6.1-11-7.8-17a61 61 0 0 1-1.8-9.3 64 64 0 0 1-.4-4.7v-2.4l-.2-2.4-.7-19.2a5591 5591 0 0 1-1-37.5h-.8l.8-.9v.9h37.3l-1-1.8h-38v1a6280 6280 0 0 0 1 57.6l.2 2.4v2.4a67 67 0 0 0 .4 4.9 63 63 0 0 0 1.7 9.6 64.4 64.4 0 0 0 8 17.9 77.7 77.7 0 0 0 12.5 15c4.8 4.5 10 8.4 15.5 11.8a111 111 0 0 0 8.5 4.8 103 103 0 0 0 9 4l.7.2.6-.2a70 70 0 0 0 9-4 111 111 0 0 0 8.6-4.8 99.7 99.7 0 0 0 15.5-11.8 76 76 0 0 0 12.6-15 64.3 64.3 0 0 0 7.9-17.9 63 63 0 0 0 1.8-9.6 66 66 0 0 0 .3-5v-2.3l.1-2.4c.3-6.4.4-12.8.5-19.2l.7-38.5v-1z" />
    <path
      fill="#979696"
      d="M516.8 366.1a64 64 0 0 1-.9 3l1.5 1.6a58 58 0 0 0 1.1-3.6l.1-.3a44 44 0 0 0-1.9-.7m2.7-35.5v.5c0 6.5-.1 12.6-.5 18.4l2 1v-2.1l.6-16.8a44 44 0 0 0-2.1-1m1.3-38.8h-.2c0 .1-.4 7.2-.7 18a42 42 0 0 1 2.3 1.2 1314 1314 0 0 1 .5-19.2z"
    />
    <path
      fill="#2a647e"
      d="M519.8 309.8c-.2 6-.4 13-.4 20.8l2.1 1v-2.4a3729 3729 0 0 0 .6-18.2 42 42 0 0 0-2.3-1.2m-.9 39.7c-.3 5.8-1 11.3-2.2 16.6l2 .7a61 61 0 0 0 1.6-9 63 63 0 0 0 .4-4.6v-2.4l.1-.4a45 45 0 0 0-1.9-.9m-14 40.4a111.6 111.6 0 0 1-38 26.6v1.4c2.7-1 5.5-2.3 8.2-3.6a108 108 0 0 0 8.3-4.5c5.4-3.3 10.5-7 15.1-11.3a79 79 0 0 0 7.3-7.6l-.8-1"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-j)"
      d="M651.8-78.7A58 58 0 0 1 642-60l.8 1a69 69 0 0 0 4.2-6 62.7 62.7 0 0 0 6.2-12.3z"
      transform="translate(-136.2 449.1)"
    />
    <path d="m505.8 389.1-.3.1-.1.3-.4.4.8 1 .8-1zm10.2-19.9c0 .5-.2.9-.3 1.3l1.4 1.5.4-1.2zM467 418v.2h.5z" />
    <path d="m521.8 320.1-.2 9v2.5l-.7 16.8v2l-.1.4v2.4a63 63 0 0 1-.5 4.7 61 61 0 0 1-1.7 9v.2a59 59 0 0 1-1.6 4.8 62.6 62.6 0 0 1-6.2 12.3 69 69 0 0 1-5 6.7 79 79 0 0 1-7.3 7.6 99 99 0 0 1-15.1 11.3 108 108 0 0 1-8.3 4.5 87 87 0 0 1-8.2 3.6l.5.2h-.5v.6c8-3.5 13.3-6 18.9-9.5 35.5-22.5 35.6-45.8 35.9-78.1zm1-28.5-2 .2h1.8l-.3 11.3a744 744 0 0 1 .5-11.5" />
    <path fill="#fff" d="m417.2 367.1-1.7.9 1.7-1" />
    <path
      fill="#00b5d2"
      d="m414.8 350.8-1.8 1.1a58 58 0 0 0 .4 6 61 61 0 0 0 1.8 9.2l.3.9a49 49 0 0 1 1.7-1c-1.4-5.2-2-10.5-2.4-16.2"
    />
    <path d="m413 351.9-.3.2c.4 5.6 1.1 11 2.4 16l.4-.1a61 61 0 0 1-2.1-10.1 64 64 0 0 1-.4-4.7z" />
    <path
      fill="#00b5d2"
      d="m414 311-2.3 1.4.3 11.4.1 5.4.2 3.7 2-1.2v-.6c0-7.4-.1-14.3-.3-20.1"
    />
    <path d="M412 323.8v9.2l.3-.1-.2-3.7zm6.6 45.2-.6.6z" />
    <path
      fill="#00b5d2"
      d="m428.5 389.6-.9 1a79 79 0 0 0 7.6 8c4.7 4.2 9.8 8 15.2 11.2a107 107 0 0 0 8.3 4.5 87 87 0 0 0 8.2 3.6l-.5.2.5-.2v-1.3a112.2 112.2 0 0 1-38.4-27"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-l)"
      d="m603-131.2-48.6 52.3 1 3-1-3-1.5 1.6a62.7 62.7 0 0 0 6.3 12.4 69 69 0 0 0 3.9 5.4l.9-1a55 55 0 0 1-8.6-15.3l49.2-53.7z"
      transform="translate(-136.2 449.1)"
    />
    <path d="m427.8 388.7-1 1 .8.8.9-1zm-9.8-19-1.4 1.6.1.5 1.5-1.6-.2-.6m48.8-52.5L418.5 369l-.6.6.2.6 48.7-52.3 1.5 1.7.4-.4zm0 100.8-.5.2h.5z" />
    <path d="m416.6 371.3-.5.5c4.3 13.5 13.2 25.6 32 37.4 5.5 3.5 10.7 6 18.8 9.5v-.6h-.5l.5-.2c-2.7-1-5.5-2.3-8.2-3.6a108 108 0 0 1-8.3-4.5c-5.4-3.3-10.5-7-15.2-11.3a79 79 0 0 1-7.6-8 69 69 0 0 1-4.6-6.3 62.6 62.6 0 0 1-6.3-12.4z" />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-m)"
      d="m604.9-103.1-1.4 1.2L642-60l1.2-1.6z"
      transform="translate(-136.2 449.1)"
    />
    <path d="m467.3 347.2-.3.3 38.4 42c0-.1 0-.2.2-.3l.1-.2z" />
    <path fill="#405d66" d="m505.6 389.2-.2.3z" />
    <path fill="#24ab5f" d="m505.6 389.2-.2.3z" />
    <g transform="translate(316.5 145.5)scale(.58162)">
      <path fill="#405d66" d="M327.5 416v.1z" />
      <path fill="#24ab5f" d="M327.5 416v.1z" />
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="m248.3 298.1-20.7-7.2a13 13 0 0 0-9.4 1.5c-2.2 1.6-6.4 1.5-6 .6.6-1 3-2.6 3-3.8 0-1.3 7.4-3.6 7.4-3.6l-6.1 1.2c-2.6.7-2.5-.8-5.2-.6-2.6.2-6 3.8-7.2 5.6a3.6 3.6 0 0 1-5.5.6c-1.6-1.6-6.9-2.4-9.4-1.5-2.6 1-19 6.5-20.7 7.2-1.8.8-1.3 2.5 5 2.6 6.1.1 12.8-.6 14.7-1.9s5 1.4 6.9 3c1.9 1.7 4.7 1.8 6.3 0 1.7-1.7 2.5-1 2.6 1.3s2.3 3.2.5 3.9-6.1 4.2-5.3 5c.4.6 1 .7 1.4.7 0 7 7.8 5.7 7.8 5.7s7.8 1.3 7.8-5.7c.4 0 1-.1 1.3-.7.8-.8-3.4-4.3-5.2-5-1.9-.7.3-1.6.4-3.9s1-3 2.6-1.2c1.6 1.7 4.5 1.6 6.4 0 1.9-1.7 5-4.4 6.8-3.1 2 1.3 8.6 2 14.8 2 6.2-.2 6.8-1.9 5-2.7z"
      />
      <circle cx={210.7} cy={288.5} r={0.5} />
      <path
        fill="#fed468"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M206.3 303.4s-.6 2.7 0 4.7c.2.6-1.5 2-.3 2.2 1.2.3 2.6.1 2-.8-.8-1-1-4.2-.9-5.5m3.6-.6s.6 2.7 0 4.7c-.2.6 1.4 2 .3 2.2-1.2.3-2.6.1-2-.8.7-1 .9-4.2.9-5.5"
      />
      <path
        fill="#b5b5b6"
        d="M189.3 293.3c.3-1.4 4-.9 5 0a17 17 0 0 0 6.3 2.3c1.4 0 .8 1.8-1.3 1.4-2-.4-4.7-2.7-6-2.8-1.2 0-4.5 1.6-4-1zm13.8 7.6c-1.7.3 2.4-4.9 2-2.5-.3 2.4-.4 3.7-.2 5 .3 1.2-.4 2.6-1-.7-.5-3.3-.2-1.9-.8-1.8m21.8-8.3c-.3-1.4-3.7.6-4.7 1.4-1 .9-4.9 2.3-6.3 2.3s-1 2.4 1.2 2c2-.4 5-2.7 6-3.3 2.8-1.7 4.3.1 3.8-2.4m-11.6 8.3c1.8.3-2.4-4.9-2-2.5s.5 3.7.3 5c-.3 1.2.3 2.6.9-.7.5-3.3.2-1.9.8-1.8m-6.8 10.4c1-1.4 3.1 1 3.6 0 .6-1 1.7-1.2 3-.6 1.4.7 1.7 1.8.3 1.7-2.6-.2-1.4 1.4-4 1.2-2.5-.2-4.4-.4-3-2.3zm-35-14.3s-1.7 3.2 2 2.1c3.6-1 6.2.4 9.5-.8 3.3-1.1 8-2.3 8.7-.5.6 1.8.4 1.9-1.2.9s-3.3.3-4 .7a82 82 0 0 1-13 1.3c-2.9-.2-7.2-1-5.4-2.4 1.8-1.3 3.3-1.3 3.3-1.3zm73.6 0s1.7 3.2-2 2.1c-3.6-1-6.2.4-9.5-.8-3.3-1.1-8-2.3-8.7-.5-.6 1.8-.4 1.9 1.2.9s3.3.3 4 .7a82 82 0 0 0 13 1.3c2.9-.2 7.2-1 5.4-2.4-1.8-1.3-3.4-1.3-3.4-1.3"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="m348.3 298.1-20.7-7.2a13 13 0 0 0-9.4 1.5c-2.2 1.6-6.4 1.5-6 .6.6-1 3-2.6 3-3.8 0-1.3 7.4-3.6 7.4-3.6l-6.1 1.2c-2.6.7-2.5-.8-5.2-.6-2.6.2-6 3.8-7.2 5.6a3.6 3.6 0 0 1-5.5.6c-1.6-1.6-6.9-2.4-9.4-1.5-2.6 1-19 6.5-20.7 7.2-1.8.8-1.3 2.5 5 2.6 6.1.1 12.8-.6 14.7-1.9s5 1.4 6.9 3c1.9 1.7 4.7 1.8 6.3 0 1.7-1.7 2.5-1 2.6 1.3s2.3 3.2.5 3.9-6.1 4.2-5.3 5c.4.6 1 .7 1.4.7 0 7 7.8 5.7 7.8 5.7s7.8 1.3 7.8-5.7c.4 0 1-.1 1.3-.7.8-.8-3.4-4.3-5.2-5-1.9-.7.3-1.6.4-3.9s1-3 2.6-1.2c1.6 1.7 4.5 1.6 6.4 0 1.9-1.7 5-4.4 6.8-3.1 2 1.3 8.6 2 14.8 2 6.2-.2 6.8-1.9 5-2.7z"
      />
      <circle cx={310.7} cy={288.5} r={0.5} />
      <path
        fill="#fed468"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M306.3 303.4s-.6 2.7 0 4.7c.2.6-1.5 2-.3 2.2 1.2.3 2.6.1 2-.8-.7-1-1-4.2-.9-5.5m3.6-.6s.6 2.7 0 4.7c-.2.6 1.4 2 .3 2.2-1.2.3-2.6.1-2-.8.7-1 .9-4.2.9-5.5"
      />
      <path
        fill="#b5b5b6"
        d="M289.3 293.3c.3-1.4 4-.9 5 0a17 17 0 0 0 6.3 2.3c1.4 0 .8 1.8-1.3 1.4-2-.4-4.7-2.7-6-2.8-1.2 0-4.5 1.6-4-1zm13.8 7.6c-1.7.3 2.4-4.9 2-2.5-.3 2.4-.4 3.7-.2 5 .3 1.2-.4 2.6-1-.7-.5-3.3-.1-1.9-.8-1.8m21.8-8.3c-.3-1.4-3.6.6-4.7 1.4-1 .9-4.9 2.3-6.3 2.3s-.9 2.4 1.2 2c2-.4 5-2.7 6-3.3 2.8-1.7 4.3.1 3.8-2.4m-11.6 8.3c1.8.3-2.4-4.9-2-2.5s.5 3.7.3 5c-.3 1.2.3 2.6.9-.7.5-3.3.2-1.9.8-1.8m-6.8 10.4c1-1.4 3.1 1 3.6 0 .6-1 1.7-1.2 3-.6 1.4.7 1.7 1.8.3 1.7-2.6-.2-1.4 1.4-4 1.2-2.5-.2-4.4-.4-3-2.3zm-35-14.3s-1.7 3.2 2 2.1c3.6-1 6.2.4 9.5-.8 3.3-1.1 8-2.3 8.7-.5.6 1.8.4 1.9-1.2.9s-3.3.3-4 .7a82 82 0 0 1-13 1.3c-2.9-.2-7.2-1-5.4-2.4 1.8-1.3 3.3-1.3 3.3-1.3zm73.6 0s1.7 3.2-2 2.1c-3.6-1-6.2.4-9.5-.8-3.3-1.1-8-2.3-8.7-.5-.6 1.8-.4 1.9 1.2.9s3.3.3 4 .7a82 82 0 0 0 13 1.3c2.9-.2 7.2-1 5.4-2.4-1.8-1.3-3.4-1.3-3.4-1.3"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M311 433.1c-2.3-1-23.7-8.2-27-9.4-3.5-1.2-10 .1-12.5 2-2.8 2-8.4 2-7.7.7s3.8-3.4 3.8-5 9.7-4.8 9.7-4.8l-8 1.7c-3.3.8-3.2-1-6.7-.8s-8 5-9.5 7.4a4.8 4.8 0 0 1-7.3.7c-2-2.1-9-3.1-12.3-2-3.4 1.3-24.8 8.5-27.2 9.5s-1.7 3.3 6.5 3.4 17-.8 19.4-2.5c2.5-1.8 6.5 1.9 9 4s6.3 2.3 8.4 0 3.2-1.3 3.4 1.6c0 3 3 4.3.6 5.1-2.4 1-8 5.6-6.9 6.7.5.7 1.1.9 1.8.8 0 9.2 10.2 7.6 10.2 7.6s10.2 1.6 10.2-7.6c.6 0 1.3-.1 1.8-.8 1-1.1-4.5-5.8-7-6.6-2.3-1 .6-2.2.7-5.2s1.3-3.9 3.4-1.6 5.9 2.1 8.3 0c2.5-2.1 6.6-5.8 9-4a47.9 47.9 0 0 0 19.5 2.5c8.1-.1 8.8-2.4 6.5-3.4z"
      />
      <circle cx={261.8} cy={420.5} r={0.6} />
      <path
        fill="#fed468"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={0.8}
        d="M256 440s-.9 3.6 0 6.2c.2.8-2 2.6-.4 3 1.5.3 3.4 0 2.5-1.2a18 18 0 0 1-1-7.1m4.7-.9s.7 3.6 0 6.2c-.3.8 1.8 2.6.3 3-1.5.3-3.4 0-2.5-1.2a18 18 0 0 0 1-7.1"
      />
      <path
        fill="#b5b5b6"
        d="M233.7 426.8c.4-2 5.1-1.2 6.5 0 1.4 1 6.4 3 8.3 3 1.8 0 1 2.3-1.7 1.8s-6.2-3.5-7.8-3.6c-1.7-.1-6 2-5.3-1.3zm18.1 10c-2.3.3 3.2-6.4 2.7-3.3s-.7 4.9-.3 6.5c.3 1.6-.6 3.4-1.3-.9s-.3-2.5-1.1-2.3m28.5-11c-.4-1.8-4.7.8-6 2-1.5 1-6.5 3-8.3 3-2 0-1.2 3 1.5 2.5 2.8-.5 6.6-3.5 8-4.3 3.6-2.2 5.5.2 4.8-3.1zm-15 11c2.2.3-3.3-6.4-2.8-3.3s.7 4.9.4 6.5c-.4 1.6.5 3.4 1.2-.9s.3-2.5 1.1-2.3zm-9.1 13.6c1.4-1.8 4.1 1.2 4.8 0s2.1-1.6 3.9-.7c1.8.8 2.2 2.2.4 2.1-3.4-.2-1.9 1.9-5.2 1.6-3.3-.2-5.8-.6-4-3zm-46-18.7s-2.2 4.2 2.6 2.7c4.8-1.4 8.3.5 12.6-1 4.4-1.6 10.6-3.1 11.4-.7.7 2.4.6 2.4-1.5 1.2-2.1-1.3-4.4.3-5.4.8s-13.4 2-17.1 1.8-9.4-1.3-7-3.1 4.4-1.7 4.4-1.7m96.8 0s2.2 4.2-2.6 2.7c-4.8-1.4-8.3.5-12.6-1-4.4-1.6-10.6-3.1-11.4-.7s-.6 2.4 1.5 1.2c2.1-1.3 4.4.3 5.4.8s13.4 2 17 1.8c3.7-.2 9.4-1.3 7-3.1-2.3-1.8-4.3-1.7-4.3-1.7"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-n)"
        d="m204 137.3 13 29.7h83.6l12.8-29.7-54.6-126.5Z"
      />
      <path
        fill="#83c453"
        d="m204 137.3 13 29.7h2.6l-13-29.8 52.2-121.7L311 137.2 298 167h2.6l12.8-29.7-54.6-126.5Z"
      />
    </g>
    <path d="m466.9 151.7 31.8 73.6-7.4 17.3h-48.7l-7.4-17.3zm0-3-1 2.6-31.8 73.5-.2.5.2.5 7.5 17.2.3.7H492l.3-.7 7.5-17.2.2-.5-.2-.5-31.8-73.5-1-2.5z" />
    <g transform="translate(316.5 145.5)scale(.58162)">
      <path
        fill="#fff"
        d="M445.7 110.8c21.5 8.8 19.6 23.8 10.3 26.8-8 1-13.9 1-18.8.3v-.3c16.3-3.5 8.5-26.8 8.5-26.8m-80.5 75.5c-.3-.7-4.9-12.5-16.5-29-15.1-21.4-16-28.6-16-28.6l4.7 2s-.9-1.7-1-4.3c-.4-4 .8-9.8 8.3-15.1 3.4-2.4 9-1.6 9-1.6s-1 3-1 6.9c0 3.8.1 8.8 8 23.5l3 5.7.2.1c-3.2 2.8-6.2 4.2-6.2 4.2a9.6 9.6 0 0 0 9 1.6c5.5 12 10 25 10 33.5 0 11.2-7.5 31.3-35.6 35 11.1-1.6 17.2-10.1 17.6-20.9 1.2-11.5-9.5-17.1-21.3-15.4 0 0 4.8-6 13.8-6 8.7 0 13.7 7.8 14 8.4M161.7 205c4 1.3 8.5 2 13 2a52 52 0 0 0 30.1-12l22.3 28.8c-7.7 3.8-10.7 17.6-10.7 17.6a19.1 19.1 0 0 1-3.5-19.7l-.4 1c-2.5 5.5-12.3 7.1-12.3 7.1.6-6.6 4.3-18 4.3-18s-4 4-12.9 9-30.5 3.4-42.3-10.4c-9.2-10.7-8.5-25.1-6.4-36.7l-.2 2.9c0 16.1 8.2 24.8 19 28.4m-8-104.4c6.2.7 12 3.8 12.8 13.3-6.3-1.2-17.5 8.7-17.5 20.3 0 5.3 2.3 9.7 4.8 13 3.1 3.9 6.4 6.1 6.4 6.1a21.7 21.7 0 0 1-17.5-11.7c.2.5 1.7 6.5-2 13.8-11 20.6-26.5 18.2-26.5 18.2a52.3 52.3 0 0 0 11.6-18.5c1.5-4 8.8-18 11-22 2-4-.3-7.3-3.2-4.5 0 0-20.8 16.8-30.4 19.8-3 1-7.6 1.3-12.5 0a25.5 25.5 0 0 1-14-10.1c22.7-.6 57.5-23.7 58.6-24.4-.7.3-13.2 4.9-24.9 1.3-12-3.6-27.7 6.3-27.7 6.3s1.7-7 7-10.2c5.4-3.3 19-3.7 19-3.7s-3-1-6-5.5c-3-4.4 2-12.2 2-12.2a33 33 0 0 0 11 12.2c4.4 2.9 18.4-.5 24-.7 2.6 0 8.5-1.4 14-.8"
      />
      <path
        fill="#dedede"
        d="m209.7 201.5-2.7 7.2 4.8-4.8zm8 10.6-5 10 7-7.6zm-70.3-89s-4.9 4.7-3.9 13c1 8.4 3 2.4 2.7 0-.1-.7-1-2.4-.6-4.4.7-4.3 2.9-10 1.8-8.5zm6.1-9.3s-10.8 9.2-16 9.9c-5.1.7 1 2.2 2.7 2.8s3.3-.9 3.3-1.7c0-.9 12.8-11.8 10-11m-17-6.8s4.9-3 13.7-1.8c8.9 1.2 16.4 2.4 8.8 2.8s-25 6.7-25 6.7 14.6-6.2 7-6.3c-7.8-.2-4.6-1.4-4.6-1.4z"
      />
      <path
        fill="#2b5f31"
        d="M170 109.4s-1 17.3-11 32.1c-10 14.9-14.4 27.7-14.4 35 0 7.4 17 24.6 17 24.6s4-18 10.7-19.1c6.7-1-1.7-4.6-8.6 0-7 4.6-10.2 5.7-8-.6s12.8-19.1 18-26.3c5.3-7.1 16-22.3 10.7-20.5s-5.2 2.6-4.6-1c.6-3.7 2-16.8-3.6-22.5-5.6-5.8-5.8-6-6.3-1.7z"
      />
      <path
        fill="#294527"
        d="m157.9 173.7-7.1-4.8c-2.7-1.7-2-6.3 3.5-2.8 5.5 3.6 6 4.6 6 4.6m-13.6-1.8s7.7 5.2 9 7.7c0 0-3.3 9.2-2.6 12.5.6 3.3 6.8-7.3 11-7.1 4.1.2-2.3 4.6-2.5 8.7s.2 13.2.2 13.2-5.2 0-10.5-5c-5.4-4.8-6.2-20.6-4.6-30m23-50.3s4.9 4 5.4 10.6c.5 6.5-3.7-3.8-5.3 1.5-1.7 5.4 6 4.4 2.5 7-3.6 2.5-7.6-5-7.6-5s5-9 5-14.1"
      />
      <path
        fill="#172716"
        d="M169.8 120s5.6 5.4 6.4 9c.9 3.4.5 8-1.6 3.7a35.9 35.9 0 0 0-6.7-8.4zm-18.5 79s-2-8.1-1-15.7-2.7-10.2-2.8-3.4c0 6.8-.8 15-.8 15z"
      />
      <path
        fill="#294527"
        d="M78.1 113.9s-5.5 10.3-4.7 15.2c1.8 10.7 12 17 12 17S59.2 140 58.7 128s19.4-14 19.4-14"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M301.2 96s3.8-1.3 5.2-.7c1.5.6 3.7 1.7 5.3.7l2.9-11.7s-4.4-1.7-7.4-.8c-3 .8-4.1-1.3-4.1-1.3"
      />
      <path
        fill="#2b5f31"
        d="M370.5 114.2s6.6 26-9.7 33.7c0 0-4.2 4 2.8 4.3 7.1.2 13.1-10.5 13.1-10.5l2.4 9.4 4.2-3.2-4.2-27z"
      />
      <path
        fill="#294527"
        d="M456 137.6s-23.5 5.8-54.4-13.9c-17.3-11.6-15.6-12.9-15.6-12.9s-13.8-9.2-17-3.6c-3.3 5.6 8.7 13 11.4 26.2 2.6 13.3 4.5-.7 4.5-.7l-2.2-4.4s26.7 20.5 35.9 22.6c9.3 2.2 36.8-14.7 37.4-13.3"
      />
      <path
        fill="#294527"
        d="M373.7 105.8s9.4 8.7 21.4 12.4c7.1.9 13.6-.4 20.8 0s16.3-1 19.6 1.7c0 0-10-13-25.3-12.7s-36.5-1.5-36.5-1.5z"
      />
      <path
        fill="#2b5f31"
        d="M423.1 118.6s-2.3-9.7-19-10.1c-16.5-.4-28-1.3-5.7-3.6 17.4-5.9 10-13.7 10-13.7s12 .3 10.8 8.2c-1.1 8-3.4 8-3.4 8s15.8 2 22.4 14.2c0 0-4.4-5.1-15-3z"
      />
      <path
        fill="#172716"
        d="M412.4 109.9s5.2 1.3 4.7 4-2.7 1.8-3.9.8c-1.1-1-3.5-4.2-.8-4.8"
      />
      <path
        fill="#294527"
        d="M346.2 110.4s12.9-4.3 19.5 2.4c8.3 8.2-2.1-8.5 13.4-6.3s-16-5.8-26.9-2.1c-10.8 3.7-14.8 13.8-14.8 13.8s6-7 8.8-7.8"
      />
      <path
        fill="#2b5f31"
        d="M454.8 138.3s-6 1-10 3c-4.1 2-19 6-25.2 3s-4.5-4.5-2.7-5.7-.5-3.2-3-1.3c-2.3 2-6.7 1.3-4.3-.8 2.3-2.1 1.1-4.4-.7-3-1.8 1.6-5.1-5-7.3-3.8s-2 4.4-5.6 3.9-19-19.7-16.4 1c2.7 20.8-1.7 13 1.2 18.6s7.3 13.2 16.8 13.9c.8.2-2.3-2.2-5.4-12.5l-4.1-13.4-3.7-9.3-2-4.5 11 8.5s13 10.2 18.3 12.3 11.8 4 14.8 4c2.9-.1 28.3-14 28.3-14z"
      />
      <path
        fill="#2b5f31"
        d="m399.9 124.6-7.8 3.6c-1.5.9 2.1 6.2 4.5 3.5l5.6-5.6 2 .3-6.3 6c-1.2 1.5-.2 1.6 2 3 2.2 1.3 16.8 13.3 31.5 10.5 0 0-2.2 4.3.5 4.4L427 152s-8.6.7-19.5-6.2c-11-7-25.2-18.5-25.2-18.5l11.5-8.5z"
      />
      <path
        fill="#294527"
        d="M431.9 150.3s-19.2-2.4-33.7-13c-14.4-10.6-19.1-15.6-19.1-15.6s8 17 5 17.8c-3.6 1-6.4 4.1-2.2 4.4 4 .2 2 3 .3 3-1.6 0-5 1.5-1.8 1.5 3 0-3.4 3.9 0 11.2 3.3 7.3 15.2 12 22.5 13l-4.5-5.3s-6.8-.5-11.8-6.5c-2.6-2.8 6 4.7 4.1-3.7-.6-4.7-3.9-7.7-5.8-7.7-1.8 0 2-2.5 5.4-.4l-1.3-4.7s-4.6.8-3.3-.9c1.4-1.7 2.6-1.4 2.6-1.4l-5-13 13.3 10s17.1 13 29.5 13.3z"
      />
      <path
        fill="#172716"
        d="m420.1 149 9.5-6.5c1.1-.8 1.5-1.6-1.4-2.4-2.8-.9-5.8-2.1-7-1.2a56 56 0 0 0-5.3 5.7c-.7 1 2 2.6 4.2 4.4"
      />
      <path fill="#294527" d="M413.5 96.3s2.9.6 2.4 4.5-8.3 5.7-8.3 5.7z" />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-z)"
        d="M234.5 90.4 234 81l-.2-5.3-1-18.7s-1.7-.8-2.7 0l.7 18.9.2 5 .4 9.8"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-y)"
        d="m283.7 84.1-.4-11-.1-4.6-.5-14s-1.8-.7-2.8 0l.3 14.1.2 5.4.2 10.3"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-x)"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={0.4}
        d="m299.1 109.2 2.2-10.9.8-4.4 2.7-13.7s-1.6-1.2-2.7-.6l-2.9 13.7-1 5.3-2.1 10"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-w)"
        d="m259 84.4-.4-10.2-.2-5.4-.8-19.6c1-.8 2.9 0 2.9 0l.8 19.5.3 5.8.4 9.8"
      />
      <path
        fill="#fff"
        d="m269.7 85 25.4-1s-1.7 3.9-6.1 3.8c-4.4 0-2-.7-4 1-1.9 1.6-5.9 2-7.9.4-2-1.5-.6.5-3.4-1a15 15 0 0 1-4-3.1zM223 76.2l23-1s-1.6 3.8-5.5 3.7c-4 0-1.8-.7-3.6.9-1.7 1.5-5.3 2-7.1.4-1.9-1.4 0 .9-3 .7-2.9-.2-5.6-4.6-3.8-4.7"
      />
      <path
        fill="#bbbaba"
        d="M230.6 79.6s6 1.3 5.4-.3-.6-2.3.5-2.2c1.2.1 2.2 1.6.4 2.6-1.7 1-5.2 2.2-6.3-.1m-.8-3.7s-6 1.1-5.8 3.4c0 0-3-.7-2.4-1.7s8.2-1.7 8.2-1.7"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-v)"
        d="m303.9 129.9 7-12.7c2.2-4-.7-4.8-1.8-6-1.2-1.1-1-7.4-1-7.4s-13.7-1.7-21.5-1.7a59 59 0 0 0-17.2 3.5l15.5 32.9 16.7.4z"
      />
      <path
        fill="#804e2d"
        d="M295.6 102.6s-10.4 1.2-14.5 14.6c-1 3.8 3 11.9 3 11.9s-6-5-6-11-.7-13.7-7.6-12.7 10.2-4 21-3.1"
      />
      <path
        fill="#523822"
        d="m290.6 110.9 2.5-5h-2.5l-2.7 4.7zm5.3.4 2.4-4.8h-2.4l-2.5 4.5zm4.1.3 2.1-4.2h-2l-2.3 4zm5 .2 1.8-3.8H305l-2 3.6zm-16.5 17.3 2-4.2h-2l-2.3 4zm4.9.3 2-4h-2l-2.1 3.8zm-6.4-8 2.4-6.5H287l-2.6 6.2zm6 0 2.2-6H293l-2.5 5.8zm5.4.3 2-5.6h-2l-2.3 5.4zm5.6 0 2-5.1h-2l-2 4.9z"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-u)"
        d="M241.8 138.5c-10.8-4.4-8.7-11.4-17.8-18-7-4.9-24-21-24-21s17.6 12.6 28.5 15.8c2.5.8 3.9 2.2 10.2 2.2v-1.9h4.4v1.9h11c3.9 0 8.9.7 10.6-2.8l4.7-9.1s8.3-1.2 17.5-1.2c0 0-7 9.2-7 12.8 0 3.7 2.5 13.8 14 22l-51.4-.7"
      />
      <path
        fill="#806245"
        d="m239.5 138.4 16.4-.3s-8.5-2.8-14-3.5-10.7-6-10.7-6"
      />
      <path
        fill="#804e2d"
        d="M239.1 129.9s-6.7-4.7-7.4-6.5c-.8-1.8 2-.5 3.8.7 1.7 1.1 8.2 1.3 11.9 3a93 93 0 0 1 11.3 7.5s2.8 2.6 9.3-1.2c6.4-3.8-.6 4.8-.6 4.8s-21 2.5-28.3-8.3"
      />
      <g fill="none" stroke="#291c11" strokeMiterlimit={10} strokeWidth={0.3}>
        <path d="M228 120s3.2 6.2 7.7 11.2 32.7 8 32.7 8" />
        <path d="M268.2 137.6s-20.4-1.6-32.9-6.9" />
        <path d="M267 136.1s-20.4-1.6-33-6.9" />
        <path d="M265.8 134.6s-20.4-1.7-33-7" />
      </g>
      <path
        fill="#804e2d"
        d="M255.7 129s12.3-.8 12.2 0c-.2.9-1.8 4.7-4.6 4.7-2.7 0-9.4-4.5-7.6-4.6z"
      />
      <g fill="none" stroke="#291c11" strokeMiterlimit={10} strokeWidth={0.3}>
        <path d="M264.8 132.7s-20.4-1.3-33-6.5" />
        <path d="M263.7 131.1s-20.4-1.2-33-6.5" />
        <path d="M262.7 129.2s-20.4-.8-32.9-6" />
        <path d="M261.6 127s-20.3-.1-32.8-5.4" />
        <path d="M260.9 125s-20.5.3-33-5" />
      </g>
      <path
        fill="#379cd1"
        d="M321.3 153.2s-9.1 3-11.5-1 .6 8.4 9.2 6.8 10-9 10-9z"
      />
      <path
        fill="#dce8f7"
        d="M201.5 139.3s-11.4-2.6-12.6 3.4 1.2 14.5 10 14.4c8.7-.2 21.5-12.1 21.2-15.4 0 0 13.5 6 18.5 3.4 5-2.5 8.8-9.8 8.8-9.8s7 8.8 17 7.4c10-1.3 10.2-8.1 10.2-8.1s10 11.6 16.1 11.2c6.2-.4 12.4-8.6 12.4-8.6s3.8 17.7 11.6 17.5c7.9-.2 19-10 12.8-15.4-9.8-8.6-13-1.7-13-1.7s-1.9 4-4 .9c-2-3.2-10-11.6-12.8-12s-2 .8-1.1 3.6c.8 2.8 3.1 9.2-3.7 9.5-5 .1-17.8-13.2-23.5-13.2-5.8 0-3.7-.8-1.9 5.3 1.9 6.2-.3 5.7-4.2 5.7-4 0-12.3-7-14.6-7.8-2.3-.9-11.6-2-11.6-2s4.5 4.7 4.8 7 .5 5.5-5.4 5.5c-5.8 0-11-1.9-13.5-3.9-2.6-2-7.4-4.1-10.6-3.3-3.2 1-2.4.8-1.7 1.4.8.6 6.8 5.2 1.8 10.8-5 5.7-7.5 4.4-7.5 4.4s1.7-9-3.5-10.2"
      />
      <path
        fill="#1b81b6"
        d="M316.5 141.2s5.7-4 10-.6c0 0-1.4-5.1-5.6-5.3-4.2 0-4.4 6-4.4 6z"
      />
      <path
        fill="#379cd1"
        d="M200.7 147.3s2 3.8-.7 4c-2.8.2-7.5.3-5.8-4.8s6.7-4 7.6-2.7c1 1.2 2.4 6.7 2.4 6.7s-2.5-5.5-3.5-3.2"
      />
      <path
        fill="#1b81b6"
        d="M199.1 147.2s1.8-.7 1.8.9-.2 2.8-2.8 2.8c-2.7 0-4-2.6-3.2-3.9s3.6.7 3.6.7"
      />
      <path
        fill="#379cd1"
        d="M204 160.6c-5.6-.1-14.8-5.5-16.3-10.8l.8-.8a14.4 14.4 0 0 0 12.5 5c5-.3 10.7-3.5 14.1-7.9 1.9-2.4 2.7-4.7 2.4-6.6-.2-.4-.3-.7-.1-1l.2-.7h.7c.4 0 .6 0 3.2 1.9a16.8 16.8 0 0 0 13.5 3.5c4.1-.7 8.1-3.2 9.5-5.9.7-1.2.7-2.3.2-3.4-.6-1.1-.9-2-.4-2.7a1.2 1.2 0 0 1 1-.6c1.9 0 6 4.5 6.7 5.3 2 2.3 5.9 4.8 9.3 4.8h.7c3.3-.4 9.5-2.6 10.9-4.6.2-.4.2-.7.1-.8-.9-2.6-.8-3.5-.4-4a1.3 1.3 0 0 1 1-.6c.7 0 1.5.4 3 2.1l.2.2c2.6 3 8.9 10 14.4 10.1 2.7 0 5.5-1.3 7.5-3.5 1.3-1.5 2.1-3.1 2-4.3-.1-1 0-1.7.4-2.1a1.3 1.3 0 0 1 1-.4c1.6 0 2.9 3.2 3.1 5.5.4 4 4 16 9.4 19.5l-.9.8c-.4-.1-10-2.6-11.1-13v-.2l-.2-1c-2.6 2-8.4 5.8-12.7 5.8h-.4c-5.1-.3-11.1-6.9-13.3-9.3l-6 6.5h-16l-5.1-6.2-4 6.2-8.5 1-3.6 1.9-10.3-4c-.8.8-2.3 4-3.2 5.4-1 1.6-10.7 8.7-10.7 8.7H204z"
      />
      <path
        fill="#1b81b6"
        d="M187.7 149.5s4.4 6.2 13.4 5.6c9-.5 18.6-9.6 17.4-16 0 0-1.2-1.2 2.4 1.5 3.6 2.6 7.7 4.7 14.2 3.6 6.5-1 12.7-6.1 10.5-10.6s3.4.3 5.7 3c2.3 2.8 7 5.5 10.8 5.1s13-3.4 11.9-6.6c-1.1-3.3-1-4.7 1.8-1.5 2.8 3 9.3 10.6 15.3 10.6 6.1.1 11-5.6 10.6-8.9-.3-3.2 2.1-.5 2.5 3.2.4 3.8 3.9 16.4 9.8 20.3 0 0-10.3-3.2-11.5-12.3l.2-2.6s-7.6 6.6-13.3 6.4c-5.8-.3-13.5-9.7-13.5-9.7l-5.5 6-16-.1-5.6-4.6-4.4 4.8-8.1 2.6-3.4 1-11-4.3s-.8 3.8-2 5.7c-1.3 2-10.8 9-15.9 8.9-5-.1-15-6.1-16.3-11z"
      />
      <path
        fill="#172716"
        d="M292.9 190.6s-2.2 17.8 1.2 24.5c3.5 6.8 18.3 9.5 13.2 3.5-5-6-14.4-28-14.4-28"
      />
      <path fill="#405d66" d="m291.3 246 4 4.2h-11.8z" />
      <path fill="#9bc4c4" d="m290 244.8 2.1 2-9.7 3.4z" />
      <path
        fill="#fff"
        d="M274.5 243.7s7.3 4 7.4 6.5c.2 2.6.5 0 .5 0l8-5.1-6.1-4.5z"
      />
      <path fill="#9bc4c4" d="M275.5 244.3s10.3-2.9 11.3-2.1l-4.6-3-9 3.8z" />
      <path fill="#689f9e" d="M274 244s6.4-3.5 10.7-2.9l-8.4-4.9-5.4 6.8z" />
      <path
        fill="#2b5f31"
        d="M309.4 188.6c5.2 6.1 12.5 17 34.3 17.2 21.9.3 9.4 1.8 6 5.8-3.3 4-17.4 9-25.8 4.1-3.2-1.8-8.7-4.1-8.7-4.1l6 9v11.9L309.9 220l-13.7-38 5.5-.6zm-33.2.5s.6 7.7 5.7 16.9c5.2 9.1 7.6 16.5 22 19.9 14.5 3.3-10.8-2.2-11.3-17.7-.5-15.6 0-21 0-21zM262 168.4s-8.9 11.5-5.6 24.5c3.4 13 .8 1.5 6.4-5 5.5-6.7 10.3-10.7 10.3-10.7z"
      />
      <path
        fill="#294527"
        d="M307.9 198.3s6.2 1.2 10.4 5.6a22 22 0 0 0 15 6.6c4-.3 16 0 11.4 2.6-4.5 2.6-7.8 6.6-21.1 1.7-13.4-4.9-15.7-16.5-15.7-16.5"
      />
      <path
        fill="#294527"
        d="M269.4 163s-9.6 10-9.4 12.7c.2 2.5 2.8 5.8 5.8 5.7 3-.2 7.4-4.2 7.4-4.2s.6 14.5 7.3 17 11.6 2.9 11.7 0v-8.8s2.8 10.9 5 16.6c2.2 5.6 23.8 36.2 20.9 28-3-8.2-10.2-21.9-13.5-28.9-3.2-7-9.4-23.3-3.4-17.8s7.8 8 7.8 8l-9-17.2s-14.8-13.8-30.6-11.2"
      />
      <path
        fill="#3e7438"
        d="M314 210s-20.7-35.2-12.8-19.4c7.8 15.8 14 21.2 14 21.2"
      />
      <path
        fill="#172716"
        d="M314.7 209.1s-12-23.6-13.5-25.8c-1.6-2.2-3.9-1.2-1.1 3.5l13 22z"
      />
      <path
        fill="#3e7438"
        d="M291.5 170.7s-1.1 4.8-1 7.3c.2 2.4 3 .3 3.8-1.4a42 42 0 0 0 1.6-4.7zm-23.4-3.3s.8-2.6 2-4h-3.5s-7.5 8.8-7.9 14.6c-.3 5.8 5.7 7.4 5.7 7.4l1.6-2.1s-4.5-1.5-4.8-5.3c0-2.8.6-5 2-6.3z"
      />
      <path
        fill="#5fa654"
        d="M294.3 168.4s5-3.9 6.9-7.4c1.8-3.5 1 4.6 1.6 7 .6 2.2 5.2 5.8 7 0 1.7-6 3.6-9 .2-10.6-3.4-1.7-8.7-6.3-11-5.7-2.3.7-4.4 4-4.4 4z"
      />
      <path
        fill="#3b7f3d"
        d="M292.9 170.2s4.8-5.7 6.2-10c1.3-4.5 3.6-6.2 3.8-4.2s.7 10.4 1.1 12.8 4.7 0 5.6-3.3c.8-3.3 2.5-6.6 2.8-5 .2 1.8 1 6.9-1.5 9.7-2.5 2.7-6 5.7-9.3 4.5s-8.7-4.5-8.7-4.5"
      />
      <path
        fill="#32517f"
        d="M275.2 148.7s4.6-2 8.3 0c3.6 1.9 10.5 4.5 10.5 4.5s2 9.3.8 13.6c-1.3 4.3-3 3.9-4.6 2.7s-5.5-4.4-10.5-5.9l-2.9-.7s5.3-1.5 2.3-8c-3-6.6-3.9-6.2-3.9-6.2"
      />
      <path
        fill="#fff"
        d="M256.6 147.7s17-2.5 19.8 2.4c2.7 4.8 6.9 13.4-1.2 13.4-8 0-12.8-1-12.8-1z"
      />
      <path
        fill="#3b7f3d"
        d="M257.4 149.4s4.6 9.7 4.7 12c0 2.4-5 2.8-7.7 2.9a108 108 0 0 0-10.2 1.3l-3.7-13.8s.4-2.9 3.7-3.1c3.4-.2 13.2.7 13.2.7"
      />
      <path
        fill="#5fa654"
        d="M245.5 164.5s2.7-1.2 0-6.4c-2.5-5.3-5.6-7.6-1.3-8 4.4-.4 4.5 3.7 6.5 6.5 2 2.7 7.3 6 5.9.5-1.5-5.5-.4-7.8 1.1-7.7 0 0-3.3-3-4.9-2.6s-8.1.3-9.2.3c-2.8-.3-6.5 3.8-6.5 3.8s7.4 9.2 7.1 11.7c-.2 2.6 1.3 1.9 1.3 1.9"
      />
      <path
        fill="#32517f"
        d="M220.9 157s6.5 7.7 7 9.8c.4 2.1 2 2.2 6.2-.3 4.3-2.5 4-.4 7.1-2.4 3-1.9 1.2-5-.7-7-2-2-14.7-5.5-17.1-4a5.2 5.2 0 0 0-2.5 4z"
      />
      <path
        fill="#6488bd"
        d="M232.5 155.9s-.2 6.2 4.9 5.5c5-.7 2.3-5 1.2-6.4-1.1-1.3-3.3-5.3-6.4-4.9-3.1.5-6.1.4-5 1.6 1.2 1.2 5.3 4.2 5.3 4.2"
      />
      <path
        fill="#161341"
        d="M227.1 151s8.6 3.8 10 6.4c1.4 2.5-2 3.2-3.3 1.6-1.3-1.7-4-4.2-5.7-4.7-1.6-.5-4.3-3.6-1-3.4z"
      />
      <path
        fill="#491918"
        d="M295.4 250.2s-8.2-10.4-20.9-14.5c-12.6-4.1 18-10.3 23.1-9.2 5.1 1 12.9 4.9-2.2 23.7"
      />
      <path
        fill="#fff"
        d="M295.4 250.2h5.8s11.3-10 12-18l-10 4s-3.9 8.4-7.8 14"
      />
      <path
        fill="#9bc4c4"
        d="m302.5 237 10.8-5s-10.7 11.9-14.6 13.4c0 0 1 .3 3.8-8.3z"
      />
      <path
        fill="#689f9e"
        d="M273.4 192.7H211l21.2 31.8s-11.5 14.8-4 25.9l8.2 12.2 27.3-9.4s8.4-24.5 29.3-26.7l-3-8.2s-12.8-9.6-14.8-25.6z"
      />
      <path
        fill="#405d66"
        d="M251.2 199s-6.7-1-15.1 2.1c-8.4 3-6.3-1-4.5-2.3s-5.7.2-4.4.5c1.4.4-1.7.9 1 3.6 2.5 2.8.3 2.3-2.3 2.8-2.7.5-3.8.8-5-3.7-1.2-4.6.5-6 5.6-6h27.7z"
      />
      <path
        fill="#fff"
        d="M256 235.7s1.6-1.2 2.9 0c1.3 1.3 5 7.2 2.3 4.9-2.6-2.4-6-5-5.1-4.9z"
      />
      <path
        fill="#405d66"
        d="M243.3 241.6c0 1.6.3 3.6 5.8 2.2s3.9-1.9 1.6-5.6c-2.2-3.8-18.7-30.5-21.1-30.3s13.7 22.7 13.7 33.7m21.1-45.6s3.3 8.4 3.5 15.8 2.5 6.1 1.7-1.9c-.9-8-1.9-10.7 1-11 2.8-.2 1 4.8 1.5 11.9s-1 10.6-2.3 11.5l4.8-3 4-1.9 7.3-2.6s-8.7-9.8-10-18.8z"
      />
      <path
        fill="#689f9e"
        d="m275.8 196.8-1.2 14v8.5l4.7-2.2c1.2-.4 0-11.8 0-11.8s-2.9-4-3.5-8.5"
      />
      <path
        fill="#405d66"
        d="M256 196s-18.8 6.5-22.7 9c-3.9 2.4 3.9-1 5.6 2.2l9.8 19.5c.9 1.5 5.8.3 3.8-3.3-2.1-3.7-9-17.9-10-18.4-1.1-.6 6.3-6.6 24.7-8.2s-11.1-.8-11.1-.8z"
      />
      <path
        fill="#9bc4c4"
        d="M235.5 261.4s-2.5-19.6 4.2-16.7 5.9-13.6-16.7-37.3c-12-12.5-6.4-11.6-1.4-11.6l50.5.2s-8.2-8.4-14.1-1.1c-.5.6-1-6.4-1.9-6.5a73 73 0 0 0-3-.3c-18.6-1.5-39.5.7-47.4 1.7-7.8 1-.8 5.6.8 7.6l22.6 29s-8.3 9-5.8 15.9c2.6 6.8 12.2 19 12.2 19z"
      />
      <path
        fill="#689f9e"
        d="M261.7 189.8c-.2.2 7-8.2 10.5-7.8s.7 13.8.7 13.8-7.4-3-12.9-3.1"
      />
      <path
        fill="#405d66"
        d="M261.2 190.6s12.4-12.6 11-4.2c-1.3 8.5.4 9.3-2.8 9.5s6.4 0 6.4 0-1.6-8-1.3-18.7c0 0-9.5 6.5-13.3 13.4"
      />
      <path
        fill="#689f9e"
        d="M219.2 186s2.7-18.8 30.8-21.9c13.3-1.4 15.8.8 15.8.8s-9.7 7.2-9.7 21.5z"
      />
      <path
        fill="#405d66"
        d="M232.6 169.5s-12.1 6.7-13.4 15.7c-.3 2.6 2.8 1.1 6.7 1.2 3.8.2-1.5-2.5-2.1-3.1s-2.8-3.4 6.8-9c8.8-5.1 11.3-9.1 27.6-8.2.6 0-3.7 14.4-3.1 14.4 1 .1 7.7-14 8.9-14l3.2-3.8s-32.6 2.9-34.6 6.8"
      />
      <path
        fill="#fff"
        d="M227.8 185.7s3.1-8.1 6-10.8c3-2.7 4-.2 2 1.7-2 1.8-.3 4.1 2 .6 2.4-3.5 4-6.4 7.8-7 3.8-.5 1.5.9-2 3.4-3.4 2.5 6.3 1.5 10 6.3 3.6 4.8.6 6.5.6 6.5zm-7-.5s0-4 4.7-9c4.8-5 11-10 11-10s-7.6.2-24.7 14.5c-4 3.5 9 4.5 9 4.5"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-s)"
        d="M220.9 181.4c1.8.8 28.6 5 35.4 5l-.6-5z"
      />
      <path
        fill="#405d66"
        d="M235.7 166.2s-7.6 6.7-10.5 10.4c-2.8 3.6 9.2-8.9 25.5-12.5m-35 20.2 40.4 1.8v1.5l-55.9 1m22.4 16.1-7.4-7.3c-.6-.7-.1-2.5 4.5-2.5h56l.5 2.5s-48.5.2-50.5 0c-2-.1 3.5 5.2 4.2 5.7s-6.4 2.5-7.3 1.6"
      />
      <path
        fill="#405d66"
        d="M235 197.5s-2.6 2.4-4 3.2c-1.6.9 2.3.2 6-1 3.3-.9 6.9-2.9 8.6-2.9m16.5-7.7s9.8-8.5 12.3-8.5l.1-5.7s-5.3 2.5-12.4 14.2m-12.7-24.7s7.7 1.5 8.8 3.7c1.2 2-1.6-.3-9.5 3.3-7.8 3.7-3.3 2.3-1.3 3 2 .5 6 2 9.3 4.8l.6-2s-2-2.4-6.6-3.9c0 0 6.3-2.1 10-2.6l1.7-2.3s-3.5-1.5-3.7-2.2c-.1-.8.7-2 3.7-1.4s2.4 1 2.4 1l2.4-2.3-3.9-.8-6 1.4zm25.1 18.9s-2.8 6.1-9.8 6.9c-7 .7 2.5.6 9.8 0m4 30.2s2-1.3 2.7-1.3 7.2 8.2 7.2 8.2m2.9-.6-7.8-7.6 5-1.7s5 4.5 7.8 5.8 6 2.8 4.5 4c-1.4 1.4 0 0 0 0s-4.6-1.7-9.5-.5m-10.8-10v-9.2l-2-3.6-.5 13.7m-2.8 1.4v-19H274v19.7m-46.8-10.2s2-2 5.1-1.2 1 3.5-2.5 3.4c-3.4-.2-2.6-2.2-2.6-2.2m3.2 5s1.8-1.8 4.5-1.1c2.8.6.8 3.1-2.2 3-3.1-.1-2.3-2-2.3-2zm3 4.9s1.7-1.5 4.2-1c2.4.6.7 2.8-2 2.7-2.8 0-2.1-1.7-2.1-1.7zm3.2 4.9s1.4-1.3 3.6-.8c2.1.5.6 2.5-1.8 2.4-2.4-.2-1.8-1.6-1.8-1.6m3.1 5s1.2-1.2 3-.7c2 .4.6 2-1.4 2-2-.1-1.6-1.4-1.6-1.4zm11 1.6s1.4-1.3 3.5-.8c2.2.5.6 2.5-1.7 2.4-2.4-.1-1.8-1.6-1.8-1.6m3.1 5s1.2-1.2 3-.7c1.9.4.6 2-1.5 2-2 0-1.5-1.3-1.5-1.3m-21.2-6.3 9 14.6c.6.7 2.3 2 5.3 1s4.2.1 1.8 1.4c-2.3 1.2-6.5 2.8-9.2 0-2.8-3-7.1-14.7-7.8-16-.6-1.4.9-1 .9-1"
      />
      <path d="M256.6 179.9h-31c-4.4 0-8 1.2-5.7 1.5s36.4 0 36.4 0" />
      <path
        fill="#689f9e"
        d="M235 191.6s17.4-1 21-1.8l.6 2.9s-26.7-.3-21.6-1.1"
      />
      <path
        fill="#fff"
        d="M256 189.8h-45c-3.5 0-6.1 5.1-6.1 5.1h-13.3l11.3-8.6 52.8.5z"
      />
      <path
        fill="#fff"
        d="m204.9 195 24.2 31.3s-6 10.1-5.9 14.3c0 4.2 1.6 6 1.6 6s3-11.6 6.8-17c3.8-5.5 3.4-7.2-4.4-14.5-7.7-7.3-21.4-21.7-21.4-21.7m51.4 10.5c2 .2 3.7.5 4 2.5.4 2 0 3-2 3.4s-7.3 1.4-8.5 1.9c-1.1.5-1.3-.8-2-1.8-.6-1-3.5-3.9 0-5 3.5-1 8.5-1 8.5-1m4 11.8c2.5 0 5.1 1.9 4.6 4.3-.6 2.4 2 3.7 2 3.7l-9 6.9c-1.7 1.3-2.1-2.5-3-4.7-1-2.3-4.5-5.7-1.6-7.6s7-2.6 7-2.6m14 19.3s-8-7.3-8-7.6-6.4 3-7.2 3.8c-.8.9-.6 2 2 3.9 2.7 1.8 8.1 6 8.1 6zm-5.8-12.4c-1.5 1.1-3.5 6 .5 2.9s11.5-6.8 18.1-8.5l-2-2.2s-9 2.2-16.6 7.8m-15.7 20.5c1 3 1.2 6.7 5 5.8 1.4-.3 1.7-.4 1.7-1.6 0-.7-2.2-1.3-2.7-3-1-3.7-5.3-5.6-4-1.2"
      />
      <path
        fill="#689f9e"
        d="M295.2 215.4s6.5 7 8.7 8.7c2.1 1.8-1.2 1.4-4.3.5-3.2-1 1.6 3.2 1.6 3.2s3.4 2 2.9 4.2-1.2 4.4-1.9 5.7 3.9 2.5 10.3-4.7c6.5-7.3-9.6-15.5-17.3-17.6"
      />
      <path
        fill="#331312"
        d="M276.2 236.3s31.5-14.4 24.4 6.7c0 0 8-13.6-.5-16a26.3 26.3 0 0 0-24.9 8z"
      />
      <path
        fill="#6488bd"
        d="M229.4 168.7s-2.2-6.9-4-8.9c-2-2-3.7-4.9-2.3-4.7a28 28 0 0 1 5.6 2c1 .5.2-3.5-3.9-5.8 0 0-6.7 1.3-7.3 2.6-.6 1.4-3.6 2.3-3.6 2.3s1.5 1 4.8 2.8c3.3 1.7 8.2 8.2 8 9.1-.1 1 1.8 1 2.7.6"
      />
      <path
        fill="#161341"
        d="M230.9 168c-.3-1.8-.6-4.6-3-7-2.5-2.3-3.3-5-.7-3 2.7 2 5.3 6.1 14 6.1 0 0-3.1 2.2-6.2 2.3-3 .2-4.1 1.5-4.1 1.5z"
      />
      <path
        fill="#1f411d"
        d="M242.5 164.1s3.2 1.3 3-1.2c-.3-2.5-5.7-9.7-7-11-1.1-1.2 2.3-4.8 4-4.8 1.6 0-4.2 1-5.4 1.6-1.2.7-2.6 1-.6 3.7 2 2.6 7.1 7.8 6 11.7m3.8-17s3.4 3 5.7 8.3c2.4 5.3 3.5 1.9 1-2.7-2.4-4.5-3.6-5.3-3.6-5.3zm9 16.6s-7.3-5.9-9-9-.2 2.1 1.4 5.1c1.7 3 1.5 4 1 4.3-.5.5 4.8-.8 6.7-.4zm3.6-5.6c0-1.1.3-3.8 1.1-1.5.9 2.2 3.6 5.9 2 6-1.4.2-4.7 1.5-4.7 1.5s1.8-1.4 1.6-6"
      />
      <path
        fill="#dedede"
        d="M260.4 156.2s2.5 4.3 4 2.8c1.5-1.6 5.6-3.2 7.7-2 2.1 1.3 5.2 5 5.1 2.8-.1-2.1-1.8-5-3.2-7.2s.3-5 1.8-3.3c1.6 1.8 6.4 12 2.2 13.3-4.1 1.3-14.7 0-14.7 0z"
      />
      <path
        fill="#bbbaba"
        d="M265.2 162.9s-.5-2.7.6-2.8c1 0 3.6 2.8 3.6 2.8zm11.9-11.6s1.9 8.4-.3 11.6c0 0 3.8-.5 2.9-4.8a22 22 0 0 0-2.6-6.8"
      />
      <path
        fill="#6488bd"
        d="M277.8 152.8s2.8-2.6 2.7 0c0 2.5 2.4 11.7 2.5 6.2.1-5.6-1.7-7.2 2-6.4 3.6.8.5-3.2-1.5-4-2-.7-3.4-1-4.1-1-.8.1-2.8 2.6-1.6 5.2"
      />
      <path
        fill="#6488bd"
        d="M292.3 152.3s-.6 6.2-1 7.8c-.6 1.6-2.5-.5-3.3-2.7-.8-2.3-2.6-5.8-2-1.7.5 4 3.1 8.5 4.6 8.4 1.4 0 2.7-8.8 2.7-11.4z"
      />
      <path
        fill="#161341"
        d="M279.7 157.1s2.3 4.2 3.5 7.8l-5.2-2s1.6-1.7 1.7-5.8m5.2 8.5s-.6-7.7-1.4-9.6c-.8-2 .6-1.5 1.9 2.2 1.2 3.7 3.6 8.7 4.8 11.3 0 0-3.5-3.2-5.3-3.9m3-14.7s-.6 2.6.1 4 2.6 7.5 2.6 4c-.1-3.3-1.5-5.4-1-7.3zm6.1 2.3s-.8 4.6-.7 6.7c.2 2.2 1.5 5.6 1 8.5-.5 3 1.7-9.3-.3-15.2"
      />
      <path
        fill="#1f411d"
        d="M296 172.3s2.7-2.6 3.6-6.7c.8-4 2.2-1.8 1.6 3.9-.7 5.7 4.8 5 6 4.2 0 0-6 2.9-8 .7s-3.1-2-3.1-2zm4-20.6s5.6 4 5.3 8.9c-.4 4.8.5 10 1.9 4.3s.2-8.9.2-8.9-5-4.5-7.3-4.3zm10.8 6.4s2.7 8.6-2.4 14.8c0 0 5.5-4.6 5-8-.7-3.4-2.6-6.8-2.6-6.8"
      />
      <path
        fill="#172716"
        d="M282.8 164.8c-3.8 1-6.7 4.3-8.3 5.9-1.5 1.6-4.1.4-6-1.2-1.8-1.6 1.6-6.2 1.6-6.2s9-.7 12.7 1.5"
      />
      <path
        fill="#172716"
        d="M289.6 169.4s-.5 9.4-1.1 12c-.6 2.5-4.4.7-7-1.5-2.7-2.3-2-7.8 0-9.6 1.9-1.8 1.6-4.4.4-5.2 0 0 3.8.1 7.7 4.3m3.3.8s1.2 4.8.1 9c-.8 3 2.3 9.6 3.7 11.5 1.4 2 4.4-.3 2.8-3.1-1.7-2.9-2.5-17.9 1.5-9.2 4 8.6 16 28 32.6 27 16.5-.8 0 0 0 0s-11.5-1.6-24.8-17.5c-4.2-5-6.8-12.5-6.8-12.5m-37.3-3.5s.2 2.3 1.5 3.5c1.3 1.3 2 3.9-.4 1.8-2.4-2-3.3-4.9-3.3-4.9l1.5-1.4s.5-.2.7 1m-8.1 20.8s4.1-1.5 6-4.3c1.7-2.8 0 0 0 0l-4.4 7.8s-1-1.4-1.6-3.5m21.2-8.8 6.9 5.2-7.3-2.1z"
      />
      <g fill="#b2d9bd">
        <ellipse cx={292.5} cy={179.3} rx={1.9} ry={1} />
        <ellipse cx={292.2} cy={176} rx={1.5} ry={0.8} />
        <ellipse cx={293.7} cy={173.1} rx={0.8} ry={0.4} />
        <ellipse cx={303.9} cy={189.9} rx={2} ry={0.8} />
        <ellipse cx={306.5} cy={195.2} rx={1.9} ry={1} />
        <ellipse cx={309} cy={199.9} rx={1.9} ry={1.1} />
        <ellipse cx={311.6} cy={204.9} rx={1.8} ry={1.5} />
      </g>
      <path
        fill="#3e7438"
        d="M270.1 178.3s8-10.2 9.3-11c1.2-.6 2-1-1.1 9.5-3 10.5-.6 14.5-.6 14.5s2.8 7.2 7.5 8.4 5.5 1.1 5.8 4c.2 2.9-1.3 5.2-5.3 4.4-4.1-1-.8 1 1.4 3.7 2.3 2.7 14.9 15 9.1 11.3a49.2 49.2 0 0 1-19.5-23.8c-3.8-11.5-2.1-24-2.1-24zm22.5 6.9s4 8.1 6.1 13c2.2 4.9 6.4 14.7 8.5 15 2 .4 7.5-1 7.7 0 0 1.1-1.2 2.4-3 2.5s-4.5.8-3.5 1.7c1 .8.9 1.8 4.3 2 3.4 0 5.2.5 5.2 1.3 0 .7-5.8 1.4-4.5 2.7l8 7.8-.3 4.5s-26.7-26.5-28.5-50.5m21.4 24.4s2.5-.2 4.5 1.2 6.9 5.9 11.3 4 7.3-8.8 7.3-8.8h3.8s-1.4 7.3-4.3 8.8 5.6 2.8 10.8-9.3c0 0 7.6-2 11.6-5.6 0 0 1.6 13.5-13 19.2-16.8 6.5-32-9.5-32-9.5l10.4 7.8m-67.8-36.7s3.8 6.3 3.3 8.4-3.3 3.8-3.3 3.8-1.7-7.2 0-12.2"
      />
      <ellipse cx={277.7} cy={171.8} fill="#b2d9bd" rx={2.4} ry={1.1} />
      <ellipse cx={281} cy={168.5} fill="#b2d9bd" rx={0.9} ry={0.3} />
      <path
        fill="#405d66"
        d="M272.1 243.2s2.7-6.3 8-5.2c5.4 1.2-5.3-2.3-5.3-2.3l-5.4 6.5c-.4.6 2.7 1 2.7 1"
      />
      <path
        fill="#294527"
        d="M296 213c-1-2.3-2.4-8.6-2.3-11.2s-.2-5.3 2.2.8a101 101 0 0 0 5.7 12.2c.7 1.1-4.5 1.6-5.7-1.7z"
      />
      <path
        fill="#2b5f31"
        d="M294.3 201c0 1.1.3 4.6 1 7.4.8 2.8 4.4 4.5 3.4 2-1-2.3-4.5-11.4-4.4-9.4"
      />
      <ellipse
        cx={295.1}
        cy={204.4}
        fill="#3e7438"
        rx={0.5}
        ry={4.4}
        transform="rotate(-9.5 295 204.3)"
      />
      <path
        fill="#095378"
        d="M188 151.3s5.7 6.4 15.7 7c10 .4 16.8-8.5 18-12.4 0 0-2.2 14.4-16.2 14.9-13.1.4-17.4-9.5-17.4-9.5z"
      />
      <path fill="#2b5f31" d="M299.4 213.8c-.4-.6 3 .8 3.1 2 .2 1-2-.3-3.1-2" />
      <path
        fill="#095378"
        d="m221.6 145.9-1.5-2.5s8.2 5.8 13.6 6c5.4 0-6 1.2-12-3.5zm25.4-1.2s-1.7 2-3.8 1.8 3.4-3.8 3.7-6c.3-1.6-1-2 4.4 1.2 3.6 2.2 8 5.3 10 5.4 1.8 0-4.7.6-4.7.6l-7.9-6zm23.5 1.2c2.8-3.6 4.5-6 4.7-7s.8-.5 2.4 1.7c1.7 2 6.8 7.3 14.1 9.5 0 0-9.2-.8-15-8.5 0 0-1.9.7-3.3 2.3-1.4 1.5-3 2-3 2zm33-3.4s1.4 6 3 7.6-2.6-.2-1.4 3.1c0 0-3.7-4.4-1.6-10.7m7.7 7.6s3 4.3 7.1 4.5c4.2.3 6 .4 10.7-4.5 2.5-2.6 1.8-4.7.6-4.2-1 .5-1.5 2.7-2.4 3.4-1 .8-9.4 8.1-16 .8"
      />
      <ellipse cx={198.9} cy={148.3} fill="#161341" rx={1.4} ry={1.2} />
      <path
        fill="#161341"
        d="M197.1 138.6s7.4.5 7.8 11.5c0 0 2-6.9.1-9-2.9-3.6-7.9-2.5-7.9-2.5"
      />
      <path
        fill="#379cd1"
        d="M314 144.3s1.7-3 3.7-3.7c1.9-.8 1.6-6.9-1.9-3.9l-4 3.6zm3.9-.7c-1 .8-2.1 2.6-1.4 2.9.8.3 5 1.1 4.8-1-.1-2-3.4-2-3.4-2"
      />
      <path
        fill="#1b81b6"
        d="M318.5 143.9s-1.8-.1-1 .4c.6.5 3.9 1.9 3.8 1.2 0-.6.2-2.5-2.8-1.6"
      />
      <path
        fill="#161341"
        d="M320.3 144s-2.2-.6-1.5 0c.8.5 2.8 2 2.7 1.2 0-1-1.2-1.3-1.2-1.3z"
      />
      <path
        fill="#fff"
        d="M212.2 157s-9 6.9-6.1 13.2c2.8 6.4 10.8 6.4 10.8 6.4l10.2-7.6s-3.1-10.3-14.9-12"
      />
      <path
        fill="#806245"
        d="m270.8 113.9 3.6-6.5h-3l-3.2 6.2zm6.7.6 3.6-6.5h-3l-3.2 6.2z"
      />
      <path fill="#523822" d="M297.3 138.3s-8.1-2.3-10.6-5.6 7 6.8 7 6.8z" />
      <path
        fill="#dedede"
        d="M227.8 76s-4.6.8-4.6 2c0 1.3 5.5 3.2 4 .8-1.4-2.4 0 0 0 0l1.5.8s-1.5 2.8-4.2 1.3c-2.8-1.5-6-4.5-4.4-4.6l7.7-.4m9.1-.2s4.8 3 6.2 2.4c1.5-.8 0 0 0 0s-3.8 1.4-6.9-.5c-3-2-.3-1.7.7-2"
      />
      <path
        fill="#dedede"
        d="M226.9 78.6s1.4 0 3.2.7c1.8.8 3.6 2.1 2 1.7-1.7-.4-4.6-2-5.2-2.4"
      />
      <path
        fill="#bbbaba"
        d="M243.8 75.4s.5 2.6-3 2.7c-3.4 0 1.6 1.6 3.6-1s1.6-1.5-.6-1.7"
      />
      <path
        fill="#fff"
        d="m250 69 25.4-1.2s-1.8 4.2-6.1 4.2c-4.3-.1-2-.9-4 .9-1.9 1.7-5.8 2.1-7.8.5s0 1-3.2.8c-3.3-.3-6.3-5-4.2-5.2z"
      />
      <path
        fill="#bbbaba"
        d="M258.4 72.8s6.7 1.4 6-.3-.7-2.6.6-2.4c1.2.1 2.3 1.7.4 2.8-2 1-5.7 2.5-7-.1m-1-4s-6.4 1.2-6.3 3.7c0 0-3.3-.8-2.6-1.9.6-1 9-1.8 9-1.8z"
      />
      <path
        fill="#dedede"
        d="M255.3 68.8s-5 1-5 2.3c0 1.4 6 3.5 4.4.9-1.6-2.7 0 0 0 0l1.7.8s-1.7 3.1-4.8 1.5c-3-1.7-6.5-5-4.8-5.1zm10-.3s5.3 3.4 7 2.6c1.5-.8 0 0 0 0s-4.3 1.6-7.7-.5-.4-1.8.8-2.1"
      />
      <path
        fill="#dedede"
        d="M254.3 71.7s1.5 0 3.5.8 4 2.4 2.2 1.9-5-2.2-5.7-2.7"
      />
      <path
        fill="#bbbaba"
        d="M273 68.2s.5 2.9-3.3 3c-3.8 0 1.7 1.8 4-1.1 2.1-3 1.7-1.7-.8-1.9z"
      />
      <path
        fill="#fff"
        d="m250.5 84.6 23.8-1.1s-1.6 4-5.7 3.8c-4 0-1.8-.7-3.7 1-1.8 1.6-5.5 2-7.4.4-1.9-1.5 0 1-3 .7-3-.2-5.9-4.7-4-4.8"
      />
      <path
        fill="#bbbaba"
        d="M258.4 88.1s6.3 1.4 5.6-.2c-.6-1.7-.6-2.4.5-2.3 1.2.1 2.3 1.6.4 2.6-1.8 1-5.3 2.4-6.5 0zm-.9-3.8s-6 1.2-6 3.6c0 0-3-.8-2.4-1.8.5-1 8.4-1.8 8.4-1.8"
      />
      <path
        fill="#dedede"
        d="M255.5 84.3s-4.8 1-4.8 2.3 5.7 3.2 4.2.8c-1.5-2.5 0 0 0 0l1.6.7s-1.6 3-4.5 1.4c-2.8-1.5-6.2-4.6-4.5-4.8zm9.4-.2s5 3.2 6.5 2.5c1.5-.8 0 0 0 0s-4 1.4-7.2-.6-.4-1.6.7-1.9"
      />
      <path
        fill="#dedede"
        d="M254.5 87s1.5 0 3.3.9c1.9.7 3.8 2.2 2.1 1.7a23 23 0 0 1-5.4-2.5"
      />
      <path
        fill="#bbbaba"
        d="M272 83.8s.6 2.7-3 2.8c-3.6 0 1.6 1.7 3.7-1 2-2.7 1.7-1.6-.7-1.8"
      />
      <path
        fill="#fff"
        d="m269.6 69 23.4-1.1s-1.6 4-5.6 3.9-1.8-.8-3.6.8c-1.8 1.7-5.5 2-7.3.5-1.9-1.5 0 .5-3 .3-2-.2-5.8-4.3-3.9-4.4"
      />
      <path
        fill="#bbbaba"
        d="M277.3 72.5s6.2 1.4 5.6-.2c-.7-1.7-.7-2.4.5-2.3 1.1.1 2.2 1.6.4 2.6s-5.3 2.4-6.5 0z"
      />
      <path
        fill="#dedede"
        d="M283.8 68.5s4.8 3.2 6.3 2.5c1.5-.8 0 0 0 0s-3.9 1.4-7-.5c-3.2-2-.4-1.7.7-2m-10.3 3s1.4 0 3.3.8c1.8.7 3.6 2.2 2 1.7a22 22 0 0 1-5.3-2.5"
      />
      <path
        fill="#bbbaba"
        d="M290.7 68.3s.6 2.6-3 2.7c-3.4 0 1.7 1.7 3.7-1s1.7-1.6-.7-1.7m-13 20.5s6.7 1.4 6-.3c-.7-1.6-.7-2.4.5-2.2 1.3.1 2.4 1.6.5 2.6-2 1-5.8 2.4-7-.1"
      />
      <path
        fill="#dedede"
        d="M285 84.6s5.3 3.2 7 2.5c1.5-.8 0 0 0 0s-4.3 1.4-7.7-.6c-3.5-2-.4-1.6.8-1.9m-11.2 3.3s1.6 0 3.5.8c2 .8 4 2.2 2.3 1.8-1.8-.4-5.1-2-5.8-2.6"
      />
      <path
        fill="#bbbaba"
        d="M292.6 84.3s.6 2.7-3.2 2.8c-3.8 0 1.7 1.7 4-1 2.2-2.7 1.8-1.6-.8-1.8"
      />
      <path
        fill="#fff"
        d="m221.6 90.8 28-1.3s-1.9 4.7-6.7 4.6-2.2-1-4.3 1c-2.2 2-6.6 2.4-8.8.6s0 1-3.6.8-7-5.6-4.6-5.7"
      />
      <path
        fill="#bbbaba"
        d="M230.8 95s7.4 1.6 6.7-.3c-.8-2-.8-2.8.6-2.7 1.4.2 2.6 2 .5 3.1-2.2 1.2-6.4 2.8-7.8-.1m-1-4.5s-7.2 1.4-7 4.2c0 0-3.7-.9-3-2 .7-1.3 10-2.2 10-2.2"
      />
      <path
        fill="#dedede"
        d="M227.4 90.5s-5.6 1.1-5.6 2.7c0 1.5 6.7 3.8 4.9.9-1.8-3 0 0 0 0l1.9.9s-1.7 3-5.3 1.7c-3.4-1.4-7.3-5.5-5.4-5.7zm11.2-.2s5.8 3.7 7.5 2.9c1.8-1 0 0 0 0s-4.2 2.6-8.4-.6c-3.5-2.8-.4-2 .9-2.3"
      />
      <path
        fill="#dedede"
        d="M226.2 93.8s1.8 0 4 .9c2.2 1 4.4 2.2 2.4 2-2.3 0-5.6-2.3-6.4-3"
      />
      <path
        fill="#bbbaba"
        d="M247 90s.6 3-3.6 3.2c-4.3 0 1.9 2 4.3-1.2 2.5-3.2 2-1.8-.8-2z"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-r)"
        d="m234.8 96.8.5 9.2v1.4l.4 9.8-3.2-.6-.8-19.8"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-q)"
        d="m280.8 90.4.3 12.2h3.2l-.4-13.2"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-p)"
        d="m259.1 89.5.8 28 1.7-.4c1.3-.4 1.7-.8 1.7-.8l-1-26.8"
      />
      <path
        fill="none"
        stroke="#48484a"
        strokeMiterlimit={10}
        d="M238.7 117.5h4.4"
      />
      <path
        fill="none"
        stroke="#c8102e"
        strokeMiterlimit={10}
        strokeWidth={0.3}
        d="M229.5 50.6v2m-1.3-1h2.5"
      />
      <path
        fill="#dedede"
        d="M211.9 175.4s.8-2 0-6 6.8 0 11.9 0c5 0-6.8 7.2-6.8 7.2z"
      />
      <path
        fill="#bbbaba"
        d="M215 176.6s.6-3.5 0-4.9c-.4-1.3 1.2-.7 2.9.7s8.8-1.2 8.3-5.6l1 2.4z"
      />
      <path
        fill="#dedede"
        d="M206 165s4.5-4.3 9-1.4c4.4 3 10.6 2.8 7.7-1.7-2.8-4.5-8.5-4.9-10.6-4.8-2 .2 0 0 0 0s-3.9 2.6-6.1 8"
      />
      <path
        fill="#bbbaba"
        d="M211.8 157.8s3.6-.3 4.5.6c1 1 3.1 4.6 1.7 3.5-4-2.9-9.7-.6-8.7-2 1-1.6 2.5-2 2.5-2"
      />
      <path
        fill="#dedede"
        d="M257.7 150s2.8-1.7 4.4-1.2 3.7 2.1 5.5 3c1.8.8 6.8 5.6 5.6 2.7-1.2-3 0-6.5 0-6.5s-18-2.7-15.5 2"
      />
      <path
        fill="#bbbaba"
        d="M263.9 147.7s4 1.3 5 2.4c.8 1 2.2 2.4 1.8.6-.4-1.7.2-3.7-1.6-3.6-2 0-5.2.6-5.2.6"
      />
      <path fill="#dedede" d="M258.7 151s3.2.8 3.8 1.7c.6 1-1.4 1.5-1 4.4" />
      <path
        fill="#3e7438"
        d="M368.6 140.6c-1.7 3.2-6.4 10.2-3.4 8 13.5-9.8 8.9-25.3 7.3-31.2-1.6-5.8-11.8-11.7-17.7-11.7s-6.8 2.5-9.9 5.4c0 0 2.6-2 7.4-1.6 4.7.3 16.2 4.7 18.8 15.2s-2.5 15.9-2.5 15.9m2-36.5s6.9 4.2 13.2 5l12.3.5-9 6.7 7.1.3 8-6.7s14.8-1.2 22.8 4l8 5.2 4.7 1.4s-7.5-9.4-20-11c-12.5-1.4-13.5-1-13.5-1s12.4-5.4 8.6-16.5l-2.4-.6s4.7 11.9-9.3 15c-14 3.2-15-.4-15-.4zm6.1 39.6s2.4-5 2.5 2c.2 6.9 4 14.2 9 18 5 3.7 10.2 3.6 10.2 3.6l3.2 3.6s-22.2-1.4-24.9-27.2m1-23.5s1.9 11 1.9 14 6.8 5.1 4.6 0c-2.1-5.1-3-8.8-3-8.8s13.4 11.7 26 18c12.7 6.3 13.9 6 17.7 6s19.8-8.2 19.8-8.2h-3.5S428.6 148 425 148c-3.7 0-11.9-2-25.3-10.6-13.5-8.6-10.4-9.3-10.4-9.3l8.1-4.2-4.4-3.3-6.5 5s-9-7.3-8.7-5.3z"
      />
      <path
        fill="#172716"
        d="M380.5 152.5c-.4-.6-.1-1.6 2.5-1.6s3.7 1 4.6 3.7 3.5 5.9.5 6c-3 0-4.3-2.8-7.6-8.1"
      />
      <path
        fill="#2b5f31"
        d="M396.6 105.8s12.5 1.3 14.6-7.6c1-4.5-.7-5.8-.7-5.8s8.6.6 7 8c-1.1 5.7-5.8 7.5-5.8 7.5s5.8.4 9.8 1.2-5-2.3-5-2.3 2.7-3 2.7-7.4-5.1-8.2-10.3-8.2c-.6 0-1.7-.1-.2 1.4 1.5 1.6 4.8 7-12 13.2z"
      />
      <path
        fill="#172716"
        d="M404.9 118.6s-16-2.8-18.3-3.4c-2.2-.6-.6.7 9.4 7.7 10 6.9 18 7.7 18 7.7a138 138 0 0 1-18.6-11.6zm-41.6 27.8s-2.4 3.7-1 3.7c1.3 0 9.2-1 11-3.3 0 0-5.7 6.2-11 5.3-5.2-1-4.6-2-4.6-2z"
      />
      <path fill="#294527" d="M368.7 145s2 2 5-.3c3.2-2.3.9-10 .9-10z" />
      <g fill="#b2d9bd">
        <ellipse cx={392.9} cy={107.8} rx={0.8} ry={0.4} />
        <ellipse cx={397.4} cy={107.7} rx={1} ry={0.5} />
        <ellipse cx={401.8} cy={107.5} rx={1.2} ry={0.6} />
        <ellipse cx={406.3} cy={107.4} rx={1.4} ry={0.7} />
        <ellipse cx={377} cy={129.8} rx={1.2} ry={0.7} />
        <ellipse cx={376.7} cy={126.7} rx={1.2} ry={0.7} />
        <ellipse cx={378.9} cy={122.5} rx={1.3} ry={0.8} />
        <ellipse cx={375.9} cy={119.9} rx={1.2} ry={0.7} />
        <ellipse cx={373.3} cy={117.7} rx={1.1} ry={0.6} />
        <ellipse cx={385.9} cy={115.1} rx={1.3} ry={0.8} />
        <ellipse cx={383} cy={112.6} rx={1.2} ry={0.7} />
        <ellipse cx={380.3} cy={110.3} rx={1.1} ry={0.6} />
        <ellipse cx={371} cy={115.7} rx={0.8} ry={0.5} />
        <ellipse cx={377} cy={108.2} rx={0.8} ry={0.5} />
        <ellipse cx={403.3} cy={105.4} rx={0.8} ry={0.5} />
        <ellipse cx={377.1} cy={132.6} rx={1} ry={0.6} />
        <ellipse cx={377.4} cy={135.5} rx={0.8} ry={0.4} />
      </g>
      <path
        fill="#3e7438"
        d="M79.1 141.2s-16.3-6.6-17.1-13.1c-.9-6.6 14.5-11.5 14.5-11.5L78 114s-19.4 2-19.4 14 27.8 18.8 27.8 18.8z"
      />
      <path
        fill="#2b5f31"
        d="M75 119.2s-6.7 2.1-5.5 2.3c1.3.2 4.6.3 4.6.3l-.4 1.3s-9.7.5-9.7 2.3-1.5 5.3 12.5 12.8l1 2.3S62 133.9 61.7 128c-.2-6.3 8.7-9 13.5-11.1 4.7-2.2-.3 2.3-.3 2.3"
      />
      <path
        fill="#b2d9bd"
        d="M60.5 130.9s1.7 3.7 3.7 5.2 5.4 2.5 5.4 2.5l-4-3.7c-1.2-1.2-5.1-4-5.1-4"
      />
      <path
        fill="#172716"
        d="M68.7 123.6c.2.9-2.8 5.3-.3 7.6 2.5 2.4.4 2.9-1.5 1-1.8-1.9-4.6-4.5-3-7.7 1.6-3.3 4.7-1.8 4.8-1z"
      />
      <path
        fill="#3e7438"
        d="M180.6 126.4s-1.2-10.8-8.9-15.5c0 0-.7 14.7-7.2 23.8-2.6 3.6-5.8 8.5-8.6 13.7-.4.5 4.2 4.4 4 5-.3.4-5.4-2.5-5.6-2-3.7 7-6.6 14.3-6.6 19.5 0 10-1.2 19 1 25.3 2.3 6.4 0 0 0 0s-7.7-11.6-6-24.1c1.8-12.5 9.4-21.2 9.4-21.2l8.2 2.4-6-6.7s15.3-21.5 12.2-34.9-12.2-11-12.2-11 17 0 24.2 12.8c2.9 6 2.1 12.9 2.1 12.9"
      />
      <path
        fill="#3e7438"
        d="M149.4 160.6s2.2 1.8 4.3 3c2 1.3 4 5.5-2.2 2.5-6-3-2.1-5.5-2.1-5.5m10.7 43.8c.1-17.5 10.6-23 10.6-23s-8.3 1.5-15 11.3c-6.8 9.8-5-3.3-3.8-11.3s14.8-17.3 14.8-17.3-10.4 14-11 19.2l5-2.6s8.4-3.6 14.2-2.7 5.5 2.7 5.5 2.7-7.2.8-10.7 4.5a28 28 0 0 0-8 18.7z"
      />
      <path
        fill="#172716"
        d="M157.9 204s1.2-7.2 2.2-10.6c1-3.3-2.4-7.3-7.7 6.5"
      />
      <path
        fill="#294527"
        d="M176.2 138.4c-1.4 1 .2 3.3 2.2 3.3s-10.5 14-17.2 26.7l4-3.2 18.2-23.7s7.7-12.9-7.2-3z"
      />
      <path
        fill="#3e7438"
        d="M179.6 134.2s-3.2 2.6-3.4 4.2c-.1 1.7 9.7-1.4 9.6-4.2-.2-2.8-.4-3.7-.4-3.7s-3.2 3.3-5.8 3.7"
      />
      <path
        fill="#294527"
        d="M167.9 136.8c-1.2-1.2-5.2.6-13.8 18.9l-1.2-1.7s6-11.8 12.4-20.4zm-4.4 28.8s-5.3-4.9-6.1-3.5c-.9 1.4-1.2 1.8.7 3.5l3.5 3.3z"
      />
      <path
        fill="#3e7438"
        d="M153 154s2.4 3.9 4.7 5.8c2.4 2 1.4 6.2-2.4 2.9a129 129 0 0 1-5-4.6z"
      />
      <g fill="#b2d9bd">
        <ellipse cx={152.3} cy={192.7} rx={1.9} ry={1} />
        <ellipse cx={176.2} cy={138.4} rx={1.9} ry={1} />
        <ellipse cx={173.8} cy={142.7} rx={1.9} ry={1} />
        <ellipse cx={171.4} cy={147} rx={1.9} ry={1} />
        <ellipse cx={168.9} cy={151.3} rx={1.8} ry={0.9} />
        <ellipse cx={166.5} cy={155.6} rx={1.5} ry={0.8} />
        <ellipse cx={152} cy={189.3} rx={1.5} ry={0.8} />
        <ellipse cx={153.5} cy={186.4} rx={0.8} ry={0.4} />
      </g>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="M114.2 108.7s.7 2.1.5 3.2m4.3-3.2s.6 2 .5 3m5.2-3.7s.6 1.8.5 2.7m18 28.2s2.1-.8 3.2-.7m-3.5-4.5s2-.2 3 0m-2.4-4.6s1.9 0 2.7.5m-1.2-3.8s1.7.6 2.4 1.3m-18.1-20s.5 1.6.4 2.5m85.5 105.9s1.8 1 2.4 1.8m-4.8 1.4s1.7 1 2.3 1.9M206 208s1.6.9 2 1.6m.7-5.4s1.5.9 2 1.6M136 106.4s.5 1.5.4 2.3m2.3 16.3s1.7 1.4 2.2 2.4m1.2-4.8s1.6 1.3 2 2.2m1.7-5.6s1.4 1.1 1.8 2m.9-5s1.3 1 1.7 1.8m2.7-5.8s1.2 1 1.5 1.7"
      />
      <path
        fill="#dedede"
        d="M337.4 120s10.4-7.6 15.4-5.6l.9-4.5s-7-1.6-12 4c-5 5.4-4.3 6-4.3 6zm5.1 18 9.7 13.7L345 139zm28.2 45.9s-1.6 0-3.7 11c-2 11-3.3 12.4-3.3 12.4s10.4-7.7 7-23.4M359 202s1 10.6-2.4 13.7c-3.4 3.2-8.5 3.2-8.5 3.2s7.1-3.3 11-16.9z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="M366.1 202.4s2.2-.2 3.3.1m-1.8-4.7s2-.3 3 0m-2.1-4.5s1.8-.2 2.7.1m-1.8-4.5s1.6-.3 2.4 0"
      />
      <path
        fill="none"
        stroke="#c8102e"
        strokeMiterlimit={10}
        strokeWidth={1.3}
        d="m309.7 83.6-3 11.5m-3.2-7 9.4 1.8"
      />
      <path d="M287.2 215.6c-4.5.4-8.8 2-12.8 4.2a58 58 0 0 0-11 7.9l-.2-.3c3.3-3 7-6 11-8.2s8.3-4 12.9-4.5z" />
      <g fill="none" stroke="#000" strokeMiterlimit={10}>
        <path
          strokeWidth={0.6}
          d="M219.2 76.3s2.5 4.8 6.3 4.8c3.7 0 3.2-1.5 3.2-1.5"
        />
        <path strokeLinecap="round" strokeWidth={1.3} d="m246 75-26.8 1.3" />
        <path
          strokeWidth={0.6}
          d="M235.7 77s1.3 1.8 4.5 1.8c5.3-.2 5.8-3.7 5.8-3.7"
        />
        <path
          strokeWidth={0.6}
          d="M226.2 78s3.5 3 6.4 3 4.8-1.4 5.3-2.5M247 85s2.5 4.7 6.3 4.7c3.7 0 3.2-1.5 3.2-1.5"
        />
        <path strokeLinecap="round" strokeWidth={1.3} d="M273.9 83.7 247 85" />
        <path
          strokeWidth={0.6}
          d="M263.6 85.7s1.3 1.8 4.5 1.8c5.3-.3 5.8-3.8 5.8-3.8"
        />
        <path
          strokeWidth={0.6}
          d="M254.1 86.7s3.5 3 6.4 3 4.8-1.4 5.3-2.6m5-15.3c.8.6 1.7 1.7 2.8 1.7 2.4 0 2.1-1 2.1-1"
        />
        <path strokeLinecap="round" strokeWidth={1.3} d="m293 68-18.3.9" />
        <path
          strokeWidth={0.6}
          d="M282.7 70s1.3 1.8 4.5 1.8c5.3-.3 5.8-3.8 5.8-3.8"
        />
        <path strokeWidth={0.6} d="M273.2 71s3.5 3 6.4 3 4.8-1.4 5.3-2.6" />
        <path strokeLinecap="round" strokeWidth={1.4} d="m295 83.6-20.7 1" />
        <path
          strokeWidth={0.6}
          d="M283.4 85.9s1.4 2 5.1 2c6-.3 6.6-4.3 6.6-4.3"
        />
        <path
          strokeWidth={0.6}
          d="M271.3 86.7s5.3 3.7 8.5 3.7c3.3 0 5.5-1.6 6-3m-39.8-18s2.7 5.1 6.8 5.1c4 0 3.5-1.6 3.5-1.6"
        />
        <path strokeLinecap="round" strokeWidth={1.4} d="m275 68-29 1.4" />
        <path
          strokeWidth={0.6}
          d="M263.9 70.2s1.3 2 4.8 2c5.7-.4 6.3-4.2 6.3-4.2"
        />
        <path
          strokeWidth={0.6}
          d="M253.6 71.3s3.8 3.2 6.9 3.2 5.2-1.5 5.7-2.8M217 91.2s3 5.8 7.5 5.8c4.6 0 4-1.8 4-1.8"
        />
        <path
          strokeLinecap="round"
          strokeWidth={1.5}
          d="M249.3 89.7 217 91.2"
        />
        <g strokeWidth={0.6}>
          <path d="M237 92.1s1.4 2.2 5.4 2.2c6.3-.3 7-4.6 7-4.6" />
          <path d="M225.4 93.3s4.3 3.7 7.7 3.7c3.5 0 5.9-1.8 6.4-3.2m35.2-7s-.2 2 1 2.5" />
          <path d="m231.7 96.8.8 19.8 3.2.6-.4-9.8M231 80.8l.4 9.8m2.4-15-.9-18.7s-1.8-.8-2.8 0l.7 18.9m3.2 5.1.5 9.5m.8 17-.5-10.6m48.4-28.3-.5-14s-1.8-.7-2.8 0l.3 14.1m3.5 15.5-.4-11m-2.5 17.3.3 12.2h3.2l-.4-13.2M280.4 74l.2 10.3m-19.3-15.6-.8-19.5s-1.9-.8-2.9 0l.8 19.6m3.6 15.5-.4-9.8m-2.5 15 .8 28 1.7-.4c1.3-.4 1.7-.8 1.7-.8l-1-26.8m-3.7-15.3.3 10.2" />
          <path d="M231.2 56.5v-6h-3.5v2l3.5.1" />
        </g>
      </g>
      <path d="M293.7 139.4a39 39 0 0 1-7.7-7 31 31 0 0 1-5.2-9.1 21 21 0 0 1-1.2-5.2v-1.3c0-.5.2-1 .3-1.4l1-2.4a65 65 0 0 1 5.7-8.8l.3.5a52 52 0 0 0-4.4-.1l-4.4.1a69 69 0 0 0-4.3.4l-2.2.3-1 .2h-.6c-.2.1-.4.1-.5.3l.2-.2-3.7 7.3-1 1.9a4.8 4.8 0 0 1-1.4 1.7 8 8 0 0 1-4 1.3h-17v-2.3l.5.5-4.4.2.7-.7-.2 1.9v.5h-.5a24 24 0 0 1-5.5-.5c-.9-.2-1.8-.5-2.6-.9l-2.5-1a59.4 59.4 0 0 1-9.9-4.4 149 149 0 0 1-9.3-5.6l-9-6 .3-.4 5.2 5 5.3 5c3.5 3.2 7.1 6.4 10.9 9.4 1.8 1.5 4 2.7 5.7 4.3a32 32 0 0 1 4.8 5.6c1.4 2 2.7 3.9 4.4 5.3a18.1 18.1 0 0 0 5 3c.2.1.3.2.3.4l.1 1-.2.5a2 2 0 0 1-.8.6h-.5a23 23 0 0 1-2.5-1.3 15.7 15.7 0 0 1-3-2.4c-1.9-1.9-3-4.1-4.2-6.3a22 22 0 0 0-6.5-8.4l-2.8-2.1a310 310 0 0 1-10.9-9.5l-10.7-9.6.4-.5a149 149 0 0 0 18.3 11.5c3.2 1.6 6.5 3.1 9.9 4.1l2.6 1 2.5.7c1.7.4 3.5.4 5.2.5l-.5.5-.1-1.9v-.6h.6l4.4.2h.5v2.3l-.5-.5h12.4c1.3.1 2.7.2 4 0 1.3 0 2.7-.3 3.7-1s1.5-2 2.1-3.3l3.9-7.3v-.1h1.3l1-.1 2.3-.2 4.3-.3 8.8-.6h.5l-.3.5c-2 2.7-4 5.6-5.6 8.7-.7 1.5-1.5 3.1-1.3 4.8s.6 3.3 1.2 5a31.9 31.9 0 0 0 12.6 15.8z" />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M269.4 105.6s9.3-3.5 17.2-3.5a229 229 0 0 1 21.5 1.7s-.2 6.3 1 7.4c1.1 1.2 4 2 1.8 6l-7 12.7"
      />
      <path d="M215 177c-2.3-.7-4.4-1.6-6.3-3-1-.8-1.8-1.6-2.5-2.6s-1-2.2-1.2-3.5a8.8 8.8 0 0 1 .3-3.6 13.8 13.8 0 0 1 7.2-7.9l.3-.2h.2a22.2 22.2 0 0 1 5 1.5 16.6 16.6 0 0 1 5.4 3.6 26 26 0 0 1 2.3 3c1 1.5 1.8 3 2.3 4.7l.2.6-.5.3c-4.1 2.4-8.2 4.8-12.4 7l-.2.1zm0-1 11.8-7.5-.4 1c-.5-1.4-1.3-2.9-2.1-4.2a24 24 0 0 0-2.2-2.8 10 10 0 0 0-.8-.8 15 15 0 0 0-4-2.4 23.7 23.7 0 0 0-4.5-1.5h.4a15.8 15.8 0 0 0-6.3 7c-.4 1-.7 2-.8 3.1a5.3 5.3 0 0 0 .2 1.6c.1.5.3 1 .6 1.4a9 9 0 0 0 2.2 2.5 16 16 0 0 0 5.9 2.7z" />
      <g fill="none" stroke="#000" strokeMiterlimit={10} strokeWidth={1.8}>
        <path d="M212.9 157c.2-.6 2.1-1.4 3.5-1.4 1.3 0-1-1.8 4.6-3.5 5.5-1.8 5.1 0 5.1 0s.4-1.5 2.8-1.5c2.3 0 5-1 5.9 0 .8 1 4.8 5.7 5.7 6.5.9.7 2.9 4.8 2.1 6.5-.7 1.6-3.1 2.3-6.9 2.6-3.7.2-8.1 4.4-8.5 3" />
        <path d="M235 150.9c.6-1.8 2-2.3 3.4-2.3 1.3 0 .3-1.5 5.2-1.5 4.8 0 3 .4 5.8.3 2.8 0 5.5-1.8 7.5 1.2 2 2.9 5.2 11 5.5 13.2.2 2.2-7.4 2.8-9.8 2.3-2.3-.5-8.7 1.9-10.5.2" />
        <path d="M256 147.6s8.7-1 14-.8c5.2.4 8.6 4.6 9.4 9 .7 4.5.4 8.1-5 7.6-9-.7-12.3-.8-12.3-.8" />
        <path d="M274.5 148.3s5.7-1.4 8.1 0a42 42 0 0 0 8 3.6c1.1.4 4.8.2 4.8 5.2s0 14.7-4 13c-4.2-1.8-4.5-4.4-8.2-5.2-3.5-.8-5.4-2-5.4-2" />
        <path d="M294.6 154a6.3 6.3 0 0 1 6.1-2.2c2.9.6 5.9 4.3 8.7 5.3s5.6 7.7 2.3 12.4-9.6 7.6-12.5 4.9c-2.8-2.7-5.6-2.5-6.6-4.2" />
      </g>
      <path d="M226 171a405 405 0 0 0-8 6.1 154 154 0 0 0-4 3.2 39 39 0 0 0-1.8 1.6l-.7.7v.1-.2l.4.2 1 .2 2.5.1h.6a3.2 3.2 0 0 1 .9.2v.1l.3.1c.1.1.6.7.6 1.3 0 .5-.3.7-.4.9l-.3.3-.5.2a16 16 0 0 1-3.4 1.1 22 22 0 0 1-4 .5H208l-5 .1.9-.3-11.7 8.1-.5-1.6 13.3-.5h.6l.5.6 23.8 31.7.4.5-.4.5c-1.3 3.2-2.9 6.3-3.9 9.3l-.6 2.2c0 .6-.1 1.4 0 1.6a34 34 0 0 0 1.8 4.2 81 81 0 0 0 2.5 4.4 195 195 0 0 0 2.6 4.4l5.4 8.8-1.7-.6 27.9-8.9-.6.6a50.6 50.6 0 0 1 9.7-16.6 35 35 0 0 1 7.3-6.3c2.8-1.8 5.8-3 9-3.7a29 29 0 0 1 4.9-.7h1.2a23 23 0 0 1 3.7.3c1.6.3 3.4 1 4.6 2.6a7.4 7.4 0 0 1 1 5.2c-.4 3.3-1.8 6.3-3.3 9.1a65 65 0 0 1-5.2 8l-.8-1.4 6.4-.6-.8.3c2.4-3.1 5.1-6 7.3-9.3a30 30 0 0 0 2.9-5 12 12 0 0 0 1-5.4c0-.5 0-.8-.2-1.2a9 9 0 0 0-.5-1.2 17.3 17.3 0 0 0-1.7-2.3 25.6 25.6 0 0 0-4.3-4 26.7 26.7 0 0 0-10.7-5v-.6c4.1.5 8.1 2 11.6 4.3a27.3 27.3 0 0 1 4.8 4 19 19 0 0 1 2 2.5l.8 1.5c.3.6.4 1.2.5 1.8.2 2.3-.3 4.5-1 6.5a37 37 0 0 1-2.9 5.6 37.9 37.9 0 0 1-7.9 9.6l-.4.3h-6.9l-2 .1 1.3-1.5a63 63 0 0 0 5-7.8c1.5-2.7 2.8-5.6 3.2-8.5.1-1.5 0-3-.8-4-.7-1-2-1.6-3.5-1.9a14 14 0 0 0-2.2-.2 21 21 0 0 0-1.1 0H294a27 27 0 0 0-4.5.6c-6 1.3-11.3 4.9-15.4 9.5-4 4.6-7.2 10.1-9.3 16l-.1.3-.4.2-27.5 10-1 .5-.7-1a110 110 0 0 1-12-17.2 39 39 0 0 1-1.2-2.5c-.4-.9-.7-1.7-1-2.9-.3-1.4 0-2.4.2-3.4.3-1 .6-2 1-2.8a27.8 27.8 0 0 1 6.2-8.8v1l-24.7-31 1.2.5-13.3-.5h-2.7l2.2-1.6 10.8-9 .4-.4h5.6l1.3.1h1.2a20 20 0 0 0 2.3-.3 13.6 13.6 0 0 0 2.7-.7s0-.1 0 0c0 0-.2.2-.2.6l.1.7.3.3h.1a.5.5 0 0 0 .1.1h-.6l-2.6-.3a9.6 9.6 0 0 1-1.4-.3c-.5-.2-1.1-.4-1.7-1.1a2 2 0 0 1-.4-1.5l.4-1 1-1.2a40 40 0 0 1 2.1-1.7 153 153 0 0 1 4-3 420 420 0 0 1 8.4-6z" />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.8}
        d="M267.9 163s-11.8 8.7-11.8 21.4 2.1 11.8 2.1 11.8 8-17 16.3-21.3c0 0-1 18.2 3.4 27.7s13.3 20 23.7 22.6c10.3 2.7-5.2-4.6-7.9-11.8-2.6-7.2-1.1-26.2-1.1-26.2s2.8 15.4 10.3 26.4a200 200 0 0 0 18.2 22.1l.9-13.8-8.8-13.2s10 11.9 23.8 11.9c13.7 0 21.3-9.3 21.7-21.3 0 0-5.5 6.8-19.2 6.8-13.8 0-28-9.6-38-30.7"
      />
      <path d="M311 157.6c2.1.3 4.3.5 6.3.3 2-.1 4.2-.6 5.2-1.7 2.8-3.2 5.6-6.4 5.5-10 0-1.8-.6-3.8-1.5-5.3a8.6 8.6 0 0 0-1.8-2.1 9.6 9.6 0 0 0-2.3-1.6c-3.2-1.6-7.4.6-10.3 3.6l-.4.8-.5-.8a55 55 0 0 0-3.3-4.7 34.6 34.6 0 0 0-3.7-4.1 18.4 18.4 0 0 0-4.4-3.2c-1.6-.8-3.2-1.2-5-2.2l.5-.8c1.9 1.4 2.4 3.5 3 5.6.3 1 .4 2.1.4 3.3 0 1.1-.2 2.4-1 3.6-.7 1.1-2 1.8-3.2 2a9 9 0 0 1-1.8.3h-.8a12 12 0 0 1-.9 0 12 12 0 0 1-6-2.8c-1.7-1.4-3-3-4.4-4.3a24 24 0 0 0-4.5-3.7 18.6 18.6 0 0 0-5.3-2.1c-1.8-.5-3.8-.7-5.7-1.1l.3-.9a27 27 0 0 1 3.3 5l.9 3a4 4 0 0 1-1 3.2c-.8 1-1.9 1.3-3 1.5a13.7 13.7 0 0 1-9-1.4c-1.7-1.2-3-2.8-4.3-4a14.3 14.3 0 0 0-4.6-3 50.4 50.4 0 0 0-11.2-2l.4-.8a29.2 29.2 0 0 1 5.7 7.1c.4 1 .8 2.2.4 3.4a3.5 3.5 0 0 1-1 1.6 5 5 0 0 1-1.4 1c-1 .4-2 .6-3.1.7-1 .1-2 .2-3 .1a27 27 0 0 1-3.1-.2 19 19 0 0 1-6-1.9c-1.8-1-3.4-2.4-4.9-3.5a8.3 8.3 0 0 0-5-1.8c-1.8 0-3.6.3-5.6.3l.1-.9a14 14 0 0 1 4 4.4 6.2 6.2 0 0 1 .2 6 12 12 0 0 1-4 4.3c-1.6 1-3.4 2-5.1 2.7l-1.1.5.4-1v-.1c.7-2.3 1-4.9.4-7.1-.3-1.2-1-2.1-1.8-2.8a7 7 0 0 0-3.2-1.2c-2.4-.3-5 0-7 1a8.1 8.1 0 0 0-3.8 5.5 12.2 12.2 0 0 0 .4 6.9l.8 1.4.5.6.6.6a21.3 21.3 0 0 0 3 2.1c4.2 2.6 9.3 3.8 14.3 3.4v.3c-.1.2-.3.2-.4.3h-.5a23 23 0 0 1-2.9.2 24 24 0 0 1-3.9-.3 25.8 25.8 0 0 1-7.4-2.4 23 23 0 0 1-3.4-2.1 22 22 0 0 1-.7-.6 5.6 5.6 0 0 1-.8-.9 8.3 8.3 0 0 1-1-1.9 12.3 12.3 0 0 1-.5-8 11 11 0 0 1 1.8-3.8 9.3 9.3 0 0 1 3.1-2.8 11 11 0 0 1 4-1.1 15.2 15.2 0 0 1 4 .1c1.3.3 2.7.7 3.8 1.6s1.9 2.2 2.2 3.5c.4 1.4.4 2.7.2 4a16.8 16.8 0 0 1-.9 3.9l-.6-.7c1.7-.7 3.4-1.6 4.9-2.7 1.5-1 3-2.3 3.7-3.9.9-1.6.7-3.5-.1-5a13 13 0 0 0-3.7-4l-1-.3 1-.6a11.4 11.4 0 0 1 6.1-1.4 10.1 10.1 0 0 1 6 2.2c1.7 1.3 3 2.6 4.7 3.5 1.6 1 3.4 1.5 5.3 1.8a25 25 0 0 0 2.9.3h2.8c1-.2 1.9-.3 2.7-.7.8-.3 1.4-.8 1.6-1.5a4 4 0 0 0-.3-2.4c-.3-.9-.8-1.7-1.3-2.5a32.3 32.3 0 0 0-3.8-4.5l-1-.8h1.3c4-.2 8 0 11.9 1.1a17.5 17.5 0 0 1 5.6 3c1.6 1.2 3 2.7 4.3 3.4l2 .8a13.1 13.1 0 0 0 4.9.2c.7-.1 1.2-.4 1.5-.5.2-.2.4-.5.4-1.2a7 7 0 0 0-.4-2.3 37 37 0 0 0-2-5.2l-.8-.6 1.2-.2c2-.5 4.1-.3 6.2.1a20.6 20.6 0 0 1 5.8 2.4 26 26 0 0 1 5 3.8c1.4 1.5 2.8 3 4.2 4.2a9.4 9.4 0 0 0 5 2.4c1.8.2 3.9 0 4.8-1.4.5-.6.7-1.5.7-2.4 0-1-.1-2-.3-2.9-.5-1.9-1.2-3.7-2-5.5l-.5-.8h.9c2 .1 4 .7 5.8 1.6 1.7 1 3.3 2.2 4.7 3.6a32.2 32.2 0 0 1 6.7 9.7l-.8-.1a13.5 13.5 0 0 1 2-2.8c.8-.8 1.7-1.6 2.8-2.2a9.4 9.4 0 0 1 3.5-1.3 8.7 8.7 0 0 1 3.9.4 10.4 10.4 0 0 1 3.3 1.8 12.1 12.1 0 0 1 2.6 2.8 13 13 0 0 1 2.2 7.1c0 2.7-1 5.2-2.3 7.2a24 24 0 0 1-2.3 2.7l-1.2 1.2-1.2 1.2a7.6 7.6 0 0 1-3.7 1.6 11 11 0 0 1-3.6.2 25 25 0 0 1-3.4-.6 20.5 20.5 0 0 1-3.2-1z" />
      <g fill="none" stroke="#000" strokeMiterlimit={10}>
        <path d="M219.2 152.7s3-4 2.4-6.8c0 0 6 4.1 10.2 3.8m12.4-3s3.8-1.8 4.5-5c0 0 3.6 4.4 7 5m14.3.1s5.1-3.9 5.8-6.2c0 0 7.5 8.8 13.3 9.5 5.8.6 13.7-6.2 13.7-6.2s-2.1 10.1 9.5 14.3m-.6-17.6c1.2 2.1 3.9 6.5 6.9 6.5s3.8-3.7 1.1-3.7c-2.6 0-2.9 1-2.9 1" />
        <path
          strokeWidth={2}
          d="M274.5 235.7a48.9 48.9 0 0 1 20.9 14.5m0 0h-13.5s1.6-3-12.5-8"
        />
        <g strokeWidth={1.8}>
          <path d="M366.6 151.7c5.6 12 10.1 25 10.1 33.5 0 11.4-7.8 32-37 35.2" />
          <path d="M358.7 199.3c1.2-11.5-9.5-17.1-21.3-15.4 0 0 4.8-6 13.8-6s14 8.4 14 8.4-4.5-12-16.5-29c-15.1-21.4-16-28.6-16-28.6l4.7 2s-5.4-10.4 7.3-19.4c3.4-2.4 9-1.6 9-1.6s-1 3-1 6.9c0 3.8 0 8.8 8 23.5a207 207 0 0 1 3 5.7" />
          <path d="M336.3 126.4c-2-7.8 5.8-23 21.9-23 14.5.2 27.5 3.7 36.5 2.5 9-1.3 20.3-9.2 13-14.7 0 0 11.5-.1 11.5 8.2 0 8.4-4.7 8-4.7 8s17.7.5 23.7 14.2c0 0-6.2-3.4-13.7-3.4s-29.3.7-29.3.7 10 8.8 22.5 13.1c12.5 4.4 18.7 8 38.3 5.6 0 0-26 14.7-30 14.7s-18-2-43.4-24.7c0 0 3.8 7.3 6.1 15.8 2.4 8.5 6.9 24.7 15.4 29.3 0 0-11.4-.1-19.7-7.7s-7.7-23.3-7.7-23.3-8 16-19 8.4c0 0 13.9-6.5 13.9-19.4a20 20 0 0 0-17.9-21" />
        </g>
        <path
          strokeLinecap="round"
          d="m340.9 137.3 5.3 2.2m-.3 4 2.3 1.7m1.1 2.7.8 1m2.1 2.8v1.5"
        />
        <g strokeWidth={1.8}>
          <path d="M153.9 147.2c6.2-10.1 12.7-20 12.7-31 0-21-21.2-15-26.9-14.8-5.6.2-19.6 3.6-24 .7a32.5 32.5 0 0 1-11-12.2s-5 7.8-2 12.2c3 4.5 6 5.5 6 5.5s-13.6.4-19 3.7c-5.3 3.3-7 10.2-7 10.2s15.7-10 27.7-6.3 25-1.3 25-1.3-35.7 23.8-58.7 24.4M205 194.9s-13.8 12-30.2 12c-16.3 0-32-8-32-30.3 0-9.4 4.2-17.8 9-25.9" />
          <path d="M166.5 113.9c-6.3-1.2-17.5 8.7-17.5 20.3s11.3 19.1 11.3 19.1c-13-1.4-17.6-11.7-17.6-11.7s2 6.2-2.1 13.8c-10.8 20.6-26.4 18.2-26.4 18.2A52.2 52.2 0 0 0 126 155c1.5-4 8.7-18 10.8-22 2.2-4-.2-7.3-3.1-4.5 0 0-20.7 16.8-30.4 19.8-6 1.9-18.1 1.5-26.5-10.1-8.3-11.6 1.4-24.4 1.4-24.4s-19.4 2.3-19.4 14 30 21.4 38.4 21.4m47.7 15.7c-3 12-7.2 31.7 4.6 45.4 11.7 13.8 33.3 15.4 42.2 10.4s12.9-9 12.9-9-3.7 11.4-4.3 18c0 0 10.9-1.7 12.7-8.1 0 0-4.7 10.1 3.5 19.7 0 0 3-13.8 10.7-17.6" />
          <path d="M161.7 205c1.1-24 18.7-24.3 18.7-24.3s-.5-2.7-9.3-2.7c-8.9 0-15.7 6.3-15.7 6.3-1.7-6 22.7-34 27.3-41.6 4.7-7.6 2.7-12.2 2.7-12.2-1.2 2.2-5.8 3.7-5.8 3.7s1.6-3 .8-13.7c-1-14.5-16.7-20-26.7-19.9" />
        </g>
      </g>
      <path
        fill="#291c11"
        d="m290.4 105.4 3.2.2v.5l-3.2.7.9-.5-3.4 5.1-.7-.3 2.8-5.4.2-.3zm5.2.6 3 .2v.5l-3 .7.8-.5-3.2 4.8-.6-.3 2.7-5.2v-.2zm4.4.9h2.9v.6l-3 .6.8-.5-3 4.7-.7-.3 2.6-5 .1-.2zm-12.2 17.5 3.2.2v.6l-3.2.8 1-.7-2.5 5.2-.8-.3 1.8-5.4.1-.4zm5.2.6 3 .2v.6l-3 .8 1-.8-2.4 5-.8-.3 1.7-5.2.1-.3zm11.8-17.5h2.4v.6l-2.4.5.8-.5-2.7 4.8-.5-.3 2.1-5 .1-.1zm-18.6 6.8h3.8v.8l-3.8.9 1.1-.8-3.2 6.7-.8-.3 2.4-7 .2-.3zm6.3.6h3.6v.7l-3.6.9 1-.7-3 6.3-.8-.3 2.3-6.6.1-.3zm5.2.7h3.5v.7l-3.5.8 1-.7-2.9 6-.8-.2 2.3-6.3.1-.3zm5.9.5 2.8.1v.7l-2.8.7 1-.8-2.4 6.1-.8-.2 1.7-6.3.1-.3zm-32.3-9.2 3.9.1v.7l-3.9.8 1-.6-4 6.2-.8-.4 3.4-6.6.1-.2zm6.6.6 3.8.1v.7l-3.8.9 1-.7-4.1 6.2-.8-.4 3.4-6.5.2-.3z"
      />
      <path
        fill="none"
        stroke="#291c11"
        strokeMiterlimit={10}
        strokeWidth={0.5}
        d="M286.9 104.4s4.3-2.2 8.5-1.8"
      />
      <path
        fill="#291c11"
        d="M264.4 120.4c.8-.4 1.6-.4 2.4-.4a28.4 28.4 0 0 1 7.5.6c1.6.4 3.2 1 4.6 2a12.3 12.3 0 0 1 3.6 3.5l-.2.1a12 12 0 0 0-3.6-3.3c-1.4-.9-2.9-1.5-4.5-1.9a22.3 22.3 0 0 0-7.3-.5l-2.5.2z"
      />
      <path
        fill="none"
        stroke="#291c11"
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M265 114c-.8 1.5-.4 2.4 4 3.2 4.5.9 9.3 2.9 11.2-1.6"
      />
      <path
        fill="none"
        stroke="#291c11"
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M260.7 117.3c2-.2 4.2-1 6.3-.5m7 1.5c3 .6 6 1.5 6.6 3.4"
      />
      <path
        fill="#291c11"
        d="M265.8 120.6a64.7 64.7 0 0 1-36.2-1.6 70 70 0 0 1-8.2-4.1 134 134 0 0 1-7.8-4.9 158 158 0 0 1-14.5-11l.3-.4a224 224 0 0 0 14.9 10.4c5 3.3 10.3 6.3 15.8 8.6a48 48 0 0 0 17.6 3.3q9 0 18-.9z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.8}
        d="M456 137.6c9.4-3 11.2-18-10.3-26.8 0 0 7.8 23.3-8.4 26.8"
      />
      <path
        fill="#74948f"
        d="M317.5 463.3c1.1-2.1 4-8.4 6.3-8 2.5.2 5.2.3 6.7-2.5s8.7-12.4 12.3-13c3.7-.6 14.2-9.3 28.1-16 11.4-5.5 19.5-13 29.5-12.8 9.9.3 5.8 7.8 16.4 7.8 10.5 0 35.2 4.5 41.6 16.4a41.7 41.7 0 0 0 20 20c5.6 2.3 26.6 8.6 18.6 11.3-8 2.8-11.6 2.2-18.8 6.2a38 38 0 0 1-23.9 5.6c-9.5-1-10.6-1.6-14 .2-3.5 1.8-22.5 2.2-24.3 0-1.7-2.2-3.1 1.5-8 0-5-1.5-23.9 1.5-32.6-1.5-8.6-3-17.6-1.8-25.9-2-8.2-.3-34-8-32-11.8z"
      />
      <path
        fill="#3c4544"
        d="M451.8 428.3s8.7 15.9 7.7 21c-1 5.2-3 .7 5.5 5.2s16.5 4.9 11 6.4c-5.5 1.6-15.7-2-12.3 5 3.3 6.8 3 6.6-3.2 6.3-7-.4-15.7-3.7-20.2 1-4.5 4.6-13.6 6.8-13.6 6.8s10.8.3 13.5-1.5c2.8-1.8 8-1.3 15.2-.2a51.1 51.1 0 0 0 25.6-7c3.8-2.8 20.4-4.8 17.6-7a85.2 85.2 0 0 0-20.2-9c-8.6-2.8-15.6-12.5-17.8-16.3s-4.7-8.3-8.8-10.7"
      />
      <path
        fill="#202926"
        d="M353.2 462.8s4.8-1.6 8.1 2c3.4 3.7 9.7 10 16.4 10 6.6 0 11-1.1 14.1-3.8 0 0-9.1 2.6-13.6 1.7s-10.7-6.6-14.7-10.2c-4-3.7-10.3.3-10.3.3m45.5 5s6.8-1 10.1 1.5c3.4 2.5 10.7 8 14.4 5.5 3.6-2.5 18.3-9 18.3-9s4.4 4 4 4.9c-.3.8-.3 1.9 4.3 2 4.7.1 12.4 2 17.2 0s6.4-.3 5.8 1.3c-.5 1.6-3.4 2.7-3.4 2.7l7.1-3 7.2-3.5s-8.2-3.9-12-4.4c-3.9-.5-10.4-2.1-8 0 2.3 2.2-3 7.5-7 5-4-2.6-9.7-8.3-11.5-9.9-1.9-1.6-1.6-1.2-4 0-2.4 1.3-15.5 8.4-18 9.6a11 11 0 0 1-11.4-.5c-4.6-3-9.3-3.7-13.1-2.1z"
      />
      <g fill="#cfdcd9">
        <path d="M424.2 419.3c-4.8-.4-6 .9-2.5 2.5 3.5 1.7 4.6 6.9.2 8.2s-7.2 4.7-11.6 1c-4.3-3.7-7.5-7.8-7.5-7.8s2.5-.4 4.5-2.5c2-2.2 13-2 16.9-1.4" />
        <path d="M392.7 412.3s8.3-.3 10.1 3.5c1.9 3.9.7 6.9-4.1 5.9-4.9-1-6-.7-2.2 3 3.8 3.6 9.3 9 16.2 10.6 6.8 1.7 13.8 3.5 9.1 4.4-4.6.8-14.3-1.4-19-1.4-4.6 0-6.8 3-15 3.7-8.1.7-12.6 3.3-14 5.7-1.3 2.3 3.4.1 10.4.6s22.6 0 25.3 1.7 15.5 2.3 19.2 4.2c3.6 1.8 9.1 0 9.1 0s-1.5 1-7.3 5.7c-5.8 4.6-13.2 7.8-16.7 7-3.5-.9-15.8-8.2-18.6-8-2.9.1-16 6.4-17.9 7-1.8.4-14.3-6-18.8-8s-7.5 0-12.5 2a67 67 0 0 1-13 3.6c-1.2 0-4.2 1.7-6.5 1.7s-8.5.6-8.8-.7a23 23 0 0 1 2.7-6.4s1.4-3.1 6.3-2.8c5 .4 3.7-2.5 5.2-4.7 1.6-2.1 7.3-10.3 12.9-11.5 5.5-1.1 9.8-7.6 48-26.8" />
        <path d="M382.2 467.8c2.6-1.7 4.6-3.6 10.5-3.1 5.8.5 9 1.6 4.6 3.1-4.3 1.5-5 3.4-9.6 2.7-4.7-.7-7.6-1.3-5.5-2.7m-36.7 1.5c4.3.5 9-1 10.8-2.3 1.9-1.3 2.4-2.5-2.3-2.4-4.8 0-15.8 3.9-8.5 4.7" />
      </g>
      <path
        fill="#74948f"
        d="M363.5 430.7c4.6-1.5 4.3-3.3 12-1.3 7.8 2.1 7.8 2.4 10.3 3.3 2.5.8 5.7 2.3 0 2.5-5.8.3-4-1.5-8 1-4 2.6-9.8 3.2-12.5 3.6-2.8.5-9.4 2.2-11.3 1.5-2-.8-7.2-.3-9 1.3-1.7 1.7-6 .4 1.8-4.6 8-5 21.6-13 24.1-14.2 2.5-1.3-13.5 8.9-7.4 6.9m-33.7 23.1c3.7-1.3 6.6-2 4 0-2.5 2-8 4.1-10 3.2-1.9-1-2.1-1.6 0-1.8 2.2-.2 5-1 6-1.4"
      />
      <path
        fill="#202926"
        d="M334.8 446.7s-3 4.6-1 3.8 6.2-1.1 3.2.1-1.7 1.5-3.1 2c-1.5.4-4.4 1.6-4.4 1.6z"
      />
    </g>
    <path d="M500.8 414.6c.5-1 1-2.2 1.8-3.3.3-.5.7-1 1.4-1.4l.7-.2h1.4c.5 0 1 0 1.5-.3l.5-.5.2-.4.3-.4a31.6 31.6 0 0 1 4.7-5.8l1.6-1.1a3 3 0 0 1 1-.4l.8-.3 3.1-1.8 3.2-2c2-1.3 4.2-2.6 6.4-3.7a85 85 0 0 1 3.3-1.7 61 61 0 0 0 3.2-1.7c2.2-1.3 4.3-2.6 6.5-3.7 2.2-1 4.7-1.8 7.3-1.7l1.8.3 1.7 1 1.2 1.5c.4.4.8.8 1.4 1.1a7 7 0 0 0 3.4.7 51 51 0 0 1 18 4.3c2.2 1.1 4.3 2.6 5.7 4.7l1 1.6 1 1.6a30 30 0 0 0 2.1 3c1.6 1.8 3.4 3.5 5.5 4.8a17 17 0 0 0 3.3 1.5l3.5 1.2a73 73 0 0 1 3.5 1.4c1 .5 2.2 1 3.3 1.7l.7.8c0 .2.2.4 0 .7 0 .2-.1.4-.3.5a3 3 0 0 1-1 .5l-.8.3-3.6 1a22.2 22.2 0 0 0-6.8 2.6 22.3 22.3 0 0 1-14.5 3l-3.6-.5h-1.8a5 5 0 0 0-1.6.6c-.6.3-1.3.4-1.9.5a27 27 0 0 1-5.6.4 41 41 0 0 1-3.7 0l-2-.3a5.3 5.3 0 0 1-.9-.3l-.6-.3-.1-.2a1 1 0 0 0-.1 0 .3.3 0 0 0-.2-.1 1 1 0 0 0-.3 0l-.8.4c-.7.2-1.4.3-2 .2a6 6 0 0 1-1-.2 5 5 0 0 0-.9-.1 19 19 0 0 0-1.8-.1l-7.4.2a36.4 36.4 0 0 1-9.3-1 20 20 0 0 0-1.7-.4 25 25 0 0 0-3.6-.5h-9.3a18 18 0 0 1-1.9-.2l-3.6-.8a70 70 0 0 1-7.3-2.2 36.5 36.5 0 0 1-5.1-2.4 4.3 4.3 0 0 1-.8-.7 1.7 1.7 0 0 1-.4-.5l.1-.9zm.8.5a.8.8 0 0 0 .2.3l.6.5 1.5.8c1.1.6 2.2 1 3.4 1.4a69 69 0 0 0 7 2.1 48 48 0 0 0 7.2 1c2.5 0 5-.2 7.4 0a26.2 26.2 0 0 1 7.4 1.4c2.3.5 4.8.5 7.2.5 2.5 0 5-.2 7.4-.1a20 20 0 0 1 3 .2l.7.2c.6 0 1.1 0 1.7-.2l.8-.3.6-.1c.3 0 .5 0 .7.2l.3.3.1.1.3.1.8.3 1.7.2a40 40 0 0 0 3.7.1 47 47 0 0 0 3.7-.1 26 26 0 0 0 1.8-.3c.6 0 1.2-.2 1.6-.4a5.8 5.8 0 0 1 3.8-.6l3.7.4a21.4 21.4 0 0 0 14-2.8 23 23 0 0 1 7-2.6l3.6-1c.6-.1 1.2-.3 1.6-.6.2-.1.2-.2.1-.4a2 2 0 0 0-.5-.6 74 74 0 0 0-6.6-3l-3.5-1.3a17.5 17.5 0 0 1-3.4-1.6c-2.1-1.3-4-3-5.6-5a31 31 0 0 1-2.2-3 34 34 0 0 1-1-1.5c-.3-.6-.5-1.1-.9-1.6-1.3-2-3.3-3.5-5.5-4.6-2.2-1.2-4.5-2-6.9-2.6a50.6 50.6 0 0 0-7.2-1.4 37 37 0 0 0-3.7-.2c-1.2 0-2.5-.1-3.7-.7-.6-.4-1-.8-1.4-1.3l-1.2-1.4c-.9-.8-2-1.1-3.3-1.2-2.4 0-4.8.7-7 1.8-2.2 1-4.2 2.4-6.4 3.6a70 70 0 0 1-3.2 1.8 85 85 0 0 0-9.6 5.5l-3.2 2-3.2 1.9-1 .3a2 2 0 0 0-.7.3l-1.4 1a25 25 0 0 0-4.5 5.7 8 8 0 0 0-.3.4 4 4 0 0 1-.2.4 3 3 0 0 1-.8.8c-.6.4-1.4.5-2 .5a9 9 0 0 1-1 0h-.6c-.4.3-.8.7-1.1 1.2-.7 1-1.2 2-1.8 3.2" />
    <path
      fill="#74948f"
      d="M428 415.8c-.6-2-1.3-4.4-4.5-5.3-3.2-.8-2.5.5-4.3-2.7-1.7-3.2-6.7-10.5-12-12.4-5.2-1.8-4.8-9.5-11.5-11.7-6.8-2.3-19.4-2-24.7 2.4-5.2 4.5-14 2.7-16.6 5-2.8 2.4-6.4 14.5-12.3 15.5-5.8 1-15.3 3-14.9 6.2s6.2 6 10.1 5.8c3.9-.3 12.2 1.4 19 4.3 6.8 3 11-1 15.5 0s9.5 2.6 14.2 1.1c4.6-1.4 6.6-3 12.8-2.6s11.7.8 15.2 0c3.4-.8 14.7-3.4 14-5.6"
    />
    <path
      fill="#3c4544"
      d="M368.7 417.8s3.4-2 9-1.5c5.5.6 6.4 4 12 3.1 5.7-.7 4 2.6 0 2-3.9-.5-28.2-1.2-21-3.6"
    />
    <path
      fill="#cfdcd9"
      d="M365.8 395.4c1.2-2.5 6.2-10.3 7.7-8.6 1.4 1.8 8.8.5 12.2-.2 3.3-.8 3.5 4.2 4.5 4.4s4.6-.7 3 1c-1.6 1.8-2.6 3.6-3.6 3.4-1-.1 1 1.3 0 2.3s1.5 2.8-3.3 3.2a23 23 0 0 0-11.7 3.8c-2.6 2-6.7 1.9-8.8 3.5-2.2 1.6-1 1.5 2.4 1.3 3.5-.1 8.5-.7 10.2.7 1.7 1.5 4.2 2.8 6 2.6 1.7-.2 7.8 3.3 3 4s-14-1.5-16.8-1c-3 .4-6.9-.8-8 1.1-1.2 2-6.2.9-7.6.8-1.5-.2-.3 1.2 1.6 1.7 1.9.6 2 1.7-.9.9-2.9-.9-4.6-1.5-6.7-1.7-2-.2-5-.5-6-1.2-1-.8-4.7 1.5-2.1-1.3 2.3-2.7 7-4 7-4s.8-1.3 4.6-.1c3.8 1.1 4 2.6 7.4-4.7 3.4-7.2 5-10.2 5.9-11.9m23.4-12c1.3.7 1.4 1.5 3 1.5s3 1.7 1.4 1.6c-1.5-.1-3.4-1-4.4-1.5s-1.4-2.1 0-1.5z"
    />
    <path
      fill="#cfdcd9"
      d="M390.6 407.6c.7-1.7-5.4-4.2-8.9-3.5-3.4.8-6 1-3.3 1.7 2.6.7 5 1.2 7.1 3.6 2.2 2.3 3.6 2 5.1-1.8"
    />
    <path
      fill="#3c4544"
      d="M396.5 384s5.5 6.2 5.6 8.9-4.7 3.4 1 3.3c5.8 0 8.3 4 12 9.7 3.6 5.6 1.8 8.8 5.6 6.9s-.9 4.5-2.7 5c-2 .4-9.4 3.6-14.3 3.6-5 0 7.2.7 10.3 0 3-.7 15.2-3.5 13.8-6.2-1.3-2.8-1.5-3.7-3.7-4.4-2.3-.6-3.4-.3-4.1-1.7-.8-1.3-3.8-7.6-7.8-10.4s-6.6-3.7-7.7-5.2c-1-1.4-3.8-7.8-8-9.5M331 409.3s-4.2 1.5-3.9 3 3.2 4.4 5.2 5.4 4.6.9 4.6.9-10.8-3.5-5.9-9.3"
    />
    <path
      fill="#3c4544"
      d="M351.1 396.2c-1.4 7.4 2.5 14.5-6.6 13.1-9.1-1.3-15.9.8-12.4-.3 4-1.4 5.1-1 8.7-2.1 3.6-1.2 5.2-1.4 10.3-10.7m48.7 7.5c-3-1.4-5.6-3.2-7.5-3-2 .1 2.4-4 6.3-1 4 3.1 2.4 4.6 1.2 4"
    />
    <path
      fill="#cfdcd9"
      d="M369.3 389.9c-3 1.4-8.2 2.8-10.7 3.8s-6 4.3-2.1 5c3.9.6 5 2.8 3.3 5.3-1.8 2.5-3.5 4.2-2.3 3.8 1.1-.4 1 2.8-.5 4.6s3.5-4.9 9.8-13.8c6.4-8.8 2.5-8.7 2.5-8.7"
    />
    <path
      fill="#74948f"
      d="M369.4 394.6c-.8-4 4.7.6 7 .4 2.4-.2 2 .8-.7 2-2.7 1.1-3.9.4-5.2 1.6-1.4 1.3-.7-1.7-1.1-4"
    />
    <path d="M427.6 415.9a9.3 9.3 0 0 0-1.4-3.2 5.1 5.1 0 0 0-2.8-1.8 11 11 0 0 0-1.7-.3c-.3 0-.6 0-1-.2a1.5 1.5 0 0 1-.6-.3 3 3 0 0 1-.3-.5c-.7-1-1.2-2.1-1.8-3.1-1.3-2.1-2.7-4-4.3-5.9a19.7 19.7 0 0 0-5.6-4.5 10 10 0 0 0-.8-.3l-.8-.4a6.6 6.6 0 0 1-1.6-1c-1-1-1.6-2-2.3-3-1.2-2.2-2.2-4.4-4-6-1.9-1.5-4.4-2-6.7-2.4a39.3 39.3 0 0 0-14.4.4 15 15 0 0 0-6.5 3c-2 1.6-4.4 2.4-6.8 2.8-2.4.5-4.9.6-7.2 1-1.2.3-2.3.7-3 1.7l-1.9 3a81 81 0 0 1-3.5 6.5l-2.2 3c-.9 1-1.8 1.8-3 2.3l-1 .3-1 .2-1.7.3-3.5.8a45 45 0 0 0-3.5 1c-1.1.4-2.3.8-3.3 1.4a5 5 0 0 0-1.2 1l-.3.6a1 1 0 0 0 0 .3v.3a5 5 0 0 0 2 2.6 12.2 12.2 0 0 0 6.3 2.4h3.7c1.2.2 2.5.3 3.7.6a62 62 0 0 1 7.1 1.7 62 62 0 0 1 3.5 1.2l1.8.7 1.6.6a12.4 12.4 0 0 0 7 .4l3.5-.8a10 10 0 0 1 3.9 0c2.4.5 4.7 1.2 7 1.5 2.4.3 4.8.3 7-.4 2.3-.8 4.6-1.8 7-2.3 2.5-.5 5-.4 7.5-.2l7.3.3h3.6a19 19 0 0 0 1.7-.2l1.8-.4a103 103 0 0 0 10.4-3l1.5-.9c.3-.1.5-.3.6-.5zm1-.3v.7a1.7 1.7 0 0 1-.4.6 4 4 0 0 1-.8.7l-1.7.9-3.5 1.3a104 104 0 0 1-7 1.9c-.6 0-1.2.2-1.9.4l-1.8.2h-3.7c-2.5 0-5-.1-7.4-.3l-3.6-.1c-1.2 0-2.4.1-3.5.3-2.3.5-4.5 1.5-6.9 2.3s-5 .8-7.5.5l-7.2-1.5c-2.2-.5-4.5.3-7 .8a15 15 0 0 1-3.7.3 13.3 13.3 0 0 1-3.8-.7l-1.7-.7a54 54 0 0 0-1.7-.7 61 61 0 0 0-3.4-1.1 61 61 0 0 0-7-1.8 37 37 0 0 0-3.6-.4 19 19 0 0 0-1.8-.1h-1.8a13.3 13.3 0 0 1-7-2.7 8.3 8.3 0 0 1-1.5-1.4c-.4-.5-.8-1.1-1-1.8v-.6a2.2 2.2 0 0 1 0-.6c.1-.4.3-.7.6-1 .5-.6 1-1 1.6-1.3 1-.6 2.3-1 3.4-1.4a46 46 0 0 1 3.6-1l3.6-.7 1.8-.3 1-.2.7-.2a8 8 0 0 0 2.8-2l2.2-2.9a95 95 0 0 0 3.7-6.3c.6-1 1.1-2.1 2-3.1l.6-.7a3.8 3.8 0 0 1 .8-.5l1.8-.6 3.6-.5 3.6-.5c2.4-.4 4.7-1.2 6.6-2.7 1.9-1.7 4.3-2.6 6.6-3.2a34.6 34.6 0 0 1 14.7-.4c1.2.2 2.4.4 3.6.8s2.3 1 3.3 1.7c1 .8 1.8 1.8 2.4 2.9l2 3.1c.5 1 1.2 2 2 2.8l1.5 1 .8.3.9.4a23 23 0 0 1 5.8 4.6 43 43 0 0 1 4.4 5.9c.7 1 1.2 2.2 1.9 3.1.1.3.3.4.4.5h.8l1.9.4c1.2.3 2.4 1 3.2 2.1.9 1 1.3 2.3 1.7 3.5" />
    <path
      fill="#202926"
      d="M421.7 411.7c-1.9-.2.4.5-3.4-5.6a98 98 0 0 0-19.4-20.6c-5-3.3-6-.9-7.5-1.4-1.6-.5 1.6 1.4 2 2 .2.6-1.4 2.1 2.7 2.9 4.2.7 1.6 1.8.7 3.6-.8 1.8 2.5 2.7 3.7 3 1.1.3 2.3 2.1 1.7 3-.6 1 3 1.2 5 .8s6.2 4.1 7.7 4.7c1.4.5 3.2 2.3 3 3.4 0 1.2-2.2-.8-2.8-1.4-.7-.5-3-.6-4-.8-1.1-.2-1.2 1.6-.6.8.5-.8 1.2.8 2.8.6 1.6-.1 2 1.2 3.7 2 1.6 1 1 2.7 0 2.4s-2 1-4.2.6-2 0-3.1 0c-1.3-.1-4.3.4-6 1-1.5.8-3.9-.7-5.4-.4-1.6.3-2.8.8-1.5 1.6 1.4 1 3.3 0 4.4.2 1 .2 3.4.3 4.7 0 1.4-.3 6.2-.2 8 .6 1.9.8.3 2 0 2.3-.2.4-3.8-.4-5.3-.8-1.5-.5-4.1 1.4-5.6.8s-2.5-.5-4.2.9-4.5-.5-8 .7c-3.3 1.1-7.3.6-7.3.6-2.8.8 8 .5 11.6 1 3.5.5 3.8-1.3 4.1-1.6.4-.3 2.5-1.4 3.3 0 1 1.3 2.5.4 4.6-.4 2-.8 2.5 0 3.7.4s5.2-.3 7.8-.6c2.7-.3 1.3.2-1.6 1.4-3 1.3-4 2.2 0 1 4-1.3 11-1.8 10.6-5.3-.4-2.3-4-3.2-5.9-3.4"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-Z)"
      d="M97 396.3c1.2-.7 1-4.5.7-8.7-.3-4.3-3.2.5-4.2-1.9s-3.4-3.1-3.4 0-6.4 1.5-2.8 5.3 8 6.5 9.8 5.3z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-aa)"
      d="M20.6 450.5c1.4 3.2-6.3 7.7-7.7 8.2-1.3.5-3.3.6-2.3-1 1-1.4-2.3-1-4.9-.7-2.6.4-5-.8-3.1-2.2 1.8-1.4 1-2.2-.7-2.8s-.8-2.6 2.4-2.4c3.3.1-.9-2.6 4.1-2.1s-.6-4.5 3-3.3a20 20 0 0 1 9.2 6.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ab)"
      d="M22.2 449.6s-6.3-5.7-6.5-7.8c-.3-2-.2-4.2 1.1-2.7s-.2-1 1.1-3.9c1.3-2.8 2.8-2.4 2.9 0 0 2.4.9 4.3 1.4 3.3s3.9-.8 3.2.6c-.6 1.4-.4 5.6.1 3.9.6-1.7 1.1-1 .7.9l-1.1 4.4s-1.3 1.6-2.9 1.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ac)"
      d="M37 450.6s-11.2 4-12.8 6.3c-1.5 2.3-2.7 4.9-.3 3.6 2.5-1.2-.8 1.1-1 5-.1 3.7 2 3.8 3.5 1 1.6-2.7 3.8-4.5 3.8-3.1 0 1.3 4.3 2.5 4.3.6.1-1.9 2.9-6.7 2.5-4.5-.4 2.3.8 1.6 1.3-.8l1.3-5.4s-.5-2.4-2.7-2.7z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ad)"
      d="M32.1 448.5s-2.7-2-3.6-4.5c-1-2.5.4-2.5 1.4-1.6 1 1 .8-2.4 1.5-4.6.6-2.1 1.8-2 1.9 0 0 2 1.4 7.4 1.7 5 .4-2.3 1.8 1.2 0 3.4-1.6 2.1-2.1 3-2.9 2.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ae)"
      d="M99.9 399.1s-.4-6.7 2.6-8c3-1.4 2 2 2.8 1.7a22 22 0 0 1 6.3-.8c2.7 0 1.7 2.7.7 3.7s-3.2 3.3-2.2 3c1-.4 3 2-1 2.7-4 .6-7.2.2-9.2-2.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-af)"
      d="M98 400.3s-5.3-1-9.4-.5c-4.2.6-3.1 1.1-.4 1.8 2.7.8 1.3 1.4-1 2.8-2.2 1.4-3.6 5 0 3.9 3.7-1 3.4 1.2 3 2.7s-.3 3 1.9 1c2.1-2 10-11 5.8-11.7z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ag)"
      d="M123.4 400.3s-6.7-2.6-7.4-4.6c-.6-2 5.2 1.1 3.7-1.7s-1.9-7.7 0-5.8c1.8 1.8 3-2 2.8-3.7-.1-1.7 2.3-4 2.8-.9.6 3.2.9 4.8 1.7 3.1.9-1.7 4-1.7 3.3.9-.8 2.6-2.6 4.6-1 3.6 1.7-1 1.7 1.1 0 2.8-1.6 1.7-1.8 3-3.1 4s-1.2 3-2.8 2.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ah)"
      d="M133.4 392.6c.1-4-.7-5.8-1.9-8.7-1.1-2.9.6-6.9 1-5.5.4 1.3.8-3 2.5-4.4 1.7-1.3 2.7.2 2.5 2.2-.1 2-.1 3.6 1 2.4 1-1.3 3.8-.4 3 1.2-.8 1.5 1.5 4.8 1.7 1.7.2-3.2 2.1-10 3-8 1 2 3.3.3 5-1 1.8-1.2 2.4 1.3 2.1 2.3s-1.6 3.5 0 3c1.7-.6 2.7.4 1.6 2a14.4 14.4 0 0 1-5.5 4.1c-1.4.3-3.2 2.5 1 2.3 4.1-.2 4.5 3.7 2.3 3.2-2.2-.6.7 2.3 2.7 1.5 2-.9 6.3.6 1.7 2.3-4.6 1.6 1.8 3.7-4.2 4-6 .2-13.2 2-16.5 0-3.4-2-3-4.6-3-4.6"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ai)"
      d="M137.7 403.7c2.6-.2 5.4-4.4 7.6-4 2.2.2 4.4.5 1.7 1.8-2.7 1.2-.7 2.7 2.5 2 3.2-.5 7.6 0 5.6.4-2 .5-1.3 1.9.2 1.9s1.8 3.9-.5 2.7-8-.7-6.2.6c1.9 1.3-.1 3-1.8 2s-6.7-4.3-4.7-2.5c2 1.7 1.5 4.8-2.2 1.5-3.6-3.3-10.7-6-2.2-6.4"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-aj)"
      d="M150.4 423.6c2.3.7 4.3.7 3-.4-1.3-1 0-1.4 3.3 0 3.4 1.4 2-2.2-1-2.7s.3-1.5 2.7-1.6c2.4 0 .6-1.7-2.1-1-2.8.8-2-2 1-5 3-2.8-.8-1.9-4 1.4-3 3.4-2.1 1.9-2-.6 0-2.5-1.1-2-1.7-.7-.5 1.2-.4 4.2-.9 2.5s-1.3.3-.7 3.4c.1.7-2.7-2.7-2.4-.3.2 2.3-1.1 2.2-1.1 4.7s0 4.4 2.3 3c2.2-1.3 4.6-.7 3.6-2.7"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-ak)"
      d="M163.2 418c1.2-3.6 3.3.1 2.1 1.8-1.1 1.7 1.4 3 3.7.7 2.4-2.3 7.1-1.1 4.5 1.3s-1 1.5 2 1.4c3 0 7.4.6 5 1.9-2.3 1.2-2.5 1.9.7 2 3.2.2 5.2.6 5.5 2 .3 1.6-.8 1.8-2.7 2.2-1.8.4.4 1.6 1 4.2.7 2.7.4 1.8-2.3 1.7-2.7 0-2.7.5-2.5 1.8s-.7 3-2.3 1.1c-1.5-2-3.2-2.3-3.2-1 0 1.4-1.6 4.4-3.2 2.3-1.7-2-3.1.2-3.2.7-.1 1.9-2.4.4-4.2-2-1.9-2.3-2.7-4.5-3.2-2.9-.5 1.7-.4 1.2-1.8-1.7-1.3-2.9 0-6.2-3.9-7-3.9-.7-2.4.4-.8-1.7 1.7-2.2 5.8 0 8.8-8.9z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-al)"
      d="M140.7 433s5.5 3.6 2.4 5c-3.2 1.4-5.8 3.8-3.2 3.8 2.7 0 6 .3 2.8 2.2-3.3 1.9-1.5 6.3 0 5.1 1.5-1.1 1.7.5 1.3 3.4-.3 2.9 3.7 6.9 3.7 2.6 0-4.2.5-7 1.5-3.6s6.5 6.6 4.5 2-1.3-7.6.4-5.4c1.7 2.3 5.6 4.8 4.1 1.3s-4-6.3-1.5-5.4 9.7 2.2 4.2-1-6.4-3.9-4.2-3.7c2.2 0 2.6-1.2-1.5-2-4.1-1-1.4-3.7-6-4.3s-10.4-1.6-8.5 0"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#174520"
      d="M326.8 407.3s-3.2-1.8-2.5-1c.6 1-4.2.5-2.8 1.2 1.4.8.6 1.2 0 1.7-.7.5-.3 1.1.7.5s2-.9 2-.3 2.2-1.1 2.6-2.1m2.5-1.8s-1.4-.8-2-2c-.6-1.4.1-1.1.4-.7.2.5 0-1.2 0-2.3.1-1 1-1.3 1-1.3s.3 2.3.6 2.7c.3.3 1.2 2.2 1.4 1.4.3-.8-.5 2.4-.5 2.5zm6 .8-.8-1.7c-.1-.3.5.6.4-.3 0-1 .5-.9.5.1-.1 1 0 .6.4.3s-.4 1.6-.4 1.6zm1.3 2.5s-3.6 1.5-4.8 2.5c-1.3 1-1.4 1.2-.5 1 1-.3-.3.5-.6 1.4-.3 1-1.8 4.3-.9 2.9 1-1.4 3-3.1 4-3.5.8-.3.4.9.7 0 .4-1 1.6-2.4 2.1-3.1.5-.8 0-1.2 0-1.2m36.8-30.1s-2.1-.4-3.4-.3c-1.3 0-1.8.4-.6.7 1.2.2 1.9.7 1 1.4-1 .7-.5 2.7.3 1.8s2.1 0 2.7-3.6m-.9-4s.5-3.6 0-3c-.4.5-2.5-1.9-2.5-1.2 0 .6-1.2 1.4-1 2a10 10 0 0 0 2.4 2.2c1 .6 1.1 0 1.1 0m2.3 3s1.2-4.2 1.3-3.6c0 .7.2.7.8.6.6 0-.2.8.5.5.6-.3 5-1.8 2.9-.7-2.2 1.1-3.4 2.3-2.2 2.2 1.2-.2 1 1.5 1.6 1.5.7 0-2.6 1.8-4.9-.6zm13.7.7s-1.4-1.4-1.3-2.5.9-1 .7-2c-.3-1 .2-1.5.3-2.9 0-1.3.5-.5.6.6 0 1 1 1.2.8 2-.2.7 2 1.6-1.1 4.8m6.4-4s0-3.5-.5-4.6c-.6-1 .4-.8.5-.6 0 .2 0-3.2.5-1.5.4 1.7 1.5.4 1.4 1.3-.2.8.5 1.6 1.2 1 .8-.4 1.3-1.7 3.6-2.8 2.3-1 3-.6 2.3 0-.8.5-3.7 2.7-3.4 3.5s3.3 0 2.2 1.2c-1 1.3-4.8 1-2.6 1.1 2.2.2.2 1.6-1 1.4-1-.3-3.4.7-2.3 1.2 1 .4 1.1 2-.3 1.3-1.4-.8-2-.8-1.6-2.5m3.4 6.4s1.5-1.3 1.4-.8c0 .4-1.4 1 0 .9 1.5-.1 3 .3 4 .5.7.2-1.2.3-.5.4s-3 0-2.1.7c.8.7-4.4-1.2-3.3.3 1 1.6-3.7-1.8.5-2m2.6 17.6s.7 1.1 0 1.9c-.7.7-1.4.8-.4 1 1 .1 2.2-1 1.7.3-.6 1.4-1 2.8.1 1.4 1-1.5-.2 3 .5 1.7s.7 4 1 2 1.8-2.7.7-3.7c-1-1 1.5-1 .5-1.6-1-.7-.2-1.8-.8-1.7-.6.2-2.7-2.2-3.3-1.3m8.3-4.8s2.3-1.5 2-1c-.3.4 3-.9 2-.2-1 .6 4.6.6 3 1-1.6.2 5.2 1 3.4 1.1-1.7.2 2.9 1.4 1.5 1.6-1.5 0-1.8.2-1.4 1.2.3 1-1.3 1.3-2.5.2-1.3-1-1.5 1.7-2-.2-.3-1.9-1.6 1-2-.5-.4-1.6-1.7.7-1.8-.6 0-1.3-1.5 0-1 1.3.6 1.5-1.1-1.5-1.2-3.9m-7.6-.6s.5-2.7 1.7-3.6 2.1-.6 1.6-.2c-.6.4-.5 1.2 0 1.2s.5.7-.7.7c-1.3 0-2.4 1-1.6 1 .8.2.2.8-1 1z"
      opacity={0.2}
    />
    <g stroke="#174520" strokeMiterlimit={10}>
      <path
        fill="none"
        strokeWidth={0.3}
        d="M373 376c.5-.4.4-2.6.3-5.1-.2-2.5-1.9.3-2.4-1-.6-1.5-2-2-2 0 0 1.7-3.8.8-1.7 3s4.7 3.8 5.7 3zm-44.6 31.5c.9 1.9-3.6 4.5-4.4 4.8s-2 .3-1.4-.6-1.3-.6-2.8-.4c-1.6.2-3-.5-1.9-1.3s.6-1.3-.3-1.6c-1-.4-.5-1.6 1.4-1.4 1.9 0-.5-1.5 2.4-1.3 2.9.3-.4-2.6 1.7-1.9 2.5.8 5 2.9 5.3 3.7zm1-.5s-3.7-3.3-3.8-4.6c-.2-1.2-.1-2.4.6-1.5.8.8 0-.6.7-2.3s1.6-1.4 1.6 0 .6 2.5.9 2c.3-.7 2.2-.6 1.9.3-.4.8-.3 3.2 0 2.2s.6-.5.4.6l-.7 2.5s-.7 1-1.6.8zm8.5.5s-6.4 2.4-7.4 3.7c-.9 1.4-1.6 2.8-.1 2.1 1.4-.7-.5.7-.6 2.9 0 2.2 1.1 2.2 2 .6 1-1.6 2.2-2.6 2.2-1.8s2.5 1.4 2.5.3c0-1 1.7-3.8 1.5-2.5-.2 1.2.4.8.7-.5l.8-3.2s-.3-1.4-1.6-1.6zm-2.8-1.2s-1.5-1.1-2-2.6c-.6-1.4.1-1.5.7-1 .6.6.5-1.3.9-2.6.4-1.2 1-1.2 1.1 0 0 1.2.8 4.3 1 3 .2-1.4 1 .6 0 1.9-1 1.2-1.2 1.7-1.7 1.3zm39.4-28.7s-.2-4 1.6-4.7c1.7-.8 1.2 1.2 1.6 1 .4-.1 2-.4 3.6-.4s1 1.5.5 2.1c-.6.6-1.9 2-1.3 1.7.6-.2 1.7 1.3-.6 1.6-2.3.4-4.2.2-5.4-1.3zm-1.1.7s-3-.6-5.4-.3-1.8.7-.2 1c1.5.5.7.9-.6 1.7s-2.1 2.8 0 2.2 2 .7 1.7 1.6c-.2.9-.2 1.8 1 .6 1.3-1.2 6-6.4 3.5-6.8zm14.8 0s-3.9-1.5-4.3-2.7c-.3-1.2 3 .7 2.2-1-.9-1.6-1.1-4.4 0-3.4 1 1.1 1.7-1.1 1.6-2 0-1 1.4-2.5 1.7-.6s.5 2.8 1 1.8c.4-1 2.3-1 1.8.5-.4 1.5-1.5 2.7-.5 2.1s1 .6 0 1.6-1 1.7-1.9 2.3c-.7.6-.7 1.8-1.6 1.4zm5.8-4.5c.1-2.3-.4-3.3-1-5-.7-1.7.3-4 .5-3.3.2.8.5-1.7 1.5-2.5s1.5.1 1.4 1.3c0 1.1 0 2 .6 1.4.6-.8 2.2-.3 1.7.6-.4 1 1 2.9 1 1 .1-1.8 1.3-5.8 1.8-4.6.6 1.2 1.9.2 3-.5 1-.8 1.3.7 1.1 1.3-.1.6-.9 2 0 1.7 1-.4 1.6.2 1 1.1a8 8 0 0 1-3.3 2.5c-.7.1-1.8 1.4.6 1.3s2.6 2.2 1.4 1.8c-1.3-.3.4 1.4 1.5.9 1.2-.5 3.7.4 1 1.3-2.6 1 1.1 2.2-2.4 2.4-3.5.1-7.7 1.2-9.6 0-2-1.1-1.8-2.7-1.8-2.7zm2.5 6.4c1.6 0 3.2-2.5 4.5-2.3s2.5.3 1 1c-1.6.8-.5 1.7 1.4 1.3 1.8-.4 4.4-.1 3.3.2-1.2.3-.8 1 0 1 1 0 1.1 2.4-.2 1.7s-4.7-.5-3.6.3c1 .7-.1 1.8-1 1.2-1-.6-4-2.5-2.8-1.5s.9 2.8-1.3.9c-2-2-6.2-3.5-1.3-3.8zm7.4 11.6c1.4.5 2.5.5 1.8-.2-.8-.6 0-.8 2 0 1.9.8 1-1.3-.7-1.5-1.7-.3.2-1 1.6-1s.3-1-1.3-.6c-1.6.5-1-1.2.7-2.8 1.7-1.7-.5-1.2-2.3.8-1.9 1.9-1.3 1-1.3-.4 0-1.5-.6-1.2-1-.4-.2.7-.2 2.4-.5 1.4s-.7.2-.4 2c.1.4-1.5-1.5-1.4-.2.2 1.4-.6 1.3-.6 2.8 0 1.4 0 2.5 1.3 1.7 1.3-.7 2.7-.4 2.1-1.6z"
      />
      <path
        fill="none"
        strokeWidth={0.3}
        d="M411.4 388.5c.7-2 1.9.2 1.2 1.1-.6 1 .8 1.8 2.2.5 1.3-1.4 4.1-.7 2.6.7-1.6 1.4-.6.9 1.1.8 1.8 0 4.3.4 3 1.1-1.4.7-1.5 1.1.3 1.2 1.9.1 3 .3 3.2 1.2s-.4 1-1.5 1.2c-1 .2.2 1 .6 2.5s.2 1-1.4 1c-1.5 0-1.5.2-1.4 1 0 .8-.5 1.8-1.4.7-.9-1.2-1.8-1.4-1.8-.6s-1 2.5-2 1.3c-.9-1.1-1.7.1-1.7.4-.1 1.1-1.4.2-2.5-1.1-1.1-1.4-1.6-2.7-1.9-1.7-.2 1-.2.7-1-1s0-3.7-2.3-4.1c-2.2-.4-1.4.2-.4-1 1-1.3 3.3 0 5-5.2zm-13.1 8.8s3.2 2.1 1.4 3c-1.9.7-3.4 2.1-1.9 2.1 1.6 0 3.5.2 1.6 1.3-1.8 1.1-.8 3.6 0 3 1-.7 1 .3.8 2-.2 1.6 2.2 4 2.2 1.5s.2-4 .8-2.1c.6 2 3.8 3.8 2.6 1.1-1.1-2.7-.7-4.4.3-3 1 1.2 3.2 2.7 2.4.6-1-2-2.3-3.6-.9-3 1.4.4 5.6 1.2 2.4-.7-3.1-1.9-3.7-2.2-2.4-2.2 1.3.1 1.5-.6-.9-1.1s-.8-2.1-3.5-2.5-6-1-5 0z"
      />
      <g strokeWidth={0.5}>
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-am)"
          d="M91.9 386.6c-.2-.6-.3.1-.3.1 2.3 7 5.9 13.2 9 19.9.7 1.7 2.7 7.3 3.6 9l1.2 2.4 2.3-4.4-4.6-8c-3.4-6.5-11-18.5-11.2-19z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-an)"
          d="M175.4 430a56.8 56.8 0 0 0-28.6-2.8s.5-2.6 2.4-5.2 2-3.4 0-1.7c-2 1.8-4.7 7.3-4.7 7.3h.1c-12 2.4-19.3 8-19.3 8l1.4 2.6s.4-2.2 10.5-5.5c12.1 1.3 12.6 7.2 12.5 10.8 0 3.6 1.2 7.3 1.2-1.6 0-8.8-10.6-10-10.7-10.1l5-1.4c20-5.1 43 4.3 30.2-.3zm-38.1 2.7 2.8-.9z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-ao)"
          d="m124.8 409 .5-.4c3-2.6 11.4-2.6 14.4-3 3.3-.3 9.8-.3 4.3-.8a46 46 0 0 0-16.1.8v.1l5-6c4.6-5.8 12.9-17 13.4-18 .4-.8-.5-.3-.5-.3-4.8 5.6-9.9 11-14.8 16.3-1.9 2-3.7 4-5.6 5.8 0-.2.4-2.1.5-6.1.2-4.3-2.8-10.3-1.8-5.8 1 4.4-.1 13.2-1.4 14.5a69 69 0 0 1-7.5 6.3c-1.4 1-2.9 1.9-4.3 2.4l1.5 3.9c2-.8 3.6-1.9 5.2-3 2.6-2 4.9-4.1 7-6.4v.1zm-1.4-3.5-.4.3 1-.9z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-Y)"
          d="M24.8 449.4s-2.5-4-3.3-6c-.7-2-2-3-1 .5 1.2 3.5 2.8 5.6 2.8 5.6h.3c-9.7.8-13 2-14.6 2.5s-1.8.8 4.4 0c6.3-.8 29.9-1.3 33.6-.8l1-2.3c-5 .2-20.1.2-23.4.5z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
      </g>
    </g>
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-X)"
      d="M413.4 400.2c-1.2-.4-2.2-4-3.1-8.2-1-4.2 3.1-.5 3.4-3 .2-2.6 2.3-4 3.3-1s6.5-.5 4.2 4.2-5.7 8.5-7.8 8"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-W)"
      d="M346 430.5c.4 3.5-8.3 5.6-9.7 5.7-1.5 0-3.4-.5-2-1.7 1.4-1.1-1.9-1.6-4.5-2-2.6-.5-4.5-2.4-2.3-3.2 2.2-.7 1.6-1.7.2-2.8-1.5-1.1 0-2.7 3-1.6s0-2.7 4.5-.8c4.7 2 .7-4.5 3.9-2.3a19 19 0 0 1 6.9 8.7"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-V)"
      d="M347.8 430.1s-4.3-7.2-4-9.3c.4-2 1.1-4.1 1.9-2.3s.1-1 2.2-3.4c2-2.3 3.3-1.5 2.7.8-.6 2.4-.4 4.4.4 3.6s4 .4 3 1.5c-1 1.2-2.1 5.3-1.1 3.8s1.3-.6.3 1l-2.3 3.9s-1.6 1.2-3.1.4"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-U)"
      d="M361.6 435.4s-11.8.6-14 2.3c-2.2 1.8-4 3.9-1.3 3.4s-1.2.8-2.4 4.4c-1.3 3.6.7 4.3 3 2.1s5-3.3 4.5-2c-.4 1.3 3.4 3.7 4 2 .6-1.9 4.7-5.7 3.6-3.6-1 2 .3 1.6 1.6-.4l2.8-4.9s.2-2.4-1.8-3.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-T)"
      d="M357.6 432s-2-2.7-2.2-5.4 1.1-2.3 1.8-1.1 1.5-2.1 2.8-4c1.3-1.8 2.3-1.4 1.8.6s-.8 7.5.2 5.3c1-2.1 1.4 1.6-.9 3.2s-3 2.2-3.5 1.4"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-R)"
      d="M411.6 403.7s-1.7-6.6-5-7c-3.2-.4-1.3 2.6-2.1 2.5-.8 0-3.6.3-6.2 1.1s-.9 3.1.4 3.7c1.2.6 4 2.3 3 2.2-1 0-2.3 3 1.7 2.3 4-.6 7-1.9 8.2-4.8"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-Q)"
      d="M413.8 404.2s4.6-2.6 8.8-3.2c4-.7 3.3.1.9 1.6s-1 1.7 1.6 2.3c2.6.7 5 3.7 1.2 3.8-3.8 0-2.8 2-2 3.4s1.2 2.8-1.5 1.5c-2.6-1.2-12.8-7.6-9-9.4"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-P)"
      d="M383.4 401.2s6.7-2.6 7.4-4.6c.6-2-5.2 1.1-3.7-1.7s1.9-7.7 0-5.9c-1.8 1.9-3-2-2.8-3.6.1-1.7-2.3-4-2.9-.9-.5 3.2-.8 4.8-1.6 3.1-.9-1.7-4-1.7-3.3.9.8 2.6 2.6 4.6 1 3.6-1.7-1-1.8 1.1 0 2.8 1.6 1.7 1.8 3 3.1 4s1.2 3 2.8 2.3"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-O)"
      d="M373.4 393.5c-.1-4 .7-5.8 1.9-8.7 1.1-3-.6-6.9-1-5.6-.4 1.4-.8-3-2.5-4.3s-2.7.2-2.5 2.2c.1 2 .1 3.6-1 2.4-1-1.3-3.8-.4-3 1.1.8 1.6-1.5 5-1.7 1.8s-2.1-10-3-8c-1 2-3.3.3-5-1-1.8-1.2-2.4 1.3-2.1 2.3s1.5 3.5-.1 3c-1.6-.6-2.6.4-1.5 2 1.2 1.5 4.2 3.9 5.5 4.1 1.4.3 3.2 2.5-1 2.3-4.1-.2-4.5 3.7-2.3 3.2 2.2-.6-.7 2.3-2.7 1.5-2-1-6.3.6-1.7 2.3 4.6 1.6-1.9 3.7 4.1 4 6 .2 13.3 2 16.6 0 3.4-2 3-4.6 3-4.6"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-N)"
      d="M369.1 404.5c-2.7 0-5.4-4.3-7.6-4s-4.4.6-1.7 1.8c2.7 1.3.7 2.8-2.5 2.2s-7.6-.2-5.6.3 1.3 1.9-.2 1.9-1.8 3.9.5 2.7c2.2-1.2 8-.7 6.2.6-1.9 1.3.1 3 1.8 2s6.7-4.3 4.7-2.6c-2 1.8-1.5 4.9 2.1 1.6 3.7-3.3 10.8-6 2.3-6.5"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-M)"
      d="M487.2 446.1c1.9.2 3.4-.2 2.2-.8s-.2-1 2.6-.6c2.8.5 1-2-1.3-1.9-2.4.2 0-1.2 1.8-1.6 1.8-.5.2-1.5-1.8-.4-2 1-1.8-1.3 0-4 1.7-2.8-1-1.4-2.9 1.7-1.8 3.1-1.3 1.8-1.7-.1-.4-2-1.2-1.4-1.4-.3s.4 3.3-.2 2.1c-.7-1.2-1 .5 0 2.8.3.5-2.5-1.6-1.9.1.6 1.8-.4 2 0 3.9.5 1.9.8 3.3 2.3 1.9 1.5-1.5 3.4-1.4 2.3-2.8"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-b)"
      d="M496 439.5c.3-2.9 2.5-.4 2 1.1-.6 1.5 1.5 2.1 3-.1 1.3-2.2 5.2-2.1 3.6.2s-.5 1.3 1.8.7 5.7-.8 4.1.6c-1.5 1.3-1.6 1.9.9 1.4 2.5-.4 4-.5 4.6.6.5 1-.4 1.5-1.7 2-1.3.7.5 1.2 1.5 3.1 1 2 .6 1.4-1.5 1.8-2 .4-2 .8-1.6 1.8s0 2.5-1.5 1.2c-1.6-1.2-2.9-1.2-2.7-.2.3 1-.4 3.6-2 2.4-1.6-1.3-2.4.6-2.3 1 .2 1.5-1.8.8-3.6-.7-1.9-1.5-2.9-3-3-1.7 0 1.4 0 1-1.6-1-1.5-2-1.2-4.8-4.3-4.7-3 .1-1.7.8-.8-1.1.8-2 4.4-1 5-8.4z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-K)"
      d="M481.4 455s4.9 1.8 2.7 3.4c-2.1 1.7-3.7 4-1.7 3.5s4.7-.8 2.5 1.2c-2.1 2 0 5 1 4 .9-1.2 1.3 0 1.5 2.3.3 2.2 4 4.6 3.3 1.3-.7-3.2-.9-5.4.5-3s6.2 4 3.8.7c-2.3-3.2-2.3-5.6-.6-4.2 1.7 1.5 5 2.7 3.3.3s-4.1-4.1-2-3.9c2 .3 7.7 0 3-1.5-4.8-1.5-5.6-1.8-3.9-2.1s1.8-1.3-1.5-1.3-1.7-2.5-5.4-2.2c-3.6.4-8.2.7-6.5 1.5"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#174520"
      d="M516.2 395.2s-2.5-2.6-2.2-1.6c.4 1-4-.8-3 .3 1.2 1.1.3 1.2-.5 1.6-.8.3-.5 1 .6.7 1.2-.3 2.2-.3 2 .3-.1.6 2.4-.5 3.1-1.3m3-1s-1.2-1.2-1.4-2.6.4-1 .5-.4c.1.5.4-1.1.8-2.2.4-1 1.2-1 1.2-1s-.3 2.3-.1 2.7.4 2.5 1 1.8l-1.3 2.3zm5.5 2.5-.3-1.8c-.1-.3.2.7.5-.2.2-1 .7-.7.3.2-.3 1 0 .6.4.4.4-.1-1 1.4-1 1.4zm.4 2.8s-3.9.4-5.3 1c-1.5.6-1.7.8-.7.8s-.5.4-1 1.2c-.6.8-3 3.5-1.8 2.5 1.3-1.1 3.8-2.1 4.8-2.2 1 0 .2 1 .8.2s2.2-1.8 3-2.4c.6-.5.2-1 .2-1zm32.1-18.6s2-1 3.2-1.2c1.2-.4 1.8-.2.8.4s-1.6 1.2-.5 1.7c1.1.4 1.2 2.4.2 1.8s-2 .6-3.7-2.7m-.3-4s-1.5-3.3-1-3c.7.4 2-2.4 2.2-1.8s1.6 1 1.5 1.6c-.2.7-1 2-1.7 2.8-.6.9-1 .3-1 .3zm-1.3 3.4s-2.4-3.6-2.3-3c.2.8 0 .7-.6.9-.6.1.4.7-.3.6-.6-.1-5.4-.2-3 .2 2.5.4 4 1.2 2.8 1.4s-.5 1.8-1.2 2c-.6 0 3 .8 4.6-2zm-16.4-1.4s1.3-1.4 1.2-2.5c0-1.1-.8-.9-.6-2 .2-1-.3-1.5-.3-2.8 0-1.4-.6-.6-.6.5s-1 1.2-.8 2c.2.7-2 1.6 1 4.8zm-6.4-4s-.1-3.4.5-4.5c.5-1.2-.4-1-.5-.7s0-3.2-.5-1.5-1.6.5-1.4 1.3c.1.8-.6 1.6-1.3 1.1s-1.2-1.8-3.5-2.8-3-.7-2.3-.1c.8.5 3.6 2.7 3.4 3.5-.3.8-3.3 0-2.3 1.2 1 1.3 4.8 1 2.6 1.2-2.1.1-.2 1.5 1 1.3 1.1-.3 3.4.7 2.4 1.2s-1.1 2 .2 1.3c1.4-.8 2-.8 1.7-2.5m-3.5 6.4s-1.5-1.3-1.4-.8c.1.4 1.5 1 0 .9-1.4-.1-3 .3-3.9.5-.8.2 1.2.3.5.4s2.9 0 2 .7c-.7.7 4.5-1.2 3.4.3-1 1.6 3.7-1.8-.6-2m69.3 29.2s.8.7.4 1.4c-.4.8-1 1-.1.9.8 0 1.5-1.2 1.3 0-.2 1.1-.2 2.2.3 1 .6-1.3.4 2.4.7 1.2.3-1.1 1.3 2.9 1.2 1.3s.9-2.3-.2-3c-1-.6 1-1 .1-1.2-1-.4-.5-1.4-1-1.1-.3.2-2.3-1.3-2.7-.5m5.6-5.1s1.4-1.6 1.3-1.2 2.2-1.2 1.5-.5 3.7-.3 2.5.2 4-.1 2.8.3c-1.3.5 2.4.6 1.4 1-1 .3-1.3.4-.9 1.1.5.8-.7 1.2-1.8.7-1.2-.6-1 1.5-1.5.1-.6-1.3-1.1 1.1-1.7 0s-1.2.8-1.5-.1c-.3-1-1.2.2-.5 1.2s-1.2-1-1.6-2.8m-6 .9s0-2.2.7-3.1c.8-.9 1.5-.8 1.2-.5-.4.4-.2 1 .2 1s.5.4-.4.6c-1 .3-1.7 1.2-1 1.1.6 0 .3.5-.7.9"
      opacity={0.2}
    />
    <g stroke="#174520" strokeMiterlimit={10}>
      <g fill="none" strokeWidth={0.3}>
        <path d="M556.9 378.2c-.7-.2-1.3-2.3-1.8-4.8-.6-2.4 1.8-.2 2-1.7 0-1.5 1.3-2.3 1.9-.6.5 1.7 3.8-.3 2.4 2.5-1.3 2.7-3.3 5-4.5 4.6zM517.7 396c.2 2-4.8 3.2-5.7 3.2-.8.1-2-.2-1.1-.9.8-.7-1.1-1-2.6-1.2-1.5-.3-2.6-1.4-1.4-1.8 1.3-.5 1-1 .1-1.7-.8-.6 0-1.6 1.8-1 1.8.7 0-1.5 2.6-.4 2.7 1.2.4-2.6 2.3-1.3 2.1 1.5 3.8 4.2 4 5zm1-.3s-2.5-4.2-2.3-5.4.7-2.4 1.1-1.3c.5 1 0-.6 1.3-2 1.2-1.4 2-.9 1.6.5-.4 1.3-.2 2.5.2 2 .5-.4 2.3.3 1.7 1-.6.6-1.2 3-.6 2.1s.8-.3.2.6l-1.3 2.3s-1 .7-1.9.2zm8 3s-6.8.4-8 1.4c-1.3 1-2.4 2.3-.9 2 1.6-.3-.6.5-1.3 2.6-.8 2 .4 2.5 1.7 1.2s2.9-1.9 2.6-1.1c-.2.7 2 2 2.4 1 .3-1 2.7-3.2 2-2-.5 1.2.3 1 1-.2l1.6-2.9s.1-1.4-1-2zm-2.3-1.9s-1.1-1.6-1.2-3.1c-.1-1.6.6-1.4 1-.7s.9-1.2 1.6-2.3c.8-1 1.4-.8 1 .4-.2 1.1-.4 4.3.2 3 .6-1.2.8 1-.5 2-1.3.8-1.8 1.2-2 .7zm31.4-16.5s-1-3.8-2.8-4c-2-.2-.8 1.5-1.3 1.5s-2 .1-3.6.6c-1.5.5-.5 1.8.2 2.2.7.3 2.4 1.3 1.8 1.2-.6 0-1.3 1.7 1 1.4 2.3-.4 4-1.1 4.7-2.9zm1.3.4s2.7-1.5 5.1-2c2.4-.3 2 .2.5 1-1.4 1-.5 1 1 1.4s3 2.1.7 2.2c-2.2 0-1.6 1.2-1.2 2 .5.7.7 1.6-.8.8-1.5-.7-7.5-4.4-5.3-5.4zm-17.6-1.8s3.8-1.5 4.2-2.7c.4-1.1-3 .7-2.1-1 .9-1.6 1-4.4 0-3.4-1 1.1-1.8-1.1-1.7-2 .1-1-1.3-2.4-1.6-.6-.3 1.9-.5 2.8-1 1.8s-2.3-1-1.9.5c.5 1.5 1.5 2.7.6 2.1-1-.6-1 .7 0 1.6 1 1 1 1.7 1.8 2.4.8.6.7 1.7 1.7 1.3zm-5.9-4.4c0-2.4.4-3.4 1.1-5.1s-.3-4-.5-3.3c-.3.8-.5-1.7-1.5-2.5s-1.6.1-1.5 1.3c.1 1.1.1 2-.5 1.4-.6-.7-2.2-.3-1.8.7.5.9-.9 2.8-1 1 0-1.9-1.2-5.8-1.8-4.7-.5 1.2-1.8.2-2.9-.5-1-.7-1.3.7-1.2 1.3.2.6 1 2 0 1.7s-1.5.2-.9 1.2a8 8 0 0 0 3.2 2.4c.8.1 1.9 1.4-.5 1.3-2.5-.1-2.7 2.2-1.4 1.9 1.3-.4-.4 1.3-1.6.8-1.1-.5-3.6.4-1 1.4 2.7 1-1 2.1 2.4 2.3 3.5.1 7.8 1.2 9.7 0 2-1.1 1.7-2.6 1.7-2.6zm-2.5 6.4c-1.5-.1-3.1-2.6-4.4-2.4s-2.6.3-1 1c1.6.8.4 1.7-1.4 1.3-1.9-.3-4.5 0-3.3.2 1.1.3.8 1.1-.1 1.1s-1 2.3.3 1.6 4.7-.4 3.6.3c-1.1.8 0 1.8 1 1.2 1-.5 4-2.5 2.8-1.5s-1 2.8 1.2 1c2.2-2 6.2-3.6 1.3-3.8zm68.7 24.1c1.1 0 2-.2 1.3-.5-.7-.4-.1-.6 1.5-.4 1.6.3.6-1.2-.7-1-1.4 0 0-.8 1-1 1-.3.1-.9-1-.3-1.2.6-1.1-.7 0-2.3 1-1.6-.6-.8-1.7 1-1 1.8-.8 1-1 0-.3-1.2-.7-.8-.8-.2s.2 2-.2 1.2c-.4-.7-.5.3 0 1.6.2.3-1.4-.9-1 .1.3 1-.3 1.1 0 2.2.2 1.1.4 2 1.3 1.1.9-.8 2-.8 1.3-1.6z" />
        <path d="M605 401.1c0-1.7 1.4-.2 1 .6-.3.9 1 1.3 1.8 0s3-1.3 2.1 0c-1 1.4-.3.8 1 .5 1.4-.3 3.4-.5 2.5.3-1 .8-1 1.1.5.9 1.4-.3 2.3-.3 2.6.3s-.1.9-1 1.2c-.7.4.4.7 1 1.8.5 1.1.3.8-.9 1s-1.1.5-1 1c.3.6 0 1.5-.8.8-1-.7-1.7-.7-1.6-.1.2.6-.2 2-1.2 1.3-.9-.7-1.3.4-1.3.7.1.8-1 .4-2.1-.5-1-.9-1.7-1.7-1.7-1 0 .8 0 .6-1-.5-.8-1.2-.6-2.8-2.4-2.8-1.8.1-1 .5-.6-.6.5-1.2 2.6-.6 3-4.9zm-8.5 9s2.8 1 1.5 2c-1.2 1-2.1 2.3-1 2 1.2-.3 2.7-.4 1.5.7-1.3 1.2 0 3 .5 2.3.6-.7.8 0 1 1.4.1 1.3 2.3 2.7 1.9.8-.5-2-.5-3.2.3-1.8.7 1.4 3.5 2.3 2.2.4-1.4-1.8-1.4-3.2-.4-2.4s3 1.5 2 .1-2.5-2.4-1.3-2.2c1.2.1 4.6 0 1.8-1-2.8-.8-3.3-1-2.3-1.1 1-.2 1-.8-.8-.8-2 0-1-1.5-3.2-1.2-2 .2-4.8.3-3.7.8z" />
      </g>
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-J)"
        strokeWidth={0.5}
        d="M415.5 389.3c0-.6.3 0 .3 0-.1 7.4-1.7 14.4-2.7 21.7-.2 1.8-.4 7.7-.8 9.6l-.5 2.7-3.5-3.4 2-9.1c1.4-7.2 5.1-20.9 5.2-21.5z"
        transform="translate(316.5 145.5)scale(.58162)"
      />
      <path
        fill="url(#sh-ac_svg__sh-ac-ac-I)"
        strokeWidth={0.4}
        d="M507.4 446.7c-9-1.1-16.5.4-22.3 2.8 0 0 0-2 .9-4.4 1-2.3 1-3-.3-1.3-1.2 1.7-2.3 6.4-2.3 6.4-8.6 4-13.3 9.5-13.3 9.5l1.5 1.8s0-1.7 7.1-6c9.5-1.2 10.9 3.3 11.5 6s2.2 5.4.6-1.4c-1.5-6.8-9.9-5.9-10-5.9a114 114 0 0 1 3.6-1.9c14.4-7.5 33.6-4.4 23-5.6zm-28.6 8.7a84 84 0 0 1 2-1.1z"
        transform="translate(316.5 145.5)scale(.58162)"
      />
      <g strokeWidth={0.5}>
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-H)"
          d="m382.3 410.3-.1-.1c2.1 2.3 4.4 4.4 7 6.4 1.6 1 3.2 2.2 5.2 3l1.5-3.9c-1.5-.5-3-1.4-4.3-2.4-2.7-1.9-5.2-4-7.6-6.3-1.2-1.3-2.4-10-1.4-14.5 1.1-4.5-2 1.5-1.8 5.8.2 4 .6 5.9.6 6.1l-5.6-5.8c-5-5.4-10-10.7-14.8-16.3 0 0-1-.5-.5.4s8.8 12 13.4 17.8l5 6.1a46 46 0 0 0-16.1-.9c-5.5.5 1 .5 4.3.8 3 .4 11.3.4 14.4 3l.4.4zm.5-4.5 1 .9-.4-.3z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-C)"
          d="M362.2 433.6h-.1z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
        <path
          fill="url(#sh-ac_svg__sh-ac-ac-B)"
          d="M350.3 430.7s-1.2-4.6-1.3-6.8c-.2-2.1-1.2-3.4-1.1.3 0 3.7 1 6.2 1 6.2h.2c-9.5-2-12.9-1.9-14.6-1.8-1.8 0-2 .2 4.2 1.2s27.3 6.8 30.7 8.4l1.6-1.9c-4.8-1.2-17.6-5-20.9-5.7z"
          transform="translate(316.5 145.5)scale(.58162)"
        />
      </g>
    </g>
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-bx)"
      d="M504.8 392.7c-1.6 14.4.8 27-1.8 33.8-2.5 6.9-10.4 2.7-14.6-1.4a1147 1147 0 0 0-18-17.5 196 196 0 0 1-15.2-15.8c-2.4-3.5-8.6-10.9-14.2-18.3q-3.3-4.35-6-8.4c-6.2-9.4-8.8-17.7-11.4-21.5-2.6-3.9-5.2-4.7-8.8-13-3.7-8.4-1-18.3-1.5-20.2-.2-1-1.2-3.4-2.2-10-1-7.3-2-19.8-1.5-41 0-4.1 8-16.2 12.3-18l4.3-1.6a15 15 0 0 1 12.3.6c6.5 3.4 22.1 19.6 27.2 26.3a217 217 0 0 1 26.2 49.2c8.2 22.6 11 37.9 11 48-.1 10 3.5 14.4 2 28.8z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-S)"
      d="M439.6 393.6c.3-7.5 1.1-14.5 1.4-20 5.6 7.3 11.8 14.7 14.2 18.2 1.6 2.3 8.3 9 15.3 15.8 3 8.9-1 16 1.6 20.1a36.8 36.8 0 0 1 4.2 17c-.3 4.7 3 7.4 3 9-.1 1.5-.2 8.6-4 8.5-3.8-.2-11-3.8-13.8-6.6A64 64 0 0 1 452 441a555 555 0 0 1-5.6-10.4 72.9 72.9 0 0 1-6.8-37"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-L)"
      d="M452 441c.5 1-7.6 6-9.5 7.5-2 1.5-3.5 3.3-4.9 1.3-1.3-2-6.7-7.5-8.5-25-1.8-17.4 3.3-37.6 3.3-37.6a233 233 0 0 0 7.2 6.4 73 73 0 0 0 6.8 37A544 544 0 0 0 452 441"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#e6c7ac"
      d="M573 362.7c-.2 3.3-.7 7.3-.9 11.7a136 136 0 0 1-4.2-3.7c-27.7-25.5-27.2-46.5-26.8-52.3 1.4 1 3 3 5.2 4 4 1.9 9.6.3 9.3-2.2.5 3.9 1.1 5.3 1.2 5.8.3 1-1.2 6.9.9 11.7 2.1 4.9 3.6 5.4 5.1 7.6s3 7 6.7 12.5l3.5 5z"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-e)"
      d="M381 199c-1.8-1.4-3.3-2.3-2.3-2.8 0 0 10.8-8 19.8-3.2s23 14.8 23 24.5a45 45 0 0 0 4.7 22.3l-4.3 1.7c-4.4 1.7-12.2 13.8-12.3 17.8-.5 21.3.4 33.8 1.5 41.1.5 4.3-9.2 7-16 3.7-3.6-1.8-6.5-5-8.8-6.8-1.7-1.4-3-2-4-1.1-.5.5-.9 1-1.1 1.5-1.2 2.2-6.5 18.4-7.8 23-1.4 4.6 1.5 6.1 1.3 9.6s2.5 6.7 0 14.3-8.8 9.2-10.5 6.8a259 259 0 0 1-12.5-21c-1.8-4 .7-15.2.5-21.3s2-22.7 5.2-24.5c3.2-1.7 6.1-8.6 13.5-15.2 7.4-6.7 12.2-5.8 12.9-8.3.6-2.6 5.9-3.3 5.9-3.3s.2-1.3 3.7-3.2l2.2-3.4c-1.4-4.4.7-12.8.7-12.8-4-4-12.6-13.6-13-18.3-.5-6.5-5-19.6-2.3-21zm18.9 5.8c.3-2.4.4-3.4-1.3-4.6-2-1.5-4.2-1.2-5.5-1-1.4.3 0 2.4 1.7 4.1s4.9 2.8 5 1.5z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#f0ceb8"
      d="M548.3 261.9c1 .7.9 1.3.7 2.7 0 .8-2 .1-3-.9s-1.7-2.2-.9-2.3c.8-.2 2-.4 3.2.5m-1.8 1.2c.2-.1.4-.4.3-.6 0-.2-.4-.4-.6-.3-.3 0-.4.3-.4.6.1.2.4.3.7.3"
    />
    <path
      fill="#f0ceb8"
      d="M546.8 262.5c0 .2 0 .5-.3.6-.3 0-.6-.1-.7-.3 0-.3.1-.5.4-.6.2 0 .5 0 .6.3"
    />
    <g
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.3}
    >
      <path d="M545.6 275s-2.2-3.9-3.1-4.7c-.9-.7-1.6-4-1.7-5-.2-1.9-1.6-3.2-2.7-4-1.1-.9-2-1.4-1.4-1.7 0 0 6.3-4.6 11.5-1.9 5.3 2.8 13.4 8.6 13.5 14.3-.3 8 2.6 13 2.6 13" />
      <path d="m548 285.3-1-1.1c-2.3-2.4-7.4-8-7.6-10.7-.3-3.8-3-11.4-1.3-12.3m8.9 23s-1.3 4.8-.5 7.4l-1.2 2m8.1 0s-3.3-2.4-7.4-.4l-.7.3c-2 1.2-2.2 2-2.2 2s-3 .3-3.4 1.8-3.2 1-7.5 4.8c-4.3 4-6 8-7.9 9s-3.1 10.6-3 14.1c0 3.6-1.3 10-.3 12.4a131 131 0 0 0 7.3 12.2c1 1.4 4.6.5 6-4 1.5-4.3 0-6.2 0-8.2.2-2-1.5-3-.7-5.6.8-2.7 3.9-12 4.6-13.4l.6-.9c1-1.2 3-2.6 4.4-3.2 1.7-.8 8.1-5.4 8.1-5.4m4.3 11c-.7-4.2-1.2-11.4-1-23.8.1-2.4 4.7-9.4 7.2-10.4l2.5-1c2.1-.6 4.5-1 7.2.4 3.8 2 12.9 11.4 15.8 15.3 3 4 10.4 15.4 15.2 28.6 4.8 13.1 6.4 22 6.4 27.9 0 5.8 2.1 8.4 1.2 16.8-1 8.4.4 15.6-1 19.6-1.6 4-6.1 1.6-8.6-.8l-10.4-10.1c-4-4-8-8-8.9-9.3-1.4-2-5-6.3-8.2-10.6a94 94 0 0 1-3.5-4.9c-3.6-5.4-5.2-10.3-6.7-12.5s-3-2.7-5.1-7.6c-2.1-4.8-.6-10.6-.9-11.7 0-.5-.7-2-1.2-5.8z" />
      <path d="M541.1 318.4c1.4 1 3 3 5.2 4 4 1.9 9.6.3 9.3-2.2m-16.8-2.5c.6-.5 1.4-.1 2.3.7m0 0c-.4 5.8-.9 26.8 26.8 52.3a136 136 0 0 0 4.2 3.7l.2.1" />
      <path d="M573 362.7c-.2 3.3-.7 7.3-.9 11.7-.2 6.9.3 14.6 4 21.5a319 319 0 0 0 3.2 6c3.5 6.2 4.7 7.7 5.6 8.6 1.6 1.6 5.8 3.7 8 3.8 2.2 0 2.2-4 2.3-5 0-.9-1.9-2.4-1.7-5.2a22 22 0 0 0-2.5-9.9c-1.4-2.4.8-6.5-1-11.6m-41.7-120.7c1 .7.9 1.3.7 2.7 0 .8-2 .1-3-.9s-1.7-2.2-.9-2.3c.8-.2 2-.4 3.2.5" />
      <path d="M546.8 262.5c0 .2 0 .5-.3.6-.3 0-.6-.1-.7-.3 0-.3.1-.5.4-.6.2 0 .5 0 .6.3m21.1 108.2s-2.9 11.7-1.9 21.9c1 10.1 4.2 13.4 5 14.5s1.7 0 2.8-.8 5.8-3.7 5.5-4.3q0 0 0 0" />
    </g>
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-g)"
      d="m409.8 273 5.3 29.3 1.9 14.6s1 9 4 13.5c3.1 4.5 7 10.3 11.3 18.8 4.4 8.5 7.5 15.3 24.1 34.8 16.7 19.6 26.6 30 26.6 30s14.2 14.3 17.7 15c1.2.5-1.5 1.4-2.7 1.3-1.2-.2-4.2-1-5.7-2.1s-24.7-23.4-24.7-23.4S456 394 440 372.1c-15.9-21.7-12.2-24.7-18.3-31a33.7 33.7 0 0 1-9-22l.6-8.6s-3.4-16.2-3.5-22.5z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#f0955d"
      d="M568.3 340.8c-.8-3-4.7-10.4-5-11.7-.3-1.4-.8-1.7-1.4-1.5l-3 .9c.2 2.4.5 4.5 1 6.2.8 2.7 4.8 7.6 5.5 8.9l1 2 1.3-.4c1.7-.6 1.4-1.4.6-4.4m-5.2-18.6c-.3-1.9-3.6-10.6-3.7-12.3-.2-1.6-1.2-2.1-2-1.9a76 76 0 0 0-1.9.6c1 5.2 2.4 12.4 2.8 15.3 0 .8.2 1.6.3 2.3 4.8-1.5 4.7-2.2 4.5-4m18.9 43c.1-1.4-5-6.7-6.9-9a20.4 20.4 0 0 1-4-7.7c-.2-1.9-.6-1.9-1.7-1.5l-2 .7a88 88 0 0 0 5.8 10.4l7.8 9.6c1.1-1 .9-1.5 1-2.5m25.7 28c.3-.3-6.1-6-8.9-8.6a88 88 0 0 1-10.2-12.5c-.8-1.8-1.6-1-2.4-.8l-1.5.8c3.3 4 6.3 7.6 7.4 8.7 2 2.1 10.7 11.4 14.5 13.7.8-.6 1-1 1.1-1.2z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-be)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M433 335.8c-1.4-5-8.1-17.8-8.6-20.1-.4-2.4-1.3-2.9-2.3-2.6l-5.4 1.6c.5 4 1 7.8 1.9 10.6 1.3 4.6 8.3 13.1 9.5 15.3l1.8 3.6 2.1-.8c2.9-1 2.3-2.5 1-7.6m-9-31.9c-.4-3.3-6-18.3-6.4-21.2-.3-2.8-1.9-3.7-3.3-3.3a130 130 0 0 0-3.3 1c1.7 9 4.2 21.5 4.8 26.3l.5 4c8.3-2.5 8.1-3.8 7.7-6.8m32.5 74c.3-2.5-8.6-11.6-11.8-15.5-3-4-6.6-10.2-7-13.4-.3-3.2-1-3.2-2.8-2.5l-3.4 1.2c3 5.9 7 14 10 17.9 2 2.7 7.4 9.4 13.3 16.5 2-1.6 1.6-2.6 1.7-4.3zm44.3 48.1c.5-.6-10.6-10.5-15.3-15a151.6 151.6 0 0 1-17.6-21.3c-1.4-3-2.7-1.8-4-1.4l-2.8 1.4c5.8 6.9 11 13 12.9 14.9 3.5 3.7 18.3 19.6 24.9 23.5 1.3-1 1.6-1.6 1.9-2z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M554.6 306.8c3.7-.4 4-1.7 3.8-3-.1-1.4-1.6-6-1.4-8.2 0-2.2 3.5-7.2 6.3-8.3 3.2-1.3 2.3-2.1 2-2.6 0 0-3.8 1.2-5.2 2.4a20.5 20.5 0 0 0-5.5 10.4c-.4 4.1 0 9.3 0 9.3"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bu)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M409.5 277.4c6.3-.7 6.7-3 6.5-5.3-.3-2.3-2.7-10.2-2.5-14s6.1-12.4 11-14.3c5.3-2.1 3.9-3.6 3.3-4.4 0 0-6.5 2-8.8 4.1-2.3 2-8.9 10.6-9.5 17.8-.7 7.2 0 16 0 16z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M570.4 302.5c.8-.2 2-.3 3 .2l5 3c.7.1 1.7 2.4 1.7 2.4s.5 1.5.4 2.7a66 66 0 0 1-.4 6.9 11 11 0 0 1-3.4 3c-1.6 1-7.8 3-9.1 3.3-1.3.2-2.6-1.3-2.6-2.7s-1-6.5-1.5-8c-.4-1.6-2.4-8-.3-8.7 2.2-.8 7.2-2 7.2-2z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bt)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M436.7 270c1.2-.3 3.5-.5 5.2.3 1.6.9 7.6 4.7 8.6 5 1 .4 2.8 4.3 2.8 4.3s.8 2.7.7 4.7-.3 11-.7 11.8c-.4.7-3 3.6-5.8 5.2a99.5 99.5 0 0 1-15.7 5.6c-2.2.4-4.5-2.3-4.5-4.6 0-2.4-1.8-11-2.5-13.8-.7-2.6-4.2-13.6-.5-15 3.7-1.3 12.4-3.4 12.4-3.4z"
      />
    </g>
    <path
      fill="#fdf2e8"
      d="M556.4 282.5s-7.1.4-6.2 1.5c.8 1.1 1.5 2.9 3 2.4s6.2-3.7 3.2-3.9"
    />
    <g fill="#d5ccc0">
      <path d="M537.5 264s.8-.5 1.3 1.8c.5 2.4 1.8 6.1 2.6 7.5.7 1.5 6.6 10 7.2 11 .7.9-.6 2.5-1 1.8-.3-.6 0 3.3.4 4 .3.7.4 2.2 1.5 2.3 1 0 0 0 0 0s-3.4.4-3.5 2.2c0 1.7-2.5-.4-1.3 1.5 1.2 2 .4 5.4-.7 3.5-1-1.9-3.2-3.9-3.3-2.6s-1.2 1.5-1.6 1.6c-.4.2-3.4 1.6-5 3a65 65 0 0 0-6.9 7.2c-1.3 2-3.9 3.3-5.2 8.7-1.3 5.5 0 0 0 0s1-5.4 2-6.2c1-.9 4-4.6 4.9-5.6.8-1 4.6-5 6.8-6s4-1.8 4-2.2c0-.5.9-1.4 1.9-1.7s1.2 0 1.6-.7c.4-.6 2.1-1.7 2.1-1.7l.7-1s.6-.4.4-1.2l.1-5.1c.1-1.4.6-1.8 0-2.3-.4-.6-4.5-4.8-5.7-7.2a20 20 0 0 1-2-6.4c0-1.4-1.3-6.2-1.3-6.2" />
      <path d="M548.8 311.2s1.2 0 2.7-.4c1.4-.3 3.4.2 3.3-1.5-.2-1.7-.2-12.1-.2-12.1s-.6-2.3 2.4-6c3-3.9 4.1-5 5.1-5.4l.3-.1s-1.8-1.4-2-4.5c-.3-3-.7-9.3-1.1-6.7-.5 2.6.8 5.2-.8 6.1-1.6 1-5.9 1.5-7.2 1s-2.6-2.8-2.6-2.8l-2.8-3.3c-.3-.5-1.4.4-.2 1.4s3 3 3.1 4c0 1-1 1.6 1 2.6 1.9 1 1.6.6 3.3.3 1.6-.2 3.7-.8 4-1.1.2-.3 1.7-.3.5.6-1.1 1-2.7 3-4.4 3-1.8.1-2.8 0-3.4-.5-.6-.4-1.6-.3-.8.2s1.7 1 3.4 1.3c1.4.2 2.5.8 4.2-1.2 1.7-1.9 2.3-2.1 2.3-3.6s1.3 1.3.2 3.5c-1.1 2.3-5 4-6.6 4.5-1.6.6-2.9 1.7-1.9 1.9 1 .1 2.8 1 3 1.5.3.6 0 1-.8 2.5-.8 1.6-3.6 10.9-5.6 13s-4.1 5.3-2.4 4.2l4.3-2.9m-11 7.5a53.5 53.5 0 0 0-7.1 14.6c-.5 3.3 2.6 5.3 2.3 8.5s-1.9 9.5-3.3 7.7-4.5-3.5-3.4-1.7c1.2 1.7 2 4.3 4 3 2.1-1.5 4.6-3.7 4.4-8.1-.1-4.4-.8-4.3-1-6.3a8.5 8.5 0 0 1-.5-3.4c.1-.9 4.7-14.3 4.7-14.3z" />
      <path d="M551.2 312s-.8 2.7-2 1.8c-1.2-1-2.7 0-2.3.5.5.4.1 1.8-1.4 1.7-1.5 0-2.2 0-2.3.5 0 .6-.5 1.6-1.2 1.5-.7-.2 2 2.9 2.5 3.3l-4-3.4c-1-.8-1.7-.4-.5-1.4l8.4-5.3s.7 1.2 2.8.8" />
    </g>
    <path
      fill="#fdf2e8"
      d="M542.5 270.3c.1-1.8 2.5-3.6 4.5-1.6s3 6.7 5.6 5.5 7-3.2 6.6-.7c-.6 2.4-3 5.3-5.1 5-2.2-.4-6.2-1.5-11.6-8.2m6.2 8.5c-.6-1.3 2.7.9 5.3.7s2.2 1 .8 1.5c-1.4.4-2.6 1.1-3.3.7-.8-.4-2.4-2-2.8-3zm6.8 8.3s-1.7 2.6-2.5 2.5c-.8-.2-2-2.6-2-2.6s3.1 1.3 4.5 0zm-18.9-27s5.4-3 8.4-2.5 7.1 3.6 8 4.2c.8.6 3.1 3.7 4 3.5.8-.2.9-.7-.5-1.9-1.3-1-7.4-6.3-10.9-6.5-3.5-.3-7.3 1.8-8.1 2-.8.3-.9 1.1-.9 1.1m24.8 13.3s-.8 1.5-.7 2.6c0 1 2 9.7 2 9.7l1.6-.4s-3.2-9-2.9-11.9"
    />
    <path
      fill="#d5ccc0"
      d="M554.7 309.3s-1.6.3-1.4 3.1c.2 2.9.4 8-.5 8.8-.9.9-7.6 1.3-5.2 1.6 2.3.4 6.7.4 7.7-1.3l.2-1.9z"
    />
    <path
      fill="#ad5f38"
      d="m569.8 302.7 5.2 2.8-7-2.4zm-4.9 1.3 6.1 2.6-8.2-1.7m-.6 1.9 7.3 1.6-7.1-.1m.5 2.5 11.6-1.7-10.8 5m.3 1 11.4-3.2-10.6 7.6m.1.9 10.8-6.1-10 8.8m1 .7 5.4-4.7-2.8 4.4m2.6-.8 4.7-6.7-1.8 5.6m2-1 2-3.9-.5 3"
    />
    <path
      fill="#f0955d"
      d="M576.4 289.1s-3.3 2-3.5 2.4c-.3.5-.5 5.8-.4 6s1.2 3 1.6 3.1c.3.2 7 4.1 7.5 4.2.5 0 3.7-.2 4.2-.4.4-.1 2.8-2 2.8-2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bs)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M447 247s-5.7 3.3-6.1 4c-.5.9-.8 10-.6 10.4.2.3 2 5 2.6 5.4.7.3 12.2 7 13 7.1 1 .1 6.4-.3 7.2-.6.7-.2 4.8-3.4 4.8-3.4"
      />
    </g>
    <path
      fill="#f0955d"
      d="M575.1 288s-2.4 2.3-3.4 2.5c-1 .1-7.3-.8-7.6-1.2-.4-.4 2.3-3 6.2-4.5"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-br)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M444.7 245s-4 4-5.8 4.3c-1.7.3-12.6-1.4-13.1-2-.6-.7 3.9-5 10.6-7.8"
      />
    </g>
    <path
      fill="#f0955d"
      d="m562.6 290.8 7.3.8c.6 0 1 2.9.9 5l-.3 4.3-9.3 3c-.5.1-1.9-4.1-1.7-7.5.2-3.3 2.5-5.7 3-5.6z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bq)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="m423.2 249.8 12.5 1.4c1 0 1.8 5 1.6 8.6l-.4 7.5-16.2 5c-.7.3-3.1-7-2.8-12.8.4-5.7 4.2-9.8 5.3-9.7"
      />
    </g>
    <path
      fill="#f0955d"
      d="m590.7 305.7-5.8.5c-1 .1-1.5.8-1.5 1.8s-1 9-1.2 9.8-.1 1.7 1.2 3c1.4 1.2 4 3.1 4.8 3.5.6.4 2.5 1 5 .2l6.6-2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bp)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M471.6 275.5s-8.4.6-10 .9c-1.8.2-2.6 1.4-2.7 3.1a263 263 0 0 1-2 16.8c-.4 1.3-.2 3 2.1 5a73 73 0 0 0 8.2 6.2 11 11 0 0 0 8.6.4l11.3-3.6"
      />
    </g>
    <path
      fill="#f0955d"
      d="M578.2 322.4c.9-.4 2.3-1 3.7.2 1.4 1.1 4.8 5.5 5.2 6.2.4.6.4 1.2.3 2.2l-.8 7.5c-.3 1.1-.7 3.1-3.2 4.2-2.5 1-8.6 4.5-10.8.3-2.3-4.2-6.3-13.6-6.6-14.6-.4-.9 0-1.5 2-2.1z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bo)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M450.1 304.2c1.4-.7 3.8-1.7 6.3.3 2.4 2 8.3 9.6 9 10.7.6 1.1.7 2 .4 3.8-.2 1.7-1 10.8-1.4 12.8-.5 2-1.2 5.4-5.4 7.3-4.2 1.8-14.7 7.7-18.6.5a351 351 0 0 1-11.4-25c-.6-1.6.2-2.6 3.5-3.7a726 726 0 0 0 17.6-6.7"
      />
    </g>
    <path
      fill="#f0955d"
      d="M584.2 344.3c1.9-.8 4.3-1.3 5.4.7 1 2 4.3 8.2 5.4 9.6 1 1.4 1.6 6.2.1 7.5a73 73 0 0 1-7.3 5c-.8.4-3.5 0-4.2-2-.8-2-6.6-11.2-8.3-12.6-1.6-1.3-1.6-4.4 1.1-5.1a84 84 0 0 0 7.8-3z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bn)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M460.4 342c3.2-1.5 7.4-2.4 9.2 1.1 1.7 3.5 7.5 14 9.3 16.5 1.7 2.4 2.8 10.6.3 12.8-2.6 2.2-11.2 8-12.6 8.6-1.4.7-6 0-7.4-3.4a119.8 119.8 0 0 0-14-21.6c-2.9-2.3-3-7.7 1.8-8.9a111 111 0 0 0 13.4-5.2z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M594.8 366.7c1.2-.5 1.5-.8 2.4 0 .8 1 7.9 7 9 7.8 1.3.8 1.3 1.4 1.2 2.7 0 1.4.7 9.1.6 10.8 0 1.6 0 2.1-1.8.5a182 182 0 0 1-12.8-13c-1-1.6-4.2-7.3-2.6-7.6s2.6-.7 4-1.2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bm)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M478.6 380.3c2-.8 2.6-1.3 4 .2a313 313 0 0 0 15.7 13.2c2.2 1.5 2.1 2.4 2 4.8-.2 2.3 1.2 15.6 1 18.4s0 3.8-3.2 1a312 312 0 0 1-22-22.4c-1.5-2.7-7.2-12.5-4.4-13s4.5-1.2 6.9-2.2"
      />
    </g>
    <path
      fill="#f0955d"
      d="M610.1 373.1s-2.5-.2-3-.9c-.5-.6-6.3-5.5-7.2-6.3-1-.8-1.7-1.4-1.6-2 0-.6 0-4.6-.2-5.5-.2-1 1.1-1 2.3-1 1.1 0 8.5.5 8.5 1"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bl)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M505 391.4s-4.5-.4-5.3-1.5-10.8-9.6-12.4-10.9c-1.5-1.3-2.8-2.5-2.8-3.5s0-7.8-.3-9.4 2-1.8 4-1.7 14.6.8 14.7 1.6"
      />
    </g>
    <path
      fill="#f0955d"
      d="m609 356.7-9.3-.4c-1.1-.1-1.6-1.1-2.5-2.9l-2.3-4c-.3-.6.4-1.3 1.4-1.6s7.4-2.6 10.5-5.2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bk)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M502.8 363.1s-13.8-.5-15.7-.7c-2-.2-2.8-1.8-4.4-4.9l-4-7c-.4-.9.7-2 2.4-2.6 1.6-.6 12.7-4.5 18-9"
      />
    </g>
    <path
      fill="#f0955d"
      d="M605.9 339.3s-2.6 2.9-5.4 4.2a29.6 29.6 0 0 1-5.3 2c-.8.1-2.2.2-3-.8-.9-1-2.3-2.5-2.8-2.8s0-1.8.2-3l1-11c0-.9.8-1 1.8-1.3s7.5-2.7 8-2.6"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bj)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M497.6 333.2s-4.4 5-9.2 7.2a51 51 0 0 1-9 3.4c-1.5.3-3.9.5-5.3-1.2a39 39 0 0 0-4.8-4.8c-.8-.6.1-3.2.3-5.3.2-2 1.6-17.5 1.6-19 0-1.3 1.6-1.5 3.2-2 1.7-.6 13-4.8 13.9-4.6"
      />
    </g>
    <path
      fill="none"
      stroke="#af6d4a"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M565.3 284.7c.3.5 1.2 1.3-2 2.6-2.8 1-6.2 6.1-6.3 8.3-.2 2.2 1.3 6.8 1.4 8.1.1 1.4-.1 2.7-3.8 3"
    />
    <path
      fill="#ad5f38"
      d="M561.2 292h6.5l-5.3-1.2m-1.8 2 8.7.4-9.4 1m-.4 2.2 8.2-1.2-8 3.7m.1 1 7.6-2.3-7 5m2 .8 4.5-3.2-2 2.4m-.3-13.1 6-.7-4.5-1.7s-2.6 2.1-1.5 2.4m3.4-3.7 3.2 1.4-4.1-.8m4.4-1.1.5 1.1-2.2-1.4s.6-.1 1.7.3m2.7 5.2 1.3.3-2.4.4m-.4 1.3 1.6-.2-1.7 1.6m0 2.4 3-2-2.9 3.8m.6 1 5-2.5-3.4 4.5s-1.3-.8-1.6-2m4.7 3.8 1.6-5-3.2 4.2m3.6 1.8.9-4.5 1 5.4m1.5 0 .2-3.3 1.8 3m1.2-.5-.3-2.3 1.1 1.6m-.7 2.7 2 .7-5.2.5s1.4-1.3 3.2-1.2m-3.4 3 6-1-6.2 3m-.2 1.8 6.2-1.6-6.8 3.7m-.1 2 8-4-8.1 6.3m1.2 1.4 7.5-6.4-5.7 8m2.3 1.6 5.2-7-2 8.3m3-.7 2-6v5.4m2-.6.7-4 1.5 3.3zm-.2 1.7h2.2l-4.8.9m-2.6.8 6.5.3-8.2 2s.1-2.4 1.7-2.3m-2 4.3h8l-8 2.6m0 1.6 6.6-1.8-7.4 4.5m0 1.7 7.4-3.8-7.4 6.2m1.1 1 6.8-5.5-4.7 7.7m2.6.3 5.3-7.9-2 6.8m3-1.4 2.5-6.2.3 4.1m-5.6 6 5.3-.5-9.1 3s1.3-2.1 3.8-2.4zm-3.2 3.5 7.3-2.3-6.4 4m1 2.3 5.4-5.3-3.8 7m2.1.3 4.2-6.5-2.3 6.6m1.9.1 2.3-6.1-.7 6.2m-8.3 6.8 5-2.6-4.2 4.3m1.2 1.3 4.3-3.3-2.8 4.3m1.3 1.1 4.3-6.2-2.8 7.5m1.3 1.1 3.1-9.3-1.5 10.8m.9.4 1-6 .5 6.3m-37-48.6 6.3.7-12.7 2m-.7.5 13.4-.5-12.4 3 12.9-1.2-12.2 3m.6 2 13.4-3.2-12 5.3m1 3.1 9-5.7-7.6 8m1 1.8 9.1-7.6-6.1 9.3s-2.2-.3-3-1.7m4.5 1.6 6.4-9.1-3 8.1m2.7-1.2 1.6-5.9.7 4m-11.2 8 8.7-2.3-9 4.5 10.4-3.5-9 5.3s-1.3-1.2-1.1-4"
    />
    <path
      fill="#ad5f38"
      d="m575.6 352.8 10.8-3-9.4 4.8m.5.6 9.9-3.1-8.2 5.5m1 1.4 7.4-4.7-6 7.2m.7 1.1 6.7-7-6.1 8.4m.7 1.3 6.2-8.7-3.5 10.6s-1.9-.7-2.7-2zm4.5 1.6 2.8-8.4-.4 6.9m1.4-1 .9-4.9 1.2 3.6m-3.3 7.3 4.1-2.4-2.9 5m.6 1 4.3-3-3 5m1 1.3 4.2-5.5-2.9 6.8m1.5 1.6 3.8-6.8-2.2 8.4m1.1 1 3.3-8.1-1.5 9.9m1.8 1.8 1.6-10.6 1 12.9"
    />
    <path
      fill="#d5ccc0"
      d="M575.6 366.2s-2.5 12.3-.8 23.1-1.7-1.9-1.8-2.3a84.2 84.2 0 0 1 0-24.3zm9.3 44.3s9.4 5 8.6 1.3c-.9-3.7-2-4.5-2.4-6.4-.5-1.8-.5-5 .6-3.8s.7-4-.5-5.5-3-6.2-2-6.2c.9 0 1.2-3.8.7-5.1-.4-1.4-4.7 2.8-10-13.1l10.1 10.8s1.3 3.2.6 6.9c-.6 3.6.9 5 1.6 7.4.7 2.3 1.6 6.3 1.3 7.6-.3 1.4 1.7 4 1.6 5.4 0 1.4-.6 4.6-1.9 4.5-1.2-.2-6.6-1.6-8.3-3.8"
    />
    <path
      fill="#fdf2e8"
      d="M589.8 389.1c.2-.6.6-1.8-.5-1.5-1.1.2-.5 2.5-.1 2.3.3-.2.4-.3.6-.8m2.6 12c0-.8 0-2-1-1.5-1 .4.3 2.5.6 2.3s.4-.4.4-.9z"
    />
    <path
      fill="#d5ccc0"
      d="M572.3 380.5s-1.1-4.6-3.5-3.2c-2.3 1.4-3 10.4-3 10.4s.1-9.1 2.3-16.9l4.2 3.7zm3 13.8s-2 12.4-3.3 11a49 49 0 0 1-6-13.3s1 8.1 4 13.6c1.8 3.3 3 1.6 4.7.3 1.7-1.4 4-2.6 4.6-4z"
    />
    <path
      fill="#c6ac95"
      d="M552.7 322.8s2 1.6 1.7 3.6-.9 4.2.5 7.4c1.5 3.2 2 6 3.6 8l6.3 7.4s-1.4-3.4-2.7-4.8c-1.3-1.5-5.4-6-5.4-10.5l.1-7.8-1.2-5.3s-1 2.1-2.9 2m-5.7.1s-5.5 2-5.5 4.8-.7-7.1-.4-9.1c0 0 4.2 3.9 5.9 4.3"
    />
    <path
      fill="#caa178"
      d="M552.4 323s1.2 2.5 1.3 5.2c.1 2.8-5 3.8-8.1 3.9-3.2 0-3.4-.2-3.4-.2s-1.6-10.2-1.1-13.3c0 0 3.4 3.4 6.2 4.2 2.7.7 5.1.1 5.1.1z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bi)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M405.7 305.1s2 4.4 2.2 9.1-8.5 6.6-14 6.6c-5.4.1-5.7-.2-5.7-.2s-2.9-17.6-2-23c0 0 6 6 10.6 7.2 4.8 1.3 8.9.3 8.9.3"
      />
    </g>
    <path
      fill="#caa178"
      d="M542.6 333s4.7-.2 7.4-.6c2.7-.5 3.5.5 4 2 .4 1.5 2.3 5.6 3 7 .6 1.3-.3 3.6-2 4.6l-5.6 2.5s-5-8.8-6.8-15.5"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bh)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M389 322.5s7.9-.4 12.6-1.2c4.7-.7 6 1 6.8 3.6.8 2.5 4 9.6 5.2 12 1.1 2.3-.5 6.2-3.5 7.8s-9.6 4.5-9.6 4.5-8.7-15.3-11.6-26.7z"
      />
    </g>
    <path
      fill="#caa178"
      d="m551.5 351.9 5.4-4.3c1-.8 2.6-.8 4.1 1.5s3.8 7.4 4.8 8.7 1.2 2.8.2 3.8a64 64 0 0 0-3.1 4.2s-8-8.4-11.4-14z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bg)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M404.2 354.9s7.5-5.9 9.2-7.4c1.8-1.4 4.5-1.4 7 2.6 2.6 4 6.6 12.7 8.3 15 1.8 2.3 2 4.8.4 6.5-1.7 1.8-5.4 7.1-5.4 7.1s-13.9-14.3-19.5-23.8"
      />
    </g>
    <path
      fill="#caa178"
      d="M572.6 367.3c-2.1-3.4-3-5.5-4.2-4.8s-4.4 4.4-4.4 4.4l8.3 7.6z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-aX)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M440.4 381.5c-3.6-5.9-5.2-9.6-7.3-8.4a57 57 0 0 0-7.4 7.7l14.2 13z"
      />
    </g>
    <path
      fill="#c6ac95"
      d="m569.7 362.9 3 4.4.3-4.6s-5.3-6.7-6.1-8.6c0 0 0 3.9 1.1 5.6.4.5.8 1.5 1 2.7.2 0 .5.2.7.5"
    />
    <path
      fill="#b28f6b"
      d="M569.7 362.9c-.2-.3-.5-.5-.6-.5.5 2.5.6 5.8-1.7 7.8l4.9 4.3.4-7.2z"
    />
    <path
      fill="none"
      stroke="#9f8d79"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M549.3 286.2s4 2.5 6.4.7c4.2-3 3.5-8.4 3.5-8.4"
    />
    <g fill="#494037">
      <path d="M553.2 260.8c-1.2-.2-3 .8-2.2 1.3.8.6.9 2.1 2 2 1.1-.3 1.3-1 1.3-2.5 0-1.4 0 0 0 0zm2.9 2.3s-2 2.6-1.2 3.6 2 1.8 2 1c-.2-.9 2.4-.3 2-1.7-.2-1.4 0 0 0 0zm-.6 7.6c.8.2 1.3.2 1.4-.5 0-.8 1-.5 1.1-1.2 0-.7-1.5 0-2.4-.5-1-.3-2 0-2 .7s-.7 1.4.2 1.4zm5-2.5s-1.2 1-1.1 1.6c0 .6 2.4 3.2 2.3 2.2-.2-1-1.2-3.8-1.2-3.8m-9.5-8.9c0 1-2.6 1-3.2.4-.7-.7-2-2.3.4-2 2.4.4 0 0 0 0zm-8.4-2.3c-.8.7-.2 1.1.6.8.7-.3 3.8-.4 2.4-1-1.5-.5-3 .2-3 .2m-1.6 3a3 3 0 0 0 1 3c1 .8 2.1.9 2-.4-.3-1.3-.4-2.2.5-2.1s1.9-1 0-1.1c-1.8-.1-3.4-.3-3.5.6m2.8 4.8c-.7-.1-2.4 2.6-1 2.7 1.5 0 2.3-.2 1.8-1-.5-.7 0-1.5-.8-1.7m2.4 1.3c.2-.6 1.8.2 1.8.8 0 .5.9 3-1.3 1.7-.5-.3-.7-1.3-.5-2.5m-2.8 3.4c.3.4 1.2 1 1.5 2s2.3.8 2.3.1.5-1.9-.5-2c-.7.3-2-.7-2.8-.9-.4 0-.7.5-.5.8m10.8 2.1c.3-.7 2.6-.4 2.4 1-.2 1.6-.4 2.5-1.1 2.4-.7 0-.1-1-.2-1.7 0-.7-1.5-.8-1.1-1.7m3.2 2.9c.5.2 1-.2 1-1s1-.1 1.2-.7c0-.5-.5-1.1-1.2-.7-.7.5-2 2-1 2.4m4.4.8s-1-.2-1 .3-.1 2 .2 1.6c.4-.3 1-.1 1-.5zm-12.4-1.6c-.6.7-.5.3-.8 1s-1.7 1-1.5 0c.1-1.1-1-1.8-.2-2 .7-.1 2.6-.8 2.6-.3 0 .4.8.2 0 1.3zm1.4-1.3c.1.6.5 1.2-.1 1.8s1.3 1.6 1.9 1.4c.6-.3.5-1.2 0-1.3-.4-.1.2-1.8-.5-1.8-.8 0-1.4-.7-1.3 0zm-1.8-2c0 .7.7.9 1.4.6s1.4-.7 1-1.5c-.3-.8-1-2.3-1.3-1.7-.4.6-1 1.7-1 2.7zm3.3-3.9c.8 0 .2 1.5 1.1 1.2s.7-2 .1-2.2c-.5-.1-2.6-.1-2.6.6 0 .6.6.4 1.4.4m-2.6 9.2c-.3.4-1 1.2-.1 1.5.8.3 2-.4 1.6-.7-.4-.4-1.1-1.3-1.5-.8m4.8 0c-.6.1-.7 1.7 0 1.7.5 0 2-.7 1.4-1-.6-.4-.6-.8-1.4-.7m-4 13c.7.8 2.1 1 2.1.7s-.4-1.9-1-1.8c-.4 0-1.6.5-1 1.2zm3.9 1c.3-.3 1.4-.9 1.8-.7.4 0 .6 1.6-.1 1.6-.8 0-2.3-.3-1.7-.8zm-3 3c-.1-.7-.2-1.1.8-1.1 1.1 0 .9.7 1.4 1.2s.8 1-.5.5l-1.8-.6m7.8-6c0-.6-1.2-.4-1.1 0 0 .3 1.1.9 1.1 0m1.4-1.8c.1-.2.9-1.2 1-.8.2.5-.3.5-.5.8s-.6.3-.5 0m2.5-3.4c-.8-.3-1.4 1.2-.8 1.5.6.2 2.2 2.2 1.8 1.1m-9.5 17c-1-2.4-1.6-5-4.6-2.4s-3.8 4.9-1.5 5.3 4.7 1.8 5.5.2.6-3 .6-3zm-7-5.8c.4.4 1.1.3 1 1 0 .7 2.4.3 2-1.7-.3-2-4.2-.4-3 .7m-5.2 4.1a21 21 0 0 0-5.4-.2c-.5.2-.2 2.5 1.6 2.6s5.4-2 3.8-2.4m.2 3.7c-.4 1.7 1 2 2.3 1.2 1.2-.7 2-1.7 1.2-2.1-.8-.5-3-1-3.5.9m4 9.6-3.5-3.4c-.8-1-.5-2.6 1.2-2.5 1.6.1 4.4 4.4 4.1 4.6m-5 3.2c-.2-1.5-2.2-4.4-5.3-5.2-3-.8-1.5.6-1.8-1s-2.2-.2-3 .8 0 1.7 1.7 1.9 5.9 3 6.5 4.6m-1.1-8.3c.2-1 1.2-2.8 1-3.5s-2.4-.6-3.5-1c-1.2-.5-2.3.5-2.2 1.5 0 1-1.3 1.5-.2 2 1.2.5 4.7 1.7 4.9 1m-5-7.4.7 2c.3 1-1.5 1.8-2.2 1.6s-3.1 1.4-3.4.5c-.2-1 3-2.6 4.9-4.1m-6 5.4s3.3-1.2 3.2.1c0 1.4-.2 3.5-1.3 3.6s-2.6.7-3 1.4-2.8 1.2-3 0l4-5.1m15.3-11.2s1.8 0 1.3 1.3l-.4 1.6c0 .3-1.1-1-2.2-1.6m-3.4 2s.4.3.8 0c.3-.4.4-1.2 1-1 .5.1.5-.7.5-.7s-1.5.3-2.3 1.6m4.7 3c.5 0 2-.3 1.5-1-.4-.6-2.1-.5-2.1 0 0 .4-.2 1.1.6 1m2.2-3.5c.7.2 1 .5 1 1-.1.6-.8.6-1.4.6-.7 0-.2-1.7.4-1.6m-23.2 15.4c.9-.6 2.5-.3 2.4 1.2a9 9 0 0 1-1.5 4.2c-.6.7-2.5.8-2.3-.1zm5.1-.5c.5-.7 3.7-1 3 .2-.8 1.2-1 3-.5 3.2.6.3 1.5 2 .3 1.6s-1.6-1.2-2.7-1.1c-1 0-1.5-1.8 0-3.9zm-3.9 7c.4 0 .6 1.3 1.1.8.5-.6.7 1.8-.4 1.6-1-.2-.5 1.8-1.3 1.5-.7-.2-1-1.5-.4-2 .6-.3.2-1.8 1-1.8zm1.7-2.2c.2.6 1 1.8 1.8 1.9.9 0 4-.5 2.6-.8s-2-1.7-3.2-1.6c0 0-1.8-.8-1.2.5" />
      <path d="M532.7 312.3c-.8.8 0 2.8 1 3 1.1.2.8 1.5 0 1.6-.9 0-2 2.6-2 2.7 0 .2 1.4 2.6 2.2 2.8.9.3 2.4 1.2 2.8.2l1.7-4.4 1.5-1.6s-.9-1.8-2.6-2.8-4.2-2-4.6-1.5m-5.8 8.3c0 1.2.7 2.3 2.4 2.3 1.8 0 2.7-2.8.1-3-2.6 0-2.5 0-2.5.7m4.5 2.4c-1-1-.9 2.8.5 3s1.4 2.1 2.1.9 2.6-3 .2-3.5c-2.4-.3-2 .3-2.8-.4m.4 3.9c.5.3 2 1.6 1.7 2.4-.3.7-.3 3.3-1 3.2-.5 0-2.2.2-2-1.5s.6-4.5 1.3-4.1m-1.5 7.1c.3-.8 3-.5 3-.5l.6 1.9s.5 1.6.5 2.2-1.6 1-2.2.6a4.6 4.6 0 0 1-1.5-2.4c-.2-.8-.8-.6-.4-1.8m4.6 7c-.2-1.2-2-1.5-2.8-1-.9.4-.6.8-.2 2.1.5 1.3 1.2 3.5 2 2.7 1-.8 1.3-2 1-3.7zm-6.6 8.8c.8.6 3 .2 2.8-2-.2-2-2.4-4.8-3.9-5.7-1.5-1-3.4.5-3.1 1zm-7.3-12.2 2.4 4.3s1.7-1.6.9-2.6" />
      <path d="M524.3 339.3c-.9-1 .4-2.7-.7-2.8s-2.7.8-2.6 1.1m.3-5.2c0 1.3.2 2.6 1.7 2.3 1.5-.4.8-1.6 1-3.4.4-1.7-.4-1.8-1.2-2-.8-.3-1.7-.3-1.8.6 0 .9.5.6.3 2.5m1.3-7.2c-.1 1.3-.7 2 .8 2.2 1.5.3 1.8.5 1.8-1 .1-1.5 1.6-1.2 1.4-.5-.3.8-.2 2 1 1.9 1.3-.1 4-1.1 2.7-2.3a6 6 0 0 0-5.2-1.7c-2.2.3-2.5 1.4-2.5 1.4m3.8 3.1c-1 .1-1.1 3-1.1 3.8 0 .7.2 2 1.5 2 1.4 0 2.4-.2 2.5-2.3s-.5-3.7-3-3.5zm0 8.3c0 .5.3 2.1 1 2.9.6.7 2 1 2.4 1s1.1-1.2.8-1.8c-.2-.7-1.7-1.8-2-2.7-.2-.8-2.4-.7-2.2.6" />
    </g>
    <g fill="none" stroke="#9f8d79" strokeMiterlimit={10} strokeWidth={0.6}>
      <path d="M559.3 275.1s.4 5.7-1.6 6l-5.2.9c-1.5.2-3.5-2.5-3.9-3.4-.4-1-1.3-.8-3-3.6m9.1 35s-1.6 1.7-3.5 2c-1.9.4-2.8-.8-2.8-.8m6.4 1.3s-3.2 3-5.7 2.8c-2.5 0-3-2.5-3-2.5" />
      <path d="m555 315.6-2.4 1.3c-.8.5-1.7 1.1-4.1 1s-4.6-2.3-6.3-2.9" />
      <path d="M539.7 316.5s2 .8 3.4 2.3 7.5 4.2 12.3.2m-4-9.9s1.5-1.1 1.9-1.2m.2 1s-.7-.2-1.5-.2" />
    </g>
    <path
      fill="#494037"
      d="M547.8 307.6c1.4.5 1.4 3 2.4 2.3 1.1-.8 2.2-1.8 2-2.8s-2.8-2.6-4.2-2.2-1 2.4-.2 2.7"
    />
    <g fill="none" strokeMiterlimit={10} strokeWidth={0.6}>
      <path
        stroke="#af6d4a"
        d="M576.4 289.1s-3.3 2-3.5 2.4c-.3.5-.5 5.8-.4 6s1.2 3 1.6 3.1c.3.2 7 4.1 7.5 4.2.5 0 3.7-.2 4.2-.4.4-.1 2.8-2 2.8-2M575 288s-2.4 2.4-3.4 2.6c-1 .1-7.3-.8-7.6-1.2-.4-.4 2.3-3 6.2-4.5m-7.7 6 7.3.8c.6 0 1 2.9.9 5l-.3 4.3-9.3 3c-.5.1-1.9-4.1-1.7-7.5.2-3.3 2.5-5.7 3-5.6zm28.1 14.9-5.8.5c-1 .1-1.5.8-1.5 1.8s-1 9-1.2 9.8-.1 1.7 1.2 3c1.4 1.2 4 3.1 4.8 3.5.6.4 2.5 1 5 .2l6.6-2m-21.6-.1c.9-.4 2.3-1 3.7.2 1.4 1.1 4.8 5.5 5.2 6.2.4.6.4 1.2.3 2.2l-.8 7.5c-.3 1.1-.7 3.1-3.2 4.2-2.5 1-8.6 4.5-10.8.3-2.3-4.2-6.3-13.6-6.6-14.6-.4-.9 0-1.5 2-2.1zm6 22c1.9-.9 4.3-1.4 5.4.6 1 2 4.3 8.2 5.4 9.6 1 1.4 1.6 6.2.1 7.5a73 73 0 0 1-7.3 5c-.8.4-3.5 0-4.2-2-.8-2-6.6-11.2-8.3-12.6-1.6-1.3-1.6-4.4 1.1-5.1a84 84 0 0 0 7.8-3zm10.6 22.3c1.2-.5 1.5-.8 2.4 0 .8 1 7.9 7 9 7.8 1.3.8 1.3 1.4 1.2 2.7 0 1.4.7 9.1.6 10.8 0 1.6 0 2.1-1.8.5a182 182 0 0 1-12.8-13c-1-1.6-4.2-7.3-2.6-7.6s2.6-.7 4-1.2zM610 373s-2.5-.2-3-.9c-.5-.6-6.3-5.5-7.2-6.3-1-.8-1.7-1.4-1.6-2 0-.6 0-4.6-.2-5.5-.2-1 1.1-1 2.3-1 1.1 0 8.5.5 8.5 1m0-1.7-9.2-.4c-1.1-.1-1.6-1.1-2.5-2.9l-2.3-4c-.3-.6.4-1.3 1.4-1.6s7.4-2.6 10.5-5.2m-1-3.3s-2.5 2.9-5.3 4.2a29.6 29.6 0 0 1-5.3 2c-.8.1-2.2.2-3-.8-.9-1-2.3-2.5-2.8-2.8s0-1.8.2-3l1-11c0-.9.8-1 1.8-1.3s7.5-2.7 8-2.6"
      />
      <path
        stroke="#af6d4a"
        d="M565.3 284.7c.3.5 1.2 1.3-2 2.6-2.8 1-6.2 6.1-6.3 8.3-.2 2.2 1.3 6.8 1.4 8.1.1 1.4.7 2.6-2.9 3m15-4.2c.7-.2 2-.3 3 .2l5 3c.6.1 1.6 2.4 1.6 2.4s.5 1.5.4 2.7a66 66 0 0 1-.4 6.9 11 11 0 0 1-3.4 3c-1.6 1-7.8 3-9.1 3.3-1.3.2-2.6-1.3-2.6-2.7s-1-6.5-1.5-8c-.4-1.6-2.4-8-.3-8.7 2.2-.8 7.2-2 7.2-2zm-2.2 38.3c-.8-3-4.7-10.4-5-11.7-.3-1.4-.8-1.7-1.4-1.5l-3 .9c.2 2.4.5 4.5 1 6.2.8 2.7 4.8 7.6 5.5 8.9l1 2 1.3-.4c1.7-.6 1.4-1.4.6-4.4zm-5.2-18.6c-.3-1.9-3.6-10.6-3.7-12.3-.2-1.6-1.2-2.1-2-1.9a76 76 0 0 0-1.9.6c1 5.2 2.4 12.4 2.8 15.3 0 .8.2 1.6.3 2.3 4.8-1.5 4.7-2.2 4.5-4zm18.9 43c.1-1.4-5-6.7-6.9-9a20.4 20.4 0 0 1-4-7.7c-.2-1.9-.6-1.9-1.7-1.5l-2 .7a88 88 0 0 0 5.8 10.4l7.8 9.6c1.1-1 .9-1.5 1-2.5zm25.7 28c.3-.3-6.1-6-8.9-8.6a88 88 0 0 1-10.2-12.5c-.8-1.8-1.6-1-2.4-.8l-1.5.8c3.3 4 6.3 7.6 7.4 8.7 2 2.1 10.7 11.4 14.5 13.7.8-.6 1-1 1.1-1.2z"
      />
      <path
        stroke="#000"
        d="M554.6 303c.2 3 3.2 16.7 3.7 20.9.5 4.1.8 8.1 1.6 10.8s4.8 7.6 5.5 8.9 5.1 10.9 7.8 14.5a583 583 0 0 0 19 22.7c2.4 2.6 15.2 16.4 16.2 13.9"
      />
      <path
        stroke="#b49578"
        d="M552.4 323s1.2 2.5 1.3 5.2c.1 2.8-5 3.8-8.1 3.9-3.2 0-3.4-.2-3.4-.2m0 1s5-.1 7.8-.5c2.7-.5 3.5.5 4 2 .4 1.5 2.3 5.6 3 7 .6 1.3-.3 3.6-2 4.6l-5.6 2.5m2.1 3.4 5.4-4.3c1-.8 2.6-.8 4.1 1.5s3.8 7.4 4.8 8.7 1.2 2.8.2 3.8-3.3 4.5-3.3 4.5m1.3.8s3.2-3.7 4.4-4.4 2.1 1.4 4.2 4.8"
      />
    </g>
    <path
      fill="#494037"
      d="M577.6 368.6c-1.2-.6-2.8-.4-2.2.8s2.7 3 3.6 3.1c1 0 1.1-.7.8-1zm-2.5 2.9c-1 .1-1.1 4.3-.7 5 .5.9 1.3 1.7 2.1.2s1.7-2.6 1-3.4c-.8-.8-2-1.9-2.4-1.8m-3 5.9c.2-.8-.1-4 1-2.7 1.2 1.4.2 4 1 4.3.9.3 2.4 1.3.8 2-1.5.8-2.4 2.2-2.5 1.3-.2-.9-.3-5-.3-5zm1.9 6.3c0 1 .5 4.1 1.1 5 .6 1 2.1 1.6 2.3.2.2-1.5.5-3 1-3.3.7-.3-.2-1.3-1.9-2.2-1.6-.9-2.6-.6-2.5.3m3 7.6c-.1 1 1.8 1.3 1.7 2.3 0 1 .4 3 1.3 2.5.9-.6 1.2-2.3 1.3-2.8 0-.5-.2-2.3-1.5-2.8-1.3-.6-2.6-.9-2.8.8m4 5c-.6.2-.8 3.2-.1 3.8s2.3 1.3 2.2-.1c-.1-1.5.9-1.6 1-2.2 0-.7-1-2.2-3-1.6zm.1-6.1c-.5.8.5 2.1 1 2.7.6.6 1 1.3 1.8.4.8-.8 1.9-2.2.5-3.2-1.3-1-2.6-1.1-3.3 0zm1.5-6.2c-.4 1-1.5 2.8-1 3.2.5.5.9 1.2 1.9 1.2s2.9-1.3 3.2-1.8-1.5-2.2-2.2-3c-.6-.8-1.2-1-1.9.4m2.6 4.6c-.6.4.8 1.5.7 2.3 0 .9.1 1.7 1.7.8 1.5-.9 3.3-1.6 2.1-2.9-1.1-1.3-2.4-1-3-1-.7.1-1.2.6-1.5.8m5.3 3.5c0-.4-.5-.4-1.5.7-1 1-3.3 2-2 2.3 1.3.5 2 1.2 2 1.8 0 .5 1 1.9 1.5 1.4.6-.6 2-.3 2-.3s-2-4.4-2-6z"
    />
    <path
      fill="#494037"
      d="M585.7 394.5c-.5-.7-1-1.6-1.3-.3-.3 1.2-.7 2.2-.3 2.6.3.4 1.5.9 1.4 1.4 0 .4 2 1.1 2.2 0 .1-1-.3-2-.5-2.3s-1-.6-1.5-1.4m-1.8 5.1c-1 1-1 2.5-1 3.4 0 1 0 2.6.6 3.2.7.7 2.1 2.6 4 2.7 2 .1 2.3-.6 1.5-2.1-.8-1.6-4-8.2-5.1-7.2m1 10.9s2.1-.5 3 .1c1 .6 1.4 1.5 2 1.9.5.4.8 1.4-.8.6-1.5-.7-4.2-2.6-4.2-2.6m8.3-10c-.8-1-1.2-1-2.6-1-1.5.1-2.9-1-3 .3s1.7 3.2 1.6 4 1.2 2.3 1.1 3c0 .9 1 1 1.7.5.7-.4 1.7-.1 1.6-1.6zm1.1 8.4c-1-.3-2.4-.4-2.9-.1-.5.2-.9 1.3-.1 2.3.7 1 1.6-.6 2-.7.5-.2 1.9-1.2 1-1.5m-16.2-32.1c.2 1 2.8 3 3.1 1.7.4-1.2 1.6-2.5.7-3.5-1-1-2.7-2-3-1.2-.2.9-.9 2.5-.8 3m-1 2c-.2.8-.6 1.7-.6 2.2s1.3 1.6 1.7 1.7c.5.2 2.3 3.1 2.7 2.5.3-.7 1.4-4.4.7-4.7-.8-.3-4.3-2.5-4.5-1.8zm7-2.2s-1.3.2-1.5 1.2c-.1 1-.4 1.8.6 2.8 1 1.1 2.8 2.3 3.5 1.7l1.4-1.7zm3.9 5.7c-1.5 0-2 1-1.1 1.4.9.6 1.9 1.5 2.1 2.2.3.7 1.4.3 1.4-1.2a2.5 2.5 0 0 0-2.4-2.4m-15.8 18c0-1.5-.2-4.7-1.2-2.8-1 1.8 1.5 6 1.2 2.8m-4.1-5c0 1 1.1 1.8 2 .4 1-1.3-.8-.4-.9-1.5 0-1-1 .2-1.1 1.2zm-.7-4c-.5-1 0-3 1-2.7.8.3 1.8 2 1.2 1.9-.7 0-1.4 2.4-2.2.9zm3.3 0c0 .7-.4 2.5.5 2.5.8 0 2-1.2 1.3-2.3-.5-1.2-1.7-1-1.8-.1zm-3-11c.3 1.4 1.8 1.2 1.7 2.3 0 1.1-.6 4 .6 2.8a5.2 5.2 0 0 0 1.3-4.2c-.2-.8-.2-2.3-1-2.4-1 0-3-.3-2.5 1.6zm-1.7 3.4s1.3-1.7 1.5-.4 1.3 2.6 1.1 3c-.2.5-2.9 1.9-2.8.4z"
    />
    <g fill="none" stroke="#000" strokeMiterlimit={10} strokeWidth={0.6}>
      <path d="M545.6 275s-2.2-3.9-3.1-4.7c-.9-.7-1.6-4-1.7-5-.4-3.7-5.2-5-4.1-5.7 0 0 6.3-4.6 11.5-1.9 5.3 2.8 13.4 8.6 13.5 14.3-.3 8 2.6 13 2.6 13" />
      <path d="M548 285.3s-8.3-8.3-8.6-11.8c-.3-3.8-3-11.4-1.3-12.3" />
      <path d="M547 284.1s-1.3 4.9-.5 7.5l-1.2 2" />
      <path d="M553.4 293.5s-3.3-2.3-7.4-.3c-2.8 1.3-3 2.2-3 2.2s-3 .4-3.3 2c-.4 1.4-3.2.9-7.5 4.7-4.3 4-6 8-7.9 9s-3.1 10.6-3 14.1c0 3.6-1.3 10-.3 12.4a131 131 0 0 0 7.3 12.2c1 1.4 4.6.5 6-4 1.5-4.3 0-6.2 0-8.2.2-2-1.5-3-.7-5.6.8-2.7 3.9-12 4.6-13.4a13 13 0 0 1 5-4.1c1.7-.8 8.1-5.4 8.1-5.4m3.4-12.8c0-2.4 4.6-9.4 7.1-10.4s5.9-2.6 9.7-.6a81 81 0 0 1 15.8 15.3c3 4 10.4 15.4 15.2 28.6 4.8 13.1 6.4 22 6.4 27.9 0 5.8 2 8.4 1.2 16.8-1 8.4.4 15.6-1 19.6-1.6 4-6.1 1.6-8.6-.8-2.4-2.4-17.3-16.5-19.3-19.4-2-2.8-8.1-10-11.7-15.5-3.6-5.4-5.2-10.3-6.7-12.5s-3-2.7-5.1-7.6c-2.1-4.8-.6-10.6-.9-11.7-.2-1.1-2.7-6.2-2.1-29.7z" />
      <path d="M538.8 317.7c1.4-1.3 3.9 2.9 7.5 4.6 4 2 9.6.4 9.3-2.1" />
      <path d="M541.1 318.4c-.5 6-1 28.9 31.2 56.1" />
      <path d="M573 362.7c-.5 8.4-2.9 21.9 3 33.2 6 11.3 7.7 13.5 8.9 14.6 1.6 1.6 5.8 3.7 8 3.8 2.2 0 2.2-4 2.3-5 0-.9-1.9-2.4-1.7-5.2a22 22 0 0 0-2.5-9.9c-1.4-2.4.8-6.5-1-11.6" />
    </g>
    <path d="M548.3 261.8c1 .8 1 1.4.8 2.8-.1.7-2 0-3-1s-1.8-2.2-1-2.3 2-.3 3.2.5" />
    <path
      fill="#fff"
      d="M546.8 262.5c0 .2 0 .5-.3.6-.3 0-.6-.1-.7-.3 0-.3.1-.5.4-.6.2 0 .5 0 .6.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M568 370.7s-3 11.7-2 21.9c1 10.1 4.2 13.4 5 14.5s1.6 0 2.8-.8 5.9-3.7 5.5-4.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M609 357c0-5.8-1.7-14.7-6.5-27.8a126.2 126.2 0 0 0-15.2-28.6c-3-4-12-13.3-15.8-15.3-2.7-1.4-5-1-7.2-.3 0 0-2.9-5-2.6-13-.1-5.7-8.2-11.5-13.5-14.3-5.2-2.7-11.5 1.9-11.5 1.9-.6.3 0 1 1 1.8-1.5.8 1.4 8.3 1.7 12 .2 2.8 5.3 8.3 7.6 10.7 0 0-.4 1.5-.6 3.3l-.6 3.1c-2.4-2.5-11.1-11.3-18-12.6-8-1.6-13.2-.2-15.6 1.7-2.1 1.8-8.5 6.8-10.6 11.3h12a9.5 9.5 0 0 1 7-2c7 .3 8 2.8 7.6 3.4s-.6 2.5 2.2 3.8a9 9 0 0 1 4 4.3l-2.2 1.7c-4.3 4-6 8-7.9 9s-3.1 10.6-3 14.1c0 3.6-1.3 10-.3 12.4a131 131 0 0 0 7.3 12.2c1 1.4 4.6.5 6-4 1.5-4.3 0-6.2 0-8.2.2-2-1.5-3-.7-5.6.8-2.7 3.9-12 4.6-13.4 0-.3.3-.6.6-.9l1.9.3.4.4c-.4 5.8-.9 26.8 26.8 52.3 0 0-2.9 11.8-1.9 21.9s4.2 13.4 5 14.5 1.7 0 2.8-.8 5.9-3.7 5.5-4.4c3.4 6.2 4.7 7.7 5.6 8.6 1.6 1.6 5.8 3.7 8 3.8 2.2 0 2.2-4 2.3-5 0-.9-1.9-2.4-1.7-5.2a22 22 0 0 0-2.5-9.9c-1.4-2.4.8-6.5-1-11.6l10.5 10c2 2.1 5.7 4.2 7.7 2.3l.2-.2.6-1.2c1.5-4 .1-11.2 1-19.6 1-8.4-1.1-11-1-16.8z"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-bw)"
      d="M12.5 392.7c1.6 14.4-.7 27 1.9 33.8 2.5 6.9 10.4 2.7 14.5-1.4l18-17.5a196 196 0 0 0 15.2-15.8c2.4-3.5 8.7-10.9 14.3-18.3 2.1-2.9 4.2-5.7 6-8.4 6.1-9.4 8.8-17.7 11.4-21.5 2.6-3.9 5.2-4.7 8.8-13 3.7-8.4 1-18.3 1.5-20.2.2-1 1.2-3.4 2.2-10 1-7.3 2-19.8 1.5-41.1 0-4-8-16.1-12.3-17.8l-4.3-1.7a15 15 0 0 0-12.3.6 139.3 139.3 0 0 0-27.2 26.3A217 217 0 0 0 25.5 316c-8.3 22.6-11 37.9-11 48 0 10-3.5 14.4-2 28.8z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-D)"
      d="M77.7 393.6c-.2-7.5-1-14.5-1.3-20-5.6 7.3-11.9 14.7-14.3 18.2a196 196 0 0 1-15.2 15.8c-3 8.9 1 16-1.6 20.1a36.8 36.8 0 0 0-4.2 17c.2 4.7-3 7.4-3 9 .1 1.5.2 8.6 4 8.5 3.8-.2 11-3.8 13.8-6.6a64 64 0 0 0 9.5-14.6 549 549 0 0 0 5.6-10.4 72.9 72.9 0 0 0 6.7-37"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-E)"
      d="M65.4 441c-.5 1 7.5 6 9.5 7.5s3.5 3.3 4.8 1.3c1.4-2 6.7-7.5 8.5-25 1.8-17.4-3.2-37.6-3.2-37.6a232 232 0 0 1-7.3 6.4 73 73 0 0 1-6.7 37 537 537 0 0 1-5.6 10.4"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#e6c7ac"
      d="M360.9 362.7c.1 3.3.6 7.3.8 11.7a135 135 0 0 0 4.2-3.7c27.7-25.5 27.3-46.5 26.8-52.3-1.3 1-3 3-5.2 4-3.9 1.9-9.5.3-9.2-2.2-.6 3.8-1.2 5.3-1.3 5.8-.3 1 1.3 6.9-.9 11.7-2 4.9-3.6 5.4-5.1 7.6s-3 7-6.7 12.5a95 95 0 0 1-3.4 5z"
    />
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-F)"
      d="M135.1 296.2c.5.5.8 1 1 1.5a336 336 0 0 1 7.9 23c1.3 4.6-1.5 6.1-1.3 9.6s-2.5 6.7 0 14.3 8.8 9.2 10.5 6.7c1.6-2.4 10.7-16.8 12.4-21 1.8-4-.6-15.1-.4-21.2s-2-22.7-5.2-24.5c-3.2-1.7-6.2-8.6-13.5-15.2-7.4-6.7-12.2-5.8-13-8.3-.6-2.6-5.8-3.3-5.8-3.3s-.2-1.3-3.7-3.2l-2.2-3.4c1.4-4.4-.7-12.8-.7-12.8 3.9-4 12.5-13.6 13-18.3.5-6.5 5-19.6 2.3-21 1.8-1.5 3.2-2.4 2.3-3 0 0-10.8-7.9-19.8-3-9 4.7-23 14.7-23.1 24.4a45 45 0 0 1-4.6 22.3l4.3 1.7c4.3 1.7 12.2 13.8 12.3 17.8.5 21.3-.5 33.8-1.5 41.1-.6 4.3 9.1 7 16 3.7 3.5-1.8 6.5-5 8.8-6.8 1.7-1.4 3-2 4-1.1m-17.6-91.4c-.3-2.4-.4-3.4 1.3-4.6 2-1.5 4.1-1.2 5.4-1 1.4.3.1 2.4-1.6 4.1-1.8 1.7-5 2.8-5 1.5z"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#f0ceb8"
      d="M385.5 261.9c-1 .7-.9 1.3-.7 2.7.1.8 2 .1 3-.9s1.7-2.2 1-2.3c-.8-.2-2.1-.4-3.3.5m1.8 1.2c-.2-.1-.4-.4-.3-.6 0-.2.4-.4.6-.3.3 0 .5.3.4.6-.1.2-.4.3-.7.3"
    />
    <path
      fill="#f0ceb8"
      d="M387 262.5c0 .2 0 .5.3.6.3 0 .6-.1.7-.3 0-.3-.1-.5-.4-.6-.2 0-.5 0-.6.3"
    />
    <g
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.3}
    >
      <path d="M388.2 275s2.3-3.9 3.1-4.7c.9-.7 1.6-4 1.8-5a5.6 5.6 0 0 1 2.7-4c1-.9 1.9-1.4 1.3-1.7 0 0-6.2-4.6-11.5-1.9-5.3 2.8-13.3 8.6-13.4 14.3.2 8-2.7 13-2.7 13" />
      <path d="m385.8 285.3 1-1.2c2.3-2.3 7.4-7.9 7.6-10.6.3-3.8 3-11.4 1.4-12.3" />
      <path d="M386.9 284.1s1.2 4.9.4 7.5l1.2 2m-8.1 0s3.3-2.4 7.4-.4l.7.3c2.1 1.2 2.2 2 2.2 2s3 .3 3.5 1.8c.3 1.5 3.2 1 7.4 4.8 4.3 4 6 8 8 9 1.8 1 3 10.6 3 14.1-.2 3.6 1.2 10 .2 12.4a131 131 0 0 1-7.3 12.2c-1 1.4-4.6.5-6-4-1.5-4.3 0-6.2 0-8.2-.2-2 1.5-3 .7-5.6-.8-2.7-3.9-12-4.5-13.4l-.7-.9c-1-1.2-3-2.6-4.4-3.2-1.7-.8-8.1-5.4-8.1-5.4m-4.2 11c.6-4.2 1.1-11.4.9-23.8 0-2.4-4.7-9.4-7.2-10.4l-2.5-1c-2-.6-4.5-1-7.2.4a81 81 0 0 0-15.8 15.3c-3 4-10.4 15.4-15.2 28.6a84.7 84.7 0 0 0-6.4 27.9c0 5.8-2 8.4-1.2 16.8 1 8.4-.4 15.6 1.1 19.6s6 1.6 8.5-.8l10.4-10.1c4.1-4 8-8 8.9-9.3 1.4-2 5-6.3 8.3-10.6a95 95 0 0 0 3.4-4.9c3.6-5.4 5.2-10.3 6.7-12.5s3-2.7 5.1-7.6c2.2-4.8.6-10.6.9-11.7 0-.5.7-2 1.3-5.8z" />
      <path d="M392.7 318.4c-1.3 1-3 3-5.2 4-3.9 1.9-9.5.3-9.2-2.2m16.7-2.5c-.6-.5-1.3-.1-2.3.7m0 0c.5 5.8 1 26.8-26.8 52.3a135 135 0 0 1-4.2 3.7l-.2.1" />
      <path d="M360.9 362.7c.1 3.3.6 7.3.8 11.7.2 6.9-.3 14.6-4 21.5a323 323 0 0 1-3.2 6 37.2 37.2 0 0 1-5.5 8.6 16.8 16.8 0 0 1-8 3.8c-2.3 0-2.3-4.1-2.4-5 0-.9 1.9-2.4 1.7-5.2a22 22 0 0 1 2.5-9.9c1.5-2.4-.8-6.5 1-11.6m41.7-120.7c-1 .7-.9 1.3-.7 2.7.1.8 2 .1 3-.9s1.7-2.2 1-2.3c-.8-.2-2.1-.4-3.3.5" />
      <path d="M387 262.5c0 .2 0 .5.3.6.3 0 .6-.1.7-.3 0-.3-.1-.5-.4-.6-.2 0-.5 0-.6.3m-21 108.2s3 11.7 1.9 21.9c-1 10.1-4.2 13.3-5 14.5-.8 1.1-1.6 0-2.8-.8-1.1-.8-5.8-3.7-5.5-4.3q0 0 0 0" />
    </g>
    <path
      fill="url(#sh-ac_svg__sh-ac-ac-G)"
      d="m107.6 273-5.3 29.3c-.2.7-2 14.6-2 14.6s-1 9-4 13.5-6.9 10.3-11.2 18.8c-4.4 8.5-7.5 15.3-24.2 34.8-16.6 19.6-26.4 30-26.4 30s-14.2 14.3-17.8 15c-1.2.5 1.6 1.4 2.8 1.3 1.2-.2 4.1-1 5.7-2.1 1.5-1.1 24.6-23.4 24.6-23.4s11.7-10.8 27.6-32.6c15.9-21.7 12.2-24.7 18.3-31a33.7 33.7 0 0 0 8.9-22l-.5-8.6s3.4-16.2 3.5-22.5v-15"
      transform="translate(316.5 145.5)scale(.58162)"
    />
    <path
      fill="#f0955d"
      d="M365.5 340.8c.8-3 4.7-10.4 5-11.7.3-1.4.8-1.7 1.4-1.5l3.1.9c-.3 2.4-.6 4.5-1 6.2-.8 2.7-5 7.6-5.6 8.9l-1 2-1.3-.4c-1.7-.6-1.4-1.4-.6-4.4m5.2-18.6c.3-1.9 3.6-10.6 3.8-12.3.1-1.6 1-2.1 2-1.9a76 76 0 0 1 1.8.6c-1 5.2-2.4 12.4-2.8 15.3l-.2 2.3c-4.9-1.5-4.8-2.2-4.6-4m-18.9 43c-.1-1.4 5-6.7 6.9-9a19 19 0 0 0 4-7.7c.3-1.9.6-1.9 1.7-1.5l2 .7a88 88 0 0 1-5.8 10.4c-1.2 1.6-4.3 5.5-7.8 9.6-1-1-.9-1.5-1-2.5m-25.7 28c-.3-.3 6.1-6 8.9-8.6a88 88 0 0 0 10.2-12.5c.8-1.8 1.6-1 2.4-.8l1.6.8c-3.4 4-6.4 7.6-7.5 8.7-2 2.1-10.7 11.4-14.5 13.7-.8-.6-1-1-1.1-1.2z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bd)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M84.4 335.8c1.3-5 8-17.8 8.5-20.1.5-2.4 1.3-2.9 2.4-2.6l5.4 1.6c-.5 4-1 7.8-1.9 10.6-1.3 4.6-8.3 13.1-9.5 15.3l-1.8 3.6-2.1-.8c-3-1-2.4-2.5-1-7.6m9-31.9c.4-3.3 6-18.3 6.3-21.2.4-2.8 2-3.7 3.4-3.3a130 130 0 0 1 3.3 1c-1.7 9-4.2 21.5-4.8 26.3l-.5 4c-8.3-2.5-8.2-3.8-7.7-6.8m-32.6 74c-.2-2.5 8.7-11.6 11.8-15.5 3.2-4 6.7-10.2 7-13.4.4-3.2 1-3.2 2.9-2.5l3.3 1.2c-2.9 5.9-7 14-9.9 17.9-2 2.7-7.4 9.4-13.4 16.5-1.9-1.6-1.5-2.6-1.7-4.3zM16.6 426c-.5-.6 10.5-10.5 15.3-15 4.7-4.3 16.2-18.3 17.6-21.3 1.3-3 2.7-1.8 4-1.4l2.7 1.4a404 404 0 0 1-12.8 14.9c-3.5 3.7-18.4 19.6-25 23.5-1.3-1-1.5-1.6-1.8-2z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M379.2 306.8c-3.6-.4-4-1.7-3.8-3 .2-1.4 1.6-6 1.4-8.2 0-2.2-3.5-7.2-6.3-8.3-3.1-1.3-2.3-2.1-2-2.6 0 0 3.9 1.2 5.2 2.4a21 21 0 0 1 5.5 10.4c.4 4.1 0 9.3 0 9.3"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bc)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M107.9 277.4c-6.3-.7-6.8-3-6.5-5.3.2-2.3 2.7-10.2 2.4-14-.2-3.8-6-12.4-11-14.3-5.3-2.1-3.8-3.6-3.2-4.4 0 0 6.5 2 8.8 4.1 2.3 2 8.9 10.6 9.5 17.8s0 16 0 16z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M363.4 302.5c-.7-.2-2-.3-3 .2l-5 3c-.7.1-1.7 2.4-1.7 2.4s-.5 1.5-.4 2.7c0 1.2.2 6.4.4 6.9a11 11 0 0 0 3.4 3c1.6 1 7.8 3 9.1 3.3 1.3.2 2.6-1.3 2.6-2.7s1-6.5 1.5-8c.4-1.6 2.5-8 .3-8.7-2.1-.8-7.2-2-7.2-2z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bb)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M80.7 270a7.3 7.3 0 0 0-5.2.3c-1.7.9-7.7 4.7-8.7 5-1 .4-2.7 4.3-2.7 4.3s-.8 2.7-.7 4.7c0 2 .3 11 .6 11.8.4.7 3 3.6 5.9 5.2a99.5 99.5 0 0 0 15.7 5.6c2.2.4 4.4-2.3 4.5-4.6 0-2.4 1.8-11 2.5-13.8.7-2.6 4.2-13.6.5-15-3.7-1.3-12.4-3.4-12.4-3.4z"
      />
    </g>
    <path
      fill="#fdf2e8"
      d="M377.4 282.5s7.1.4 6.3 1.5c-1 1.1-1.6 2.9-3 2.4-1.5-.5-6.3-3.7-3.3-3.9"
    />
    <g fill="#d5ccc0">
      <path d="M396.4 264s-.8-.5-1.4 1.8a41 41 0 0 1-2.5 7.5c-.8 1.5-6.6 10-7.3 11-.7.9.6 2.5 1 1.8.4-.6 0 3.3-.3 4-.4.7-.5 2.2-1.5 2.3-1.1 0 0 0 0 0s3.3.4 3.4 2.2c0 1.7 2.5-.4 1.3 1.5-1.2 2-.4 5.4.7 3.5 1-1.9 3.2-3.9 3.3-2.6.2 1.3 1.2 1.5 1.6 1.6.4.2 3.4 1.6 5 3a68 68 0 0 1 6.9 7.2c1.3 2 3.9 3.3 5.2 8.7 1.3 5.5 0 0 0 0s-1-5.4-2-6.2c-1-.9-4-4.6-4.8-5.6-.9-1-4.7-5-6.9-6s-3.9-1.8-4-2.2c0-.5-.8-1.4-1.9-1.7-1-.3-1.2 0-1.6-.7a8.5 8.5 0 0 0-2.1-1.7l-.6-1s-.7-.4-.5-1.2c.1-.7 0-3.8-.1-5.1 0-1.4-.6-1.8 0-2.3.4-.6 4.5-4.8 5.7-7.2a20 20 0 0 0 2-6.4c0-1.4 1.4-6.2 1.4-6.2" />
      <path d="M385 311.2s-1.2 0-2.7-.4c-1.4-.3-3.4.2-3.2-1.5l.1-12.1s.6-2.3-2.4-6c-3-3.9-4.1-5-5.1-5.4l-.3-.1s1.8-1.4 2-4.5c.3-3 .7-9.3 1.2-6.7.4 2.6-.9 5.2.7 6.1 1.6 1 5.9 1.5 7.2 1s2.6-2.8 2.6-2.8l2.8-3.3c.3-.5 1.4.4.2 1.4s-3 3-3.1 4c0 1 1 1.6-1 2.6-1.9 1-1.6.6-3.2.3-1.7-.2-3.7-.8-4-1.1s-1.7-.3-.6.6c1.1 1 2.7 3 4.5 3 1.7.1 2.7 0 3.3-.5.6-.4 1.6-.3.8.2s-1.7 1-3.4 1.3c-1.3.2-2.5.8-4.2-1.2-1.7-1.9-2.3-2.1-2.3-3.6s-1.3 1.3-.2 3.5c1.2 2.3 5 4 6.7 4.5 1.5.6 2.8 1.7 1.8 1.9-1 .1-2.8 1-3 1.5-.3.6 0 1 .8 2.5.9 1.6 3.7 10.9 5.6 13 2 2.1 4.2 5.3 2.5 4.2l-4.4-2.9m11 7.5a53.7 53.7 0 0 1 7.2 14.6c.5 3.3-2.7 5.3-2.4 8.5.4 3.2 1.9 9.5 3.3 7.7s4.5-3.5 3.4-1.7c-1.1 1.7-2 4.3-4 3-2-1.5-4.6-3.7-4.4-8.1.1-4.4.8-4.3 1-6.3.4-1.5.6-2.5.5-3.4 0-.9-4.7-14.3-4.7-14.3z" />
      <path d="M382.7 312s.7 2.7 1.9 1.8c1.2-1 2.8 0 2.3.5-.5.4 0 1.8 1.4 1.7 1.5 0 2.2 0 2.3.5 0 .6.5 1.6 1.2 1.5.7-.2-2 2.9-2.5 3.3l4-3.4c1-.8 1.7-.4.5-1.4-1.2-.9-8.4-5.3-8.4-5.3s-.7 1.2-2.7.8" />
    </g>
    <path
      fill="#fdf2e8"
      d="M391.3 270.3c-.1-1.8-2.5-3.6-4.5-1.6s-3 6.7-5.5 5.5c-2.7-1.2-7.2-3.2-6.6-.7.5 2.4 2.9 5.3 5 5 2.2-.4 6.2-1.5 11.6-8.2m-6.2 8.5c.6-1.3-2.6.9-5.3.7-2.6-.2-2.2 1-.8 1.5 1.5.4 2.6 1.1 3.3.7.8-.4 2.4-2 2.8-3zm-6.8 8.3s1.8 2.6 2.5 2.5c.8-.2 2-2.6 2-2.6s-3.1 1.3-4.5 0zm19-27s-5.5-3-8.5-2.5-7 3.6-8 4.2c-.8.6-3.1 3.7-4 3.5-.8-.2-.8-.7.5-1.9 1.3-1 7.4-6.3 10.9-6.5 3.5-.3 7.3 1.8 8.1 2 .8.3 1 1.1 1 1.1m-25 13.3s1 1.5.8 2.6c0 1-2 9.7-2 9.7l-1.6-.4s3.2-9 2.9-11.9z"
    />
    <path
      fill="#d5ccc0"
      d="M379.1 309.3s1.6.3 1.4 3.1c-.1 2.9-.3 8 .5 8.8.9.9 7.6 1.3 5.2 1.6-2.3.4-6.7.4-7.6-1.3-1-1.7 0 0 0 0l-.3-1.9z"
    />
    <path
      fill="#ad5f38"
      d="m364 302.7-5.2 2.8 7.1-2.4zm4.9 1.3-6.1 2.6 8.2-1.7m.6 1.9-7.3 1.6 7.2-.1m-.5 2.5-11.7-1.7 10.8 5m-.2 1-11.5-3.2 10.6 7.6m0 .9-10.9-6.1 10 8.8m-1 .7-5.4-4.7 2.8 4.4m-2.6-.8-4.7-6.7 1.8 5.6m-2-1-2-3.9.5 3"
    />
    <path
      fill="#f0955d"
      d="M357.4 289.1s3.3 2 3.5 2.4c.3.5.5 5.8.4 6s-1.2 3-1.6 3.1c-.3.2-7 4.1-7.5 4.2-.5 0-3.7-.2-4.2-.4-.4-.1-2.8-2-2.8-2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-ba)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M70.4 247s5.7 3.3 6 4c.5.9.8 10 .7 10.4-.2.3-2 5-2.7 5.4-.6.3-12.1 7-13 7.1-.8.1-6.3-.3-7-.6-.9-.2-5-3.4-5-3.4"
      />
    </g>
    <path
      fill="#f0955d"
      d="M358.7 288s2.4 2.3 3.4 2.5c1 .1 7.3-.8 7.6-1.2.4-.4-2.2-3-6.1-4.5"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a9)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M72.6 245s4.2 4 5.9 4.3 12.5-1.4 13.1-2c.6-.7-3.9-5-10.6-7.8"
      />
    </g>
    <path
      fill="#f0955d"
      d="m371.2 290.8-7.2.8c-.6 0-1 2.9-1 5l.3 4.3 9.4 3c.4.1 1.8-4.1 1.6-7.5-.2-3.3-2.5-5.7-3-5.6z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a8)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="m94.2 249.8-12.5 1.4c-1 0-1.8 5-1.6 8.6l.4 7.5 16.1 5c.8.3 3.2-7 2.8-12.8-.3-5.7-4.2-9.8-5.2-9.7"
      />
    </g>
    <path
      fill="#f0955d"
      d="m343 305.7 6 .5c1 .1 1.4.8 1.4 1.8.1 1 1 9 1.2 9.8s.1 1.7-1.2 3c-1.4 1.2-4 3.1-4.7 3.5s-2.6 1-5 .2l-6.7-2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a7)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M45.8 275.5s8.3.6 10 .9c1.8.2 2.6 1.4 2.7 3.1a263 263 0 0 0 2 16.8c.4 1.3.2 3-2.2 5a73 73 0 0 1-8 6.2 11 11 0 0 1-8.7.4l-11.4-3.6"
      />
    </g>
    <path
      fill="#f0955d"
      d="M355.6 322.4c-.9-.4-2.3-1-3.7.2a46.5 46.5 0 0 0-5.2 6.2c-.4.6-.4 1.2-.3 2.2.2 1 .6 6.3.9 7.5.2 1.1.6 3.1 3.1 4.2 2.5 1 8.6 4.5 10.8.3 2.3-4.2 6.3-13.6 6.6-14.6.4-.9 0-1.5-2-2.1z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a6)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M67.3 304.2c-1.5-.7-3.9-1.7-6.3.3s-8.3 9.6-9 10.7c-.6 1.1-.7 2-.5 3.8.3 1.7 1 10.8 1.5 12.8.4 2 1.1 5.4 5.4 7.3 4.2 1.8 14.7 7.7 18.6.5 4-7.2 10.8-23.4 11.4-25s-.2-2.6-3.5-3.7c-3.4-1.1-17.6-6.7-17.6-6.7"
      />
    </g>
    <path
      fill="#f0955d"
      d="M349.6 344.3c-1.9-.8-4.3-1.3-5.3.7s-4.4 8.2-5.5 9.6c-1 1.4-1.6 6.2-.1 7.5 1.4 1.3 6.4 4.6 7.3 5 .8.4 3.5 0 4.3-2s6.6-11.2 8.2-12.6c1.6-1.3 1.6-4.4-1.1-5.1a84 84 0 0 1-7.8-3z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a5)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M57 342c-3.2-1.5-7.4-2.4-9.2 1.1s-7.5 14-9.3 16.5c-1.8 2.4-2.8 10.6-.3 12.8s11.1 8 12.5 8.6c1.5.7 6 0 7.4-3.4 1.4-3.5 11.4-19.3 14.2-21.6s2.8-7.7-2-8.9c-4.6-1.2-13.3-5.2-13.3-5.2z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M339 366.7c-1.1-.5-1.5-.8-2.4 0-.8 1-7.9 7-9 7.8-1.3.8-1.3 1.4-1.2 2.7 0 1.4-.7 9.1-.6 10.8 0 1.6 0 2.1 1.8.5s12-11.4 12.8-13c1-1.6 4.2-7.3 2.6-7.6s-2.6-.7-4-1.2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a4)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M38.8 380.3c-2-.8-2.6-1.3-4.1.2A313 313 0 0 1 19 393.7c-2.2 1.5-2.1 2.4-2 4.8.1 2.3-1.2 15.6-1 18.4.1 2.8 0 3.8 3.1 1s20.5-19.7 22-22.4c1.6-2.7 7.2-12.5 4.5-13a28 28 0 0 1-6.9-2.2z"
      />
    </g>
    <path
      fill="#f0955d"
      d="M323.7 373.1s2.5-.2 3-.9c.5-.6 6.3-5.5 7.2-6.3 1-.8 1.7-1.4 1.7-2l.1-5.5c.2-1-1.1-1-2.3-1-1.1 0-8.5.5-8.5 1"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a3)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M12.4 391.4s4.4-.4 5.2-1.5S28.5 380.3 30 379c1.6-1.3 3-2.5 2.9-3.5s0-7.8.3-9.4c.2-1.6-2-1.8-4-1.7s-14.7.8-14.7 1.6"
      />
    </g>
    <path
      fill="#f0955d"
      d="m324.9 356.7 9.2-.4c1.1-.1 1.6-1.1 2.5-2.9l2.3-4c.3-.6-.4-1.3-1.3-1.6a38 38 0 0 1-10.5-5.2"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a2)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M14.5 363.1s13.8-.5 15.8-.7 2.7-1.8 4.4-4.9l4-7c.4-.9-.7-2-2.4-2.6a68.1 68.1 0 0 1-18-9"
      />
    </g>
    <path
      fill="#f0955d"
      d="M328 339.3a19.4 19.4 0 0 0 10.6 6.1c.8.2 2.2.3 3-.7.9-1 2.3-2.5 2.8-2.8s0-1.8-.2-3c0-1.2-1-10.2-1-11 .1-.9-.8-1-1.8-1.3s-7.5-2.7-8-2.6"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a1)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M19.8 333.2A33.3 33.3 0 0 0 38 343.8c1.4.3 3.9.5 5.3-1.2a39 39 0 0 1 4.7-4.8c.9-.6 0-3.2-.3-5.3a770 770 0 0 1-1.6-19c0-1.3-1.5-1.5-3.2-2-1.6-.6-13-4.8-13.8-4.6"
      />
    </g>
    <path
      fill="none"
      stroke="#af6d4a"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M368.6 284.7c-.4.5-1.2 1.3 1.9 2.6 2.8 1 6.2 6.1 6.3 8.3.2 2.2-1.2 6.8-1.4 8.1-.1 1.4.2 2.7 3.8 3"
    />
    <path
      fill="#ad5f38"
      d="M372.6 292h-6.5l5.3-1.2m1.8 2-8.7.4 9.4 1m.4 2.2-8.2-1.2 8 3.7m-.1 1-7.6-2.3 7 5m-2 .8-4.5-3.2 2 2.4m.3-13.1-6-.7 4.5-1.7s2.6 2.1 1.5 2.4m-3.4-3.7-3.1 1.4 4-.8m-4.4-1.1-.5 1.1 2.2-1.4s-.6-.1-1.7.3m-2.7 5.2-1.3.3 2.4.4m.4 1.3-1.5-.2 1.6 1.6m0 2.4-3-2 2.9 3.8m-.5 1-5-2.5 3.3 4.5s1.4-.8 1.7-2m-4.7 3.8-1.6-5 3.1 4.2M354 304l-1-4.5-1 5.4m-1.5 0-.1-3.3-2 3m-1-.5.2-2.3-1 1.6m.6 2.7-2 .7 5.2.5s-1.3-1.3-3.2-1.2m3.4 3-6-1 6.2 3m.2 1.8-6.2-1.6 6.8 3.7m.1 2-8-4 8.2 6.3m-1.3 1.4-7.4-6.4 5.6 8m-2.3 1.6-5.2-7 2 8.3m-3-.7-2-6v5.4m-2-.6-.7-4-1.5 3.3zm.2 1.7h-2.2l4.8.9m2.6.8-6.4.3 8.1 2s-.1-2.4-1.7-2.3m2 4.3h-8l8 2.6m.1 1.6-6.7-1.8 7.4 4.5m0 1.7-7.4-3.8 7.4 6.2m-1.1 1-6.8-5.5 4.8 7.7m-2.7.3-5.3-7.9 2 6.8m-3-1.4-2.5-6.2-.3 4.1m5.6 6-5.3-.5 9.1 3s-1.3-2.1-3.8-2.4zm3.2 3.5L331 348l6.4 4m-1 2.3L331 349l3.7 7m-2.1.3-4.1-6.5 2.2 6.6m-1.9.1-2.3-6.1.7 6.2m8.3 6.8-5-2.6 4.2 4.3m-1.2 1.3-4.3-3.3 2.8 4.3m-1.3 1.1-4.2-6.2 2.7 7.5m-1.3 1.1-3-9.3 1.4 10.8m-.9.4-1-6-.5 6.3m37.1-48.6-6.4.7 12.7 2m.7.5-13.4-.5 12.4 3-12.9-1.2 12.2 3m-.6 2-13.4-3.2 12 5.3m-1 3.1-8.9-5.7 7.5 8m-1 1.8-9.1-7.6 6.2 9.3s2-.3 3-1.7zm-4.5 1.6-6.3-9.1 3 8.1m-2.8-1.2-1.5-5.9-.8 4m11.2 8-8.7-2.3 9 4.5-10.4-3.5 9 5.3s1.3-1.2 1.1-4"
    />
    <path
      fill="#ad5f38"
      d="m358.2 352.8-10.7-3 9.3 4.8m-.5.6-9.9-3.1 8.2 5.5m-1 1.4-7.4-4.7 6 7.2m-.7 1.1-6.6-7 6 8.4m-.7 1.3-6.1-8.7 3.4 10.6s2-.7 2.7-2zm-4.5 1.6-2.8-8.4.4 6.9m-1.4-1-.9-4.9-1.1 3.6m3.2 7.3L339 368l2.9 5m-.6 1-4.3-3 3.1 5m-1 1.3-4.3-5.5 2.9 6.8m-1.5 1.6-3.8-6.8 2.2 8.4m-1.1 1-3.3-8.1 1.5 9.9m-1.8 1.8-1.6-10.6-1 12.9"
    />
    <path
      fill="#d5ccc0"
      d="M358.2 366.2s2.6 12.3.9 23.1 1.6-1.9 1.7-2.3a84.2 84.2 0 0 0 0-24.3zm-9.2 44.3s-9.5 5-8.7 1.3c.9-3.7 2-4.5 2.4-6.4.5-1.8.5-5-.6-3.8-1 1.2-.7-4 .5-5.5s3-6.2 2-6.2c-.8 0-1.1-3.8-.7-5.1.5-1.4 4.7 2.8 10-13.1l-10.1 10.8s-1.2 3.2-.6 6.9c.6 3.6-.9 5-1.6 7.4-.6 2.3-1.6 6.3-1.2 7.6.3 1.4-1.8 4-1.7 5.4 0 1.4.7 4.6 2 4.5 1.2-.2 6.5-1.6 8.3-3.8"
    />
    <path
      fill="#fdf2e8"
      d="M344 389.1c-.1-.6-.6-1.8.5-1.5 1.1.2.5 2.5.2 2.3-.4-.2-.5-.3-.7-.8m-2.6 12c0-.8 0-2 1-1.5 1 .4-.3 2.5-.6 2.3-.2-.2-.4-.4-.4-.9z"
    />
    <path
      fill="#d5ccc0"
      d="M361.5 380.5s1.1-4.6 3.5-3.2 3 10.4 3 10.4-.1-9.1-2.3-16.9l-4.2 3.7zm-3 13.8s2 12.4 3.4 11a49 49 0 0 0 6-13.3s-1 8.1-4 13.6c-1.8 3.3-3 1.6-4.7.3-1.8-1.4-4-2.6-4.7-4z"
    />
    <path
      fill="#c6ac95"
      d="M381.1 322.8s-2 1.6-1.7 3.6.9 4.2-.5 7.4c-1.5 3.2-1.9 6-3.6 8l-6.3 7.4s1.4-3.4 2.7-4.8c1.3-1.5 5.4-6 5.4-10.5l-.1-7.8 1.2-5.3s1 2.1 2.9 2m5.8.1s5.4 2 5.4 4.8.7-7.1.4-9.1c0 0-4.2 3.9-5.8 4.3"
    />
    <path
      fill="#caa178"
      d="M381.4 323s-1.2 2.5-1.3 5.2c0 2.8 5 3.8 8.1 3.9 3.2 0 3.4-.2 3.4-.2s1.6-10.2 1.1-13.3c0 0-3.4 3.4-6.1 4.2-2.8.7-5.2.1-5.2.1z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-a0)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M111.7 305.1s-2 4.4-2.2 9.1 8.5 6.6 14 6.6c5.4.1 5.7-.2 5.7-.2s2.8-17.6 2-23c0 0-6 6-10.7 7.2-4.7 1.3-8.8.3-8.8.3"
      />
    </g>
    <path
      fill="#caa178"
      d="M391.2 333s-4.7-.2-7.4-.6c-2.7-.5-3.5.5-4 2-.4 1.5-2.3 5.6-3 7-.6 1.3.3 3.6 2 4.6l5.6 2.5s5-8.8 6.8-15.5"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-aZ)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M128.5 322.5s-8-.4-12.7-1.2c-4.7-.7-6 1-6.8 3.6-.8 2.5-4 9.6-5.2 12-1.1 2.3.5 6.2 3.5 7.8s9.5 4.5 9.5 4.5 8.8-15.3 11.7-26.7"
      />
    </g>
    <path
      fill="#caa178"
      d="m382.3 351.9-5.4-4.3c-1-.8-2.6-.8-4 1.5-1.6 2.3-3.9 7.4-4.9 8.7s-1.1 2.8-.2 3.8c1 1 3.1 4.2 3.1 4.2s8.1-8.4 11.4-14z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-bf)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="m113.2 354.9-9.3-7.4c-1.7-1.4-4.5-1.4-7 2.6s-6.5 12.7-8.3 15c-1.7 2.3-2 4.8-.3 6.5 1.7 1.8 5.4 7.1 5.4 7.1s13.8-14.3 19.5-23.8"
      />
    </g>
    <path
      fill="#caa178"
      d="M361.2 367.3c2.1-3.4 3-5.5 4.2-4.8 1.3.7 4.4 4.4 4.4 4.4l-8.3 7.6z"
    />
    <g
      mask="url(#sh-ac_svg__sh-ac-ac-aY)"
      opacity={0.4}
      transform="translate(316.5 145.5)scale(.58162)"
    >
      <path
        fill="#652e11"
        d="M77 381.5c3.6-5.9 5.1-9.6 7.2-8.4a57 57 0 0 1 7.5 7.7l-14.2 13z"
      />
    </g>
    <path
      fill="#c6ac95"
      d="m364.1 362.9-3 4.4-.2-4.6s5.2-6.7 6-8.6c0 0 0 3.9-1.1 5.6-.4.5-.8 1.5-1 2.7-.2 0-.4.2-.7.5"
    />
    <path
      fill="#b28f6b"
      d="M364.1 362.9c.3-.3.5-.5.7-.5-.6 2.5-.7 5.8 1.6 7.8l-4.9 4.3-.4-7.2z"
    />
    <path
      fill="none"
      stroke="#9f8d79"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      d="M384.5 286.2s-4 2.5-6.4.7c-4.2-3-3.5-8.4-3.5-8.4"
    />
    <g fill="#494037">
      <path d="M380.6 260.8c1.3-.2 3 .8 2.2 1.3-.8.6-.9 2.1-2 2-1.1-.3-1.3-1-1.3-2.5 0-1.4 0 0 0 0zm-2.9 2.3s2 2.6 1.2 3.6-2 1.8-2 1c.2-.9-2.4-.3-2-1.7.3-1.4 0 0 0 0zm.7 7.6c-1 .2-1.4.2-1.4-.5 0-.8-1.2-.5-1.2-1.2s1.5 0 2.4-.5c1-.3 2 0 2 .7s.7 1.4-.2 1.4zm-5-2.5s1.1 1 1 1.6c0 .6-2.3 3.2-2.2 2.2 0-1 1.1-3.8 1.1-3.8m9.6-8.9c-.2 1 2.5 1 3.2.4.6-.7 1.9-2.3-.5-2-2.4.4 0 0 0 0zm8.3-2.3c.8.7.2 1.1-.6.8-.7-.3-3.8-.4-2.3-1 1.4-.5 2.9.2 2.9.2m1.7 2.9a3 3 0 0 1-1 3c-1 .8-2 .9-1.9-.4.2-1.3.3-2.2-.6-2.1-.8.1-1.9-1 0-1.1 1.8-.1 3.4-.3 3.5.6m-2.8 4.8c.7-.1 2.4 2.6 1 2.7-1.4 0-2.3-.2-1.8-1 .6-.7 0-1.5.8-1.7m-2.4 1.3c-.2-.6-1.8.2-1.8.8 0 .5-.9 3 1.3 1.7.5-.3.8-1.3.5-2.5m2.8 3.4c-.3.4-1.2 1-1.5 2s-2.3.8-2.3.1-.5-1.9.5-2c.7.3 2-.7 2.8-.9.5 0 .8.5.5.8m-10.7 2.1c-.4-.7-2.7-.4-2.5 1 .2 1.6.5 2.5 1.1 2.4.7 0 .2-1 .2-1.7s1.6-.8 1.2-1.7m-3.3 2.9c-.5.2-1-.2-1-1s-1-.1-1.2-.7c0-.5.5-1.1 1.2-.7.7.5 2 2 1 2.4m-4.4.8s1-.2 1 .3.2 2-.2 1.6c-.4-.3-1-.1-1-.5zm12.4-1.6c.6.7.5.3.8 1s1.7 1 1.5 0c-.1-1.1 1-1.8.2-2-.7-.1-2.6-.8-2.6-.3 0 .4-.7.2 0 1.3zm-1.4-1.3c0 .6-.5 1.2.1 1.8.7.6-1.2 1.6-1.9 1.4-.6-.3-.5-1.2 0-1.3.4-.1-.2-1.8.5-1.8.8 0 1.4-.7 1.3 0zm1.8-2c0 .7-.7.9-1.4.6s-1.4-.7-1-1.5c.3-.8 1-2.3 1.3-1.7.4.6 1 1.7 1.1 2.7zm-3.2-3.9c-1 0-.3 1.5-1.2 1.2s-.7-2-.1-2.2c.5-.1 2.6-.1 2.6.6 0 .6-.6.4-1.3.4m2.6 9.2c.2.4.9 1.2 0 1.5-.8.3-2-.4-1.6-.7.4-.4 1.1-1.3 1.6-.8m-5 0c.7.1.8 1.7.2 1.7s-2-.7-1.5-1c.6-.4.6-.8 1.4-.7zm4 13c-.6.8-2 1-2 .7s.5-1.9 1-1.8c.4 0 1.6.5 1 1.2zm-3.8 1c-.3-.3-1.3-.9-1.7-.7-.4 0-.7 1.6 0 1.6.8 0 2.4-.3 1.7-.8zm3.1 3c0-.7.2-1.1-1-1.1-1 0-.7.7-1.2 1.2s-1 1 .5.5zm-7.8-6c0-.6 1.2-.4 1.1 0 0 .3-1.1.9-1.1 0m-1.4-1.8c-.1-.2-.9-1.2-1-.8-.2.5.3.5.5.8s.6.3.5 0m-2.5-3.4c.8-.3 1.4 1.2.8 1.5-.6.2-2.2 2.2-1.8 1.1m9.5 17c1-2.4 1.7-5 4.7-2.4s3.8 4.9 1.4 5.3c-2.3.4-4.7 1.8-5.5.2s-.6-3-.6-3zm7-5.8c-.4.4-1.1.3-1 1 0 .7-2.4.3-2-1.7.3-2 4.2-.4 3 .7m5.2 4.1c1.8-.3 5-.4 5.4-.2.5.2.3 2.5-1.5 2.6s-5.4-2-3.9-2.4m-.2 3.7c.5 1.7-1 2-2.2 1.2-1.3-.7-2.1-1.7-1.3-2.1.8-.5 3.1-1 3.5.9m-4 9.6s2.7-2.4 3.5-3.4c.9-1 .5-2.6-1.2-2.5-1.6.1-4.4 4.4-4.1 4.6m5 3.2c.2-1.5 2.2-4.4 5.3-5.2 3-.8 1.6.6 1.8-1 .3-1.6 2.2-.2 3 .8s0 1.7-1.7 1.9-5.9 3-6.4 4.6m1-8.3c-.2-1-1.2-2.8-1-3.5s2.4-.6 3.6-1c1.1-.5 2.2.5 2.2 1.5s1.3 1.5 0 2c-1.1.5-4.6 1.7-4.7 1zm5-7.4-.7 2c-.2 1 1.5 1.8 2.2 1.6s3.1 1.4 3.4.5c.2-1-3-2.6-4.9-4.1m6 5.4s-3.3-1.2-3.2.1c.1 1.4.2 3.5 1.3 3.6s2.6.7 3 1.4c.5.7 2.8 1.2 3 0l-4-5.1M389.4 294s-1.8 0-1.4 1.3l.4 1.6c0 .3 1.1-1 2.2-1.6m3.4 2s-.4.3-.8 0c-.3-.4-.4-1.2-1-1-.5.1-.5-.7-.5-.7s1.5.3 2.3 1.6m-4.7 3c-.5 0-2-.3-1.5-1 .4-.6 2.1-.5 2.2 0 0 .4 0 1.1-.7 1m-2.2-3.5c-.6.2-1 .5-.9 1 0 .6.8.6 1.4.6s.1-1.7-.5-1.6m23.2 15.4c-.9-.6-2.5-.3-2.3 1.2a9 9 0 0 0 1.4 4.2c.6.7 2.5.8 2.3-.1zm-5.1-.5c-.5-.7-3.7-1-3 .2.8 1.2 1.1 3 .5 3.2-.6.3-1.5 2-.3 1.6s1.6-1.2 2.7-1.1c1 0 1.5-1.8.1-3.9m4 7c-.5 0-.7 1.3-1.2.8-.5-.6-.6 1.8.4 1.6s.6 1.8 1.3 1.5c.7-.2 1-1.5.4-2-.5-.3-.2-1.8-1-1.8zm-1.8-2.2c-.2.6-1 1.8-1.8 1.9-.9 0-4-.5-2.6-.8s2.1-1.7 3.2-1.6c0 0 1.8-.8 1.2.5" />
      <path d="M401.1 312.3c.8.8 0 2.8-1 3s-.8 1.5 0 1.6c.9 0 2 2.6 2 2.7 0 .2-1.3 2.6-2.2 2.8-.9.3-2.4 1.2-2.8.2l-1.7-4.4-1.5-1.6s.9-1.8 2.6-2.8 4.2-2 4.6-1.5m5.8 8.3c0 1.2-.6 2.3-2.4 2.3s-2.7-2.8-.1-3c2.6 0 2.6 0 2.5.7m-4.5 2.4c1-1 .9 2.8-.5 3s-1.4 2.1-2 .9c-.8-1.2-2.7-3-.3-3.5 2.4-.3 2 .3 2.8-.4m-.4 3.9c-.5.3-2 1.6-1.7 2.4.3.7.4 3.3 1 3.2.5 0 2.2.2 2-1.5s-.6-4.5-1.3-4.1m1.5 7.1c-.3-.8-3-.5-3-.5l-.6 1.9s-.5 1.6-.5 2.2 1.6 1 2.2.6c.6-.5 1.4-1.7 1.5-2.4.2-.8.8-.6.4-1.8m-4.6 7c.3-1.2 2-1.5 2.9-1 .8.4.5.8 0 2.1-.4 1.3-1 3.5-2 2.7-.8-.8-1.2-2-.9-3.7zm6.6 8.8c-.8.6-3 .2-2.8-2 .2-2 2.4-4.8 4-5.7 1.4-1 3.3.5 3 1zm7.3-12.2-2.3 4.3s-1.8-1.6-1-2.6" />
      <path d="M409.6 339.3c.8-1-.5-2.7.6-2.8s2.7.8 2.6 1.1m-.3-5.2c0 1.3-.2 2.6-1.7 2.3-1.5-.4-.8-1.6-1-3.4-.4-1.7.4-1.8 1.2-2 .8-.3 1.7-.3 1.8.6s-.4.6-.3 2.5m-1.3-7.2c.2 1.3.7 2-.8 2.2-1.5.3-1.7.5-1.8-1s-1.6-1.2-1.3-.5c.2.8.1 2-1 1.9-1.3-.1-4-1.1-2.7-2.3a6 6 0 0 1 5-1.7c2.3.3 2.6 1.4 2.6 1.4m-3.8 3.1c1 .1 1.1 3 1.1 3.8 0 .7-.2 2-1.5 2-1.4 0-2.4-.2-2.5-2.3s.5-3.7 3-3.5zm0 8.3c0 .5-.3 2.1-1 2.9-.6.7-2 1-2.3 1-.4 0-1.2-1.2-1-1.8.3-.7 1.9-1.8 2.1-2.7.3-.8 2.4-.7 2.3.6z" />
    </g>
    <g fill="none" stroke="#9f8d79" strokeMiterlimit={10} strokeWidth={0.6}>
      <path d="M374.5 275.1s-.4 5.7 1.6 6l5.2.9c1.5.2 3.5-2.5 4-3.4.3-1 1.3-.8 2.9-3.6m-9.1 35s1.6 1.7 3.5 2c1.9.4 2.8-.8 2.8-.8m-6.4 1.3s3.2 3 5.7 2.8c2.5 0 3-2.5 3-2.5" />
      <path d="m378.8 315.6 2.4 1.3c.8.5 1.7 1.1 4.2 1 2.3-.1 4.5-2.3 6.2-2.9" />
      <path d="M394.1 316.5s-2 .8-3.4 2.3-7.5 4.2-12.3.2m4-9.9-1.8-1.2m-.3 1s.7-.2 1.5-.2" />
    </g>
    <path
      fill="#494037"
      d="M386 307.6c-1.4.5-1.3 3-2.4 2.3-1.1-.8-2.2-1.8-2-2.8.3-1 2.9-2.6 4.2-2.2 1.4.4 1 2.4.2 2.7"
    />
    <g fill="none" strokeMiterlimit={10} strokeWidth={0.6}>
      <g stroke="#af6d4a">
        <path d="M357.4 289.1s3.3 2 3.5 2.4c.3.5.5 5.8.4 6s-1.2 3-1.6 3.1c-.3.2-7 4.1-7.5 4.2-.5 0-3.7-.2-4.2-.4-.4-.1-2.8-2-2.8-2m13.5-14.5s2.4 2.4 3.4 2.6c1 .1 7.3-.8 7.6-1.2.4-.4-2.2-3-6.1-4.5m7.6 6-7.2.8c-.6 0-1 2.9-1 5l.3 4.3 9.4 3c.4.1 1.8-4.1 1.6-7.5-.2-3.3-2.5-5.7-3-5.6zm-28.1 14.9 5.8.5c1 .1 1.5.8 1.5 1.8.1 1 1 9 1.2 9.8s.1 1.7-1.2 3c-1.4 1.2-4 3.1-4.7 3.5s-2.6 1-5 .2l-6.7-2m21.6-.1c-.9-.4-2.3-1-3.7.2a46.5 46.5 0 0 0-5.2 6.2c-.4.6-.4 1.2-.3 2.2.2 1 .6 6.3.9 7.5.2 1.1.6 3.1 3.1 4.2 2.5 1 8.6 4.5 10.8.3 2.3-4.2 6.3-13.6 6.6-14.6.4-.9 0-1.5-2-2.1zm-6 22c-1.9-.9-4.3-1.4-5.3.6s-4.4 8.2-5.5 9.6c-1 1.4-1.6 6.2-.1 7.5 1.4 1.3 6.4 4.6 7.3 5 .8.4 3.5 0 4.3-2s6.6-11.2 8.2-12.6c1.6-1.3 1.6-4.4-1.1-5.1a84 84 0 0 1-7.8-3zM339 366.6c-1.1-.5-1.5-.8-2.4 0-.8 1-7.9 7-9 7.8-1.3.8-1.3 1.4-1.2 2.7 0 1.4-.7 9.1-.6 10.8 0 1.6 0 2.1 1.8.5s12-11.4 12.8-13c1-1.6 4.2-7.3 2.6-7.6s-2.6-.7-4-1.2zm-15.3 6.4s2.5-.2 3-.9c.5-.6 6.3-5.5 7.2-6.3 1-.8 1.7-1.4 1.7-2l.1-5.5c.2-1-1.1-1-2.3-1-1.1 0-8.5.5-8.5 1m0-1.7 9.2-.4c1.1-.1 1.6-1.1 2.5-2.9l2.3-4c.3-.6-.4-1.3-1.3-1.6a38 38 0 0 1-10.5-5.2m.9-3.3a19.4 19.4 0 0 0 10.6 6.1c.8.2 2.2.3 3-.7.9-1 2.3-2.5 2.8-2.8s0-1.8-.2-3c0-1.2-1-10.2-1-11 .1-.9-.8-1-1.8-1.3s-7.5-2.7-8-2.6" />
        <path d="M368.6 284.7c-.4.5-1.2 1.3 1.9 2.6 2.8 1 6.2 6.1 6.3 8.3.2 2.2-1.2 6.8-1.4 8.1-.1 1.4-.7 2.6 3 3m-15-4.2c-.7-.2-2-.3-3 .2l-5 3c-.7.1-1.7 2.4-1.7 2.4s-.5 1.5-.4 2.7c0 1.2.2 6.4.4 6.9a11 11 0 0 0 3.4 3c1.6 1 7.8 3 9.1 3.3 1.3.2 2.6-1.3 2.6-2.7s1-6.5 1.5-8c.4-1.6 2.5-8 .3-8.7-2.1-.8-7.2-2-7.2-2zm2.1 38.3c.8-3 4.7-10.4 5-11.7.3-1.4.8-1.7 1.4-1.5l3.1.9c-.3 2.4-.6 4.5-1 6.2-.8 2.7-5 7.6-5.6 8.9l-1 2-1.3-.4c-1.7-.6-1.4-1.4-.6-4.4zm5.2-18.6c.3-1.9 3.6-10.6 3.8-12.3.1-1.6 1-2.1 2-1.9a76 76 0 0 1 1.8.6c-1 5.2-2.4 12.4-2.8 15.3l-.2 2.3c-4.9-1.5-4.8-2.2-4.6-4zm-18.9 43c-.1-1.4 5-6.7 6.9-9a19 19 0 0 0 4-7.7c.3-1.9.6-1.9 1.7-1.5l2 .7a88 88 0 0 1-5.8 10.4c-1.2 1.6-4.3 5.5-7.8 9.6-1-1-.9-1.5-1-2.5zm-25.7 28c-.3-.3 6.1-6 8.9-8.6a88 88 0 0 0 10.2-12.5c.8-1.8 1.6-1 2.4-.8l1.6.8c-3.4 4-6.4 7.6-7.5 8.7-2 2.1-10.7 11.4-14.5 13.7-.8-.6-1-1-1.1-1.2z" />
      </g>
      <path
        stroke="#000"
        d="M379.2 303c-.2 3-3.2 16.7-3.7 20.9-.5 4.1-.8 8.1-1.6 10.8-.7 2.7-4.8 7.6-5.5 8.9s-5.1 10.9-7.8 14.5-16.4 20-18.9 22.7c-2.5 2.6-15.3 16.4-16.3 13.9"
      />
      <path
        stroke="#b49578"
        d="M381.4 323s-1.2 2.5-1.3 5.2c0 2.8 5 3.8 8.1 3.9 3.2 0 3.4-.2 3.4-.2m0 1s-5-.1-7.8-.5c-2.7-.5-3.5.5-4 2-.4 1.5-2.3 5.6-3 7-.6 1.3.3 3.6 2 4.6l5.6 2.5m-2.1 3.4-5.4-4.3c-1-.8-2.6-.8-4 1.5-1.6 2.3-3.9 7.4-4.9 8.7s-1.1 2.8-.2 3.8c1 1 3.3 4.5 3.3 4.5m-1.3.8s-3.1-3.7-4.4-4.4c-1.2-.7-2 1.4-4.2 4.8"
      />
    </g>
    <path
      fill="#494037"
      d="M356.2 368.6c1.2-.6 2.9-.4 2.2.8-.6 1.2-2.7 3-3.6 3.1-1 0-1.1-.7-.8-1zm2.5 2.9c1 .1 1.1 4.3.7 5-.5.9-1.3 1.7-2.1.2s-1.6-2.6-1-3.4c.8-.8 2-1.9 2.4-1.8m3 5.9c-.2-.8.1-4-1-2.7-1.2 1.4-.2 4-1 4.3-.9.3-2.4 1.3-.8 2 1.5.8 2.4 2.2 2.5 1.3.2-.9.3-5 .3-5zm-1.9 6.3c0 1-.5 4.1-1.1 5-.6 1-2.1 1.6-2.3.2-.2-1.5-.4-3-1-3.3-.7-.3.3-1.3 1.9-2.2s2.6-.6 2.5.3m-3 7.6c.1 1-1.8 1.3-1.7 2.3 0 1-.4 3-1.3 2.5-.9-.6-1.2-2.3-1.2-2.8s.1-2.3 1.4-2.8c1.3-.6 2.6-.9 2.8.8m-4 5c.6.2.9 3.2.1 3.8-.7.6-2.3 1.3-2.2-.1.2-1.5-.9-1.6-.9-2.2 0-.7 1-2.2 3-1.6zm-.1-6.1c.5.8-.5 2.1-1 2.7-.6.6-1 1.3-1.8.4-.7-.8-1.9-2.2-.5-3.2 1.3-1 2.6-1.1 3.3 0zm-1.5-6.2c.4 1 1.5 2.8 1 3.2-.5.5-.9 1.2-1.9 1.2s-2.9-1.3-3.2-1.8 1.6-2.2 2.2-3c.7-.8 1.3-1 1.9.4m-2.6 4.6c.6.4-.8 1.5-.7 2.3 0 .9 0 1.7-1.6.8s-3.3-1.6-2.2-2.9 2.4-1 3-1c.7.1 1.2.6 1.5.8m-5.3 3.5c0-.4.6-.4 1.5.7 1 1 3.3 2 2 2.3-1.3.5-2 1.2-2 1.8 0 .5-1 1.9-1.5 1.4-.6-.6-2-.3-2-.3s2-4.4 2-6z"
    />
    <path
      fill="#494037"
      d="M348.1 394.5c.5-.7 1-1.6 1.3-.3.3 1.2.7 2.2.4 2.6-.4.4-1.6.9-1.5 1.4.1.4-2 1.1-2.2 0a4 4 0 0 1 .5-2.3c.2-.3 1-.6 1.5-1.4m1.8 5.1c1 1 1 2.5 1 3.4 0 1 0 2.6-.6 3.2-.7.7-2.1 2.6-4 2.7-2 .1-2.3-.6-1.5-2.1.8-1.6 4-8.2 5.1-7.2m-1 10.9s-2.1-.5-3 .1c-1 .6-1.3 1.5-2 1.9-.5.4-.8 1.4.8.6 1.6-.7 4.3-2.6 4.3-2.6zm-8.2-10c.7-1 1.1-1 2.5-1 1.5.1 2.9-1 3 .3s-1.6 3.2-1.6 4c.1.8-1.1 2.3-1 3 0 .9-1.1 1-1.8.5-.7-.4-1.7-.1-1.6-1.6zm-1.2 8.4c1-.3 2.4-.4 3-.1.5.2.8 1.3 0 2.3-.7 1-1.6-.6-2-.7-.5-.2-1.9-1.2-1-1.5m16.2-32.1c-.1 1-2.8 3-3.1 1.7-.4-1.2-1.6-2.5-.7-3.5 1-1 2.7-2 3-1.2.2.9.9 2.5.8 3m1 2c.2.8.6 1.7.6 2.2s-1.3 1.6-1.7 1.7c-.4.2-2.3 3.1-2.6 2.5-.4-.7-1.5-4.4-.7-4.7.7-.3 4.2-2.5 4.4-1.8zm-7-2.2s1.4.2 1.5 1.2.4 1.8-.6 2.8c-1 1.1-2.8 2.3-3.4 1.7-.7-.6-1.5-1.7-1.5-1.7zm-3.9 5.7c1.5 0 2 1 1.1 1.4-.8.6-1.8 1.5-2.1 2.2s-1.4.3-1.4-1.2a2.5 2.5 0 0 1 2.4-2.4m15.8 18c0-1.5.2-4.7 1.2-2.8 1 1.8-1.5 6-1.2 2.8m4.1-5c0 1-1 1.8-2 .4-1-1.3.8-.4.9-1.5 0-1 1.1.2 1.1 1.2zm.7-4c.6-1 0-3-1-2.7-.8.3-1.8 2-1.1 1.9.6 0 1.3 2.4 2.1.9zm-3.3 0c0 .7.4 2.5-.5 2.5-.8 0-1.9-1.2-1.3-2.3.6-1.2 1.8-1 1.8-.1zm3-11c-.3 1.4-1.8 1.2-1.7 2.3 0 1.1.6 4-.6 2.8a5.2 5.2 0 0 1-1.2-4.2c.2-.8.1-2.3 1-2.4.9 0 2.8-.3 2.5 1.6zm1.8 3.4s-1.4-1.7-1.6-.4-1.3 2.6-1.1 3c.2.5 3 1.9 2.8.4z"
    />
    <g fill="none" stroke="#000" strokeMiterlimit={10} strokeWidth={0.6}>
      <path d="M388.2 275s2.3-3.9 3.1-4.7c.9-.7 1.6-4 1.7-5 .4-3.7 5.2-5 4.1-5.7 0 0-6.2-4.6-11.5-1.9-5.3 2.8-13.4 8.6-13.4 14.3.2 8-2.7 13-2.7 13" />
      <path d="M385.8 285.3s8.3-8.3 8.6-11.8c.3-3.8 3-11.4 1.4-12.3" />
      <path d="M386.9 284.1s1.2 4.9.4 7.5l1.2 2" />
      <path d="M380.4 293.5s3.3-2.3 7.4-.3c2.8 1.3 3 2.2 3 2.2s3 .4 3.3 2c.4 1.4 3.3.9 7.5 4.7 4.3 4 6 8 8 9 1.8 1 3 10.6 3 14.1-.2 3.6 1.2 10 .2 12.4a131 131 0 0 1-7.3 12.2c-1 1.4-4.6.5-6-4-1.5-4.3 0-6.2 0-8.2-.2-2 1.5-3 .7-5.6-.8-2.7-3.9-12-4.5-13.4a13 13 0 0 0-5-4.1c-1.8-.8-8.2-5.4-8.2-5.4m-3.3-12.8c-.1-2.4-4.7-9.4-7.2-10.4s-5.9-2.6-9.7-.6a81 81 0 0 0-15.8 15.3c-3 4-10.4 15.4-15.2 28.6a84.7 84.7 0 0 0-6.4 27.9c0 5.8-2 8.4-1.2 16.8 1 8.4-.4 15.6 1.1 19.6s6 1.6 8.5-.8c2.4-2.4 17.3-16.5 19.3-19.4 2-2.8 8.1-10 11.7-15.5 3.6-5.4 5.2-10.3 6.7-12.5s3-2.7 5.1-7.6c2.2-4.8.6-10.6.9-11.7.2-1.1 2.7-6.2 2.2-29.7z" />
      <path d="M395 317.7c-1.4-1.3-3.9 2.9-7.5 4.6-4 2-9.5.4-9.2-2.1" />
      <path d="M392.7 318.4c.5 6 1 28.9-31.2 56.1" />
      <path d="M360.9 362.7c.4 8.4 2.8 21.9-3.2 33.2a64 64 0 0 1-8.7 14.6 16.7 16.7 0 0 1-8 3.8c-2.3 0-2.3-4-2.4-5 0-.9 1.9-2.4 1.7-5.2a22 22 0 0 1 2.5-9.9c1.5-2.4-.8-6.5 1-11.6" />
    </g>
    <path d="M385.6 261.8c-1 .8-1 1.4-.8 2.8.1.7 2 0 3-1s1.8-2.2 1-2.3-2-.3-3.2.5" />
    <path
      fill="#fff"
      d="M387 262.5c0 .2 0 .5.3.6.3 0 .6-.1.7-.3 0-.3-.1-.5-.4-.6-.2 0-.5 0-.6.3"
    />
    <g fill="none" stroke="#000" strokeMiterlimit={10}>
      <path
        strokeWidth={0.6}
        d="M365.9 370.7s3 11.7 1.9 21.9c-1 10.1-4.2 13.4-5 14.5s-1.6 0-2.8-.8c-1.1-.8-5.9-3.7-5.5-4.4"
      />
      <path
        strokeWidth={1.2}
        d="M325 357a82.2 82.2 0 0 1 6.3-27.8 126.2 126.2 0 0 1 15.2-28.6c3-4 12-13.3 15.8-15.3 2.7-1.4 5.1-1 7.2-.3 0 0 3-5 2.7-13 0-5.7 8.1-11.5 13.4-14.3 5.3-2.7 11.5 1.9 11.5 1.9.6.3 0 1-1.1 1.8 1.6.9-1.3 8.3-1.6 12-.2 2.8-5.3 8.3-7.5 10.7l.5 3.3.6 3.1c2.4-2.5 11.2-11.3 18-12.6 8.1-1.6 13.2-.2 15.6 1.7 2.1 1.8 8.5 6.8 10.7 11.3h-12a9.8 9.8 0 0 0-7-2c-7 .3-8.2 2.8-7.7 3.4.4.6.6 2.5-2.1 3.8a9 9 0 0 0-4 4.3c.6.5 1.4 1 2.1 1.7 4.3 4 6 8 8 9 1.8 1 3 10.6 3 14.1-.2 3.6 1.2 10 .2 12.4a131 131 0 0 1-7.3 12.2c-1 1.4-4.6.5-6-4-1.5-4.3 0-6.2 0-8.2-.2-2 1.5-3 .7-5.6-.8-2.7-3.9-12-4.5-13.4l-.7-.9-1.8.3-.5.4c.5 5.8 1 26.8-26.8 52.3 0 0 3 11.8 1.9 21.9-1 10.1-4.2 13.4-5 14.5s-1.6 0-2.8-.8c-1.1-.8-5.9-3.7-5.5-4.4a36.6 36.6 0 0 1-5.5 8.6 16.7 16.7 0 0 1-8 3.8c-2.3 0-2.3-4-2.4-5 0-.9 1.9-2.4 1.7-5.2a22 22 0 0 1 2.5-9.9c1.5-2.4-.8-6.5 1-11.6l-10.5 10c-2 2.1-5.7 4.2-7.6 2.3a.4.4 0 0 1-.3-.2 4 4 0 0 1-.6-1.2c-1.5-4-.1-11.2-1-19.6-1-8.4 1.1-11 1.1-16.8z"
      />
    </g>
    <path fill="#012169" d="M0 0h320v240H0Z" />
    <path
      fill="#fff"
      d="m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    />
    <path
      fill="#c8102e"
      d="M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    />
    <path fill="#fff" d="M120.5 0v240h80V0ZM0 80v80h320V80Z" />
    <path fill="#c8102e" d="M0 96.5v48h320v-48zM136.5 0v240h48V0Z" />
  </ChakraIcon>
);
